import { React, useEffect, useState, useRef, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import upgrade from "../../../Assets/Icons/up-range.svg";
import downgrade from "../../../Assets/Icons/down-range.svg";
import {
  RightLayoutContainer,
  PageTitleComp,
  DetailFields,
  ResultWrap1,
  TableLayoutData,
  ContentMiddle,
  SolutionContainer,
  //   PipeDesign,
} from "../../styledElements";
import {
  Button,
  PageHeader,
  Tabs,
  Row,
  Col,
  Table,
  Tooltip,
  Progress,
} from "antd";
import { Styled, RadioButtonStyle } from "../../pageStyled";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertBlue from "../../../Assets/Icons/alertBlue.svg";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import Iconmoon from "../../../Components/IconsFiles/icon";
import warning from "../../../Assets/Icons/warning.png";
import { ModalPopup } from "../../../Components/Modal/modal";
import { TableList, RightSideSolution } from "../../pageStyled";
import TableShimmer from "../../../Components/TableShimmer/tableShimmer";
// import { HaberForm } from "../../styledElements";
import {
  getFailedGroups,
  // getJobCardCylinders,
  getJobCardsById,
  getJobCardsDetails,
  putSolutionStatus,
  cancelJobCard,
  getAlgorithmCompletionStatus,
  getIntermediateList,
  createNewSolution,
  readyJobCardSinglestageNewSolution,
  unselectGrpOfAcceptedJobcards,
} from "../../../Services/deckleMatchServices";
import { getOrdersList } from "../../../Services/orderServices";
import moment from "moment";
import JobCardCylinderContainer from "../../../Components/JobCardCylinders/JobCardCylinderContainer";
import IcoMoon from "react-icomoon";
import deckleCover from "../../../Assets/Images/deckle-match-result-cover.svg";
import warningjob from "../../../Assets/Icons/warningjob.svg";
import vectorIco from "../../../Assets/Icons/vectorIco.svg";
import alerttrue from "../../../Assets/Icons/alerttrue.svg";
import wrongIco from "../../../Assets/Icons/wrongIco.svg";
import failedIco from "../../../Assets/Icons/failedIco.svg";
import greaterRange from "../../../Assets/Icons/up-range.svg";
import lowerRange from "../../../Assets/Icons/down-range.svg";
import { getStockSizesDetailsByIds } from "../../../Services/productServices";
import ViewDeckleOrder from "../DeckleOrderDrawer/viewDeckleOrder";
import { getFormObject, setFormObject } from "../../../Services/formServices";
import { useInterval } from "../../../Utils/polling/pollingConfig";
import CreateNewSolution from "../DeckleResults/createNewSolution";
import JobcardPrepare from "../../../Components/IconsFiles/preparing_job_card";
import LottieAnimation from "../../../Lottie";
import {
  CoversionFactorCMToUnits,
  CoversionFactorUnitsToCM,
  lengthUnit,
  weightUnit,
} from "../../../Utils/Constant/MeasurementUnitList";
import JobcardDetailsMultistage from "../JobCards/jobCardDetailsMultistage";
import JobCardDataContext from "../../../ContextApi/JobCardDataContext";
import { toHandlePOName } from "../../../Utils/helper/helper";
import CreateNewSolCompare from "./CreateNewSolCompare";

const gridViewData = [
  {
    label: <Iconmoon icon="grid-chart" size={20} color="#EA655B" />,
    value: "grid",
  },
  { label: <Iconmoon icon="table" size={20} color="#EA655B" />, value: "list" },
];

const { TabPane } = Tabs;
const Panes = Tabs.TabPane;
const DeckleResultsData = (props) => {
  const stopCancellApi = useRef(false);
  const {
    stopCancelled,
    setStopCancelled,
    handleResetAll,
    handleBackPathForJC,
    acceptedJCGrpCode,
    setAcceptedJCGrpCode,
    removeGrpsFromOrderSummary,
  } = useContext(JobCardDataContext);
  const [isAcceptModal, setIsAcceptModal] = useState(false);
  const [isDiscardModal, setIsDiscardModal] = useState(false);
  const location = useLocation();
  const isReplanMode =
    location?.state?.type === "replan" && location?.state?.parentJCid != null;
  const getReplanParentJobcardId = () => {
    if (!isReplanMode) return null;
    const id = parseInt(location.state.parentJCid, 10);
    return Number.isFinite(id) ? id : null;
  };
  /** In replan mode always use `location.state.parentJCid` as the mapping parent key. */
  const getNewSolutionParentJobcardId = (jobCardId) =>
    getReplanParentJobcardId() ?? jobCardId;
  const [isGoBack, setIsGoBack] = useState(false);
  const [ordersIdListByJobCard, setOrdersIdListByJobCard] = useState({});
  const [paperMachineFormValues, setPaperMachineFormValues] =
    useState(getFormObject());
  const [formValuesForStock, setFormValuesForStock] = useState({});
  const [jobcardIds, setJobcardIds] = useState(
    location.state?.jobCards.jobcards,
  );
  const [unselectedOrders, setUnselectedOrders] = useState([]);
  const [products, setProducts] = useState();
  const [failedGroups, setFailedGroups] = useState(
    location.state?.jobCards.failed_groups,
  );
  const [totalGroups, setTotalGroups] = useState(
    location.state?.jobCards.total_groups,
  );
  const [isLoading, setIsLoading] = useState(
    // location.state?.jobCards?.failed_groups?.length ? true : false
    false,
  );
  const isCancelJobCard = useRef(true);
  const [fetchFailed, setFetchFailed] = useState(false);
  const [jobIndex, setJobIndex] = useState(0);
  const [failedjobIndex, setFailedjobIndex] = useState(0);
  const [isFetchingData, setIsFetchingData] = useState(false);
  const [jobCardDetailsList, setJobCardDetailsList] = useState([]);
  const [solutionId, setSolutionId] = useState("1");
  const [failedJobs, setFailedJobs] = useState();
  const [sizeDetailsList1, setsizeDetailsList1] = useState();
  const [sizeDetailsList2, setsizeDetailsList2] = useState();
  const [newSolSizeList1, setNewSolSizeList1] = useState();
  const [newSolSizeList2, setNewSolSizeList2] = useState();
  const [orderDetailsList1, setOrderDetailsList1] = useState();
  const [orderDetailsList2, setOrderDetailsList2] = useState();
  const [stockSizeDetailsList1, setStockSizeDetailsList1] = useState();
  const [stockSizeDetailsList2, setStockSizeDetailsList2] = useState();
  const [failedJobOrders, setFailedJobOrders] = useState();
  // Avoid refetch toggles; use idempotent fetch when ids change.
  const [viewOrder, setViewOrder] = useState(false);
  const [selectedOrderNo, setSelectedOrderNo] = useState();
  const [selectedOrder, setSelectedOrder] = useState();
  const [intermediateData1, setIntermediateData1] = useState([]);
  const [intermediateData2, setIntermediateData2] = useState([]);
  const [intermediateNewSolutionData1, setIntermediateNewSolutionData1] =
    useState([]);
  const [intermediateNewSolutionData2, setIntermediateNewSolutionData2] =
    useState([]);
  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("user-details")),
  );
  const [createNewSolutionClicked, setCreateNewSolutionClicked] = useState({
    isClicked: false,
    index: -1,
  });
  // Avoid forced rerenders; keep updates immutable instead.
  const [stockSizesByJobCard, setStockSizesByJobCard] = useState({});
  const [
    createNewSolutionFormValuesByJobCard,
    setCreateNewSolutionFormValuesByJobCard,
  ] = useState({});
  // const [showAimation, setShowAimation] = useState(false);
  const [showAimation, setShowAimation] = useState({});
  const [solId, setSolId] = useState("compare");
  const [optimizePartition, setOptimizePartition] = useState(false);
  const [minimizeOverfulfillment, setMinimizeOverfulfillment] = useState(false);
  const [activeKey, setActiveKey1] = useState(0);
  const matchTrimLossKey = "match_trim_loss_%_(a-b)";
  const matchFulfilmentKey = "requirement_fulfilled_%_(a-b)";
  const [acceptSolCounter, setAcceptSolCounter] = useState(false);
  const [isUnfulfilledTab, setIsUnfulfilledTab] = useState(false);
  const [totalFulfilledOrders, setTotalFulfilledOrders] = useState(0);
  const [totalUnfulfilledOrders, setTotalUnfulfilledOrders] = useState(0);
  const [sizeExpanded, setSizeExpanded] = useState(false);
  // const [sizeExpanded, setSizeExpanded] = useState(false);
  // const [sizeExpanded, setSizeExpanded] = useState(false);
  // const [sizeExpanded, setSizeExpanded] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [rerender, setRerender] = useState(false);

  const handleOptimizePartitionChange = (isChecked) => {
    setOptimizePartition(isChecked);
  };
  const handleMinimizeOverfulfillmentChange = (isChecked) => {
    setMinimizeOverfulfillment(isChecked);
  };
  const [failedNewSol, setFailedNewSol] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [activeJC, setActiveJC] = useState();
  const [jobcardIdsWithCode, setJobcardIdsWithCode] = useState([]);
  const [renderKey, setRenderKey] = useState(false);
  const [visibleToaster, setVisibleToaster] = useState(false);
  const [actionToaster, setActionToaster] = useState({
    error: "",
    msg: "",
  });
  const [compareSolSummaryData, setCompareSolSummaryData] = useState({});
  const [newCompareSolSummaryData, setNewCompareSolSummaryData] = useState({});
  const currentActiveJC = useRef();
  const [isNewSolutionPolling, setIsNewSolutionPolling] = useState(false);
  const newSolutionMappingRef = useRef({});
  const newSolutionPollingInFlightRef = useRef(false);
  const newSolutionPollingActiveRef = useRef(false);
  const newSolutionPendingParentsRef = useRef(new Set());
  const newSolutionAppliedNewIdsByParentRef = useRef({});
  const newSolutionAnimationIndexByParentRef = useRef({});
  const newSolutionBaselineNewIdByParentRef = useRef({});
  const jobCardDetailsListRef = useRef([]);
  const jobCardsDetailsFetchInFlightRef = useRef(false);
  const lastFetchedJobcardsKeyRef = useRef("");

  /** Keeps a ref in sync with job card list for polling callbacks without stale closures. */
  useEffect(() => {
    jobCardDetailsListRef.current = jobCardDetailsList;
  }, [jobCardDetailsList]);

  /**
   * Fetches job card details for a given set of ids, but skips if we already fetched
   * the same ids (or if an in-flight request is ongoing).
   */
  const fetchJobcardDetailsIfNeeded = (ids) => {
    const normalized = (ids || [])
      .map((x) => parseInt(x, 10))
      .filter((x) => Number.isFinite(x))
      .sort((a, b) => a - b);
    const key = normalized.join(",");
    if (!key) return;
    if (jobCardsDetailsFetchInFlightRef.current) return;
    if (lastFetchedJobcardsKeyRef.current === key) return;

    jobCardsDetailsFetchInFlightRef.current = true;
    lastFetchedJobcardsKeyRef.current = key;
    getJobCardsListDetails(normalized);
  };

  /** Normalizes API `jobcard_output_mapping` keys/values to numeric parent id → new id(s). */
  const normalizeJobcardOutputMapping = (mapping) => {
    if (!mapping || typeof mapping !== "object") return {};
    const out = {};
    for (const [k, v] of Object.entries(mapping)) {
      const parentId = parseInt(k, 10);
      if (!Number.isFinite(parentId)) continue;
      if (Array.isArray(v)) {
        const ids = v
          .map((x) => parseInt(x, 10))
          .filter((x) => Number.isFinite(x));
        if (ids.length) out[parentId] = ids;
      } else {
        const newId = parseInt(v, 10);
        if (Number.isFinite(newId)) out[parentId] = newId;
      }
    }
    return out;
  };

  /** Clears cached ready-mapping for a parent so a new-solution-on-new-solution poll waits for a fresh id. */
  const resetNewSolutionPollStateForParent = (parentId, baselineNewId, animIndex) => {
    const nextMap = { ...(newSolutionMappingRef.current || {}) };
    delete nextMap[parentId];
    newSolutionMappingRef.current = nextMap;

    newSolutionAppliedNewIdsByParentRef.current = {
      ...(newSolutionAppliedNewIdsByParentRef.current || {}),
      [parentId]: [],
    };
    newSolutionBaselineNewIdByParentRef.current = {
      ...(newSolutionBaselineNewIdByParentRef.current || {}),
      [parentId]: baselineNewId ?? null,
    };
    newSolutionAnimationIndexByParentRef.current = {
      ...(newSolutionAnimationIndexByParentRef.current || {}),
      [parentId]: animIndex,
    };
  };

  /** Merges a new poll snapshot into `newSolutionMappingRef` (supports scalar or array per parent). */
  const mergeNewSolutionMapping = (nextMapping) => {
    const normalized = normalizeJobcardOutputMapping(nextMapping);
    const prev = newSolutionMappingRef.current || {};
    const merged = { ...prev };
    for (const [parentIdStr, newVal] of Object.entries(normalized)) {
      const parentId = parseInt(parentIdStr, 10);
      const prevVal = merged[parentId];
      if (Array.isArray(prevVal) || Array.isArray(newVal)) {
        const prevArr = Array.isArray(prevVal)
          ? prevVal
          : prevVal !== undefined
            ? [prevVal]
            : [];
        const newArr = Array.isArray(newVal) ? newVal : [newVal];
        merged[parentId] = Array.from(new Set([...prevArr, ...newArr]));
      } else {
        merged[parentId] = newVal;
      }
    }
    newSolutionMappingRef.current = merged;
  };

  /** Stops loading animation for one parent and clears it from the pending set; stops polling when empty. */
  const markParentResolved = (parentId) => {
    const list = jobCardDetailsListRef.current || [];
    const animIdx = newSolutionAnimationIndexByParentRef.current?.[parentId];
    let idx = Number.isFinite(animIdx)
      ? animIdx
      : list.findIndex((x) => x?.id === parentId);
    const replanParentId = getReplanParentJobcardId();
    if (idx === -1 && replanParentId != null && parentId === replanParentId && list.length > 0) {
      idx = 0;
    }
    if (idx !== -1) {
      setShowAimation((prev) => ({ ...prev, [idx]: false }));
    }
    const nextAnim = { ...(newSolutionAnimationIndexByParentRef.current || {}) };
    delete nextAnim[parentId];
    newSolutionAnimationIndexByParentRef.current = nextAnim;

    const nextPending = new Set(newSolutionPendingParentsRef.current || []);
    nextPending.delete(parentId);
    newSolutionPendingParentsRef.current = nextPending;
    if (nextPending.size === 0) {
      newSolutionPollingActiveRef.current = false;
      setIsNewSolutionPolling(false);
    }
  };

  /**
   * Polls GET `/jobcards/new-solution/?ready` while parents are pending.
   * Batches detail fetches and merges new job cards per parent; stops per-parent animation when data arrives.
   */
  const pollReadyNewSolutionOnce = async () => {
    if (!newSolutionPollingActiveRef.current) return;
    if (newSolutionPollingInFlightRef.current) return;
    if (stopCancellApi?.current) return;

    const pendingParents = newSolutionPendingParentsRef.current;
    if (!pendingParents || pendingParents.size === 0) {
      newSolutionPollingActiveRef.current = false;
      setIsNewSolutionPolling(false);
      return;
    }

    newSolutionPollingInFlightRef.current = true;
    try {
      const res = await readyJobCardSinglestageNewSolution();
      if (res?.jobcard_output_mapping) {
        mergeNewSolutionMapping(res.jobcard_output_mapping);
      }

      const mapping = newSolutionMappingRef.current || {};
      const replanParentId = getReplanParentJobcardId();
      let parentsToApply;
      if (replanParentId != null) {
        parentsToApply = Object.prototype.hasOwnProperty.call(mapping, replanParentId)
          ? [replanParentId]
          : [];
      } else {
        parentsToApply = Array.from(pendingParents).filter((pid) =>
          Object.prototype.hasOwnProperty.call(mapping, pid)
        );
      }
      if (!parentsToApply.length) return;

      const idsToFetchByParent = {};
      const allIdsToFetch = [];
      for (const parentId of parentsToApply) {
        const newVal = mapping[parentId];
        const newIds = (Array.isArray(newVal) ? newVal : [newVal])
          .map((x) => parseInt(x, 10))
          .filter((x) => Number.isFinite(x));
        if (!newIds.length) continue;

        const baselineId = parseInt(
          newSolutionBaselineNewIdByParentRef.current?.[parentId],
          10
        );
        const freshNewIds = Number.isFinite(baselineId)
          ? newIds.filter((id) => id !== baselineId)
          : newIds;
        if (!freshNewIds.length) continue;

        const latestNewId = freshNewIds[freshNewIds.length - 1];
        const alreadyApplied = new Set(
          (newSolutionAppliedNewIdsByParentRef.current?.[parentId] || []).map((x) =>
            parseInt(x, 10)
          )
        );
        if (alreadyApplied.has(latestNewId)) continue;

        idsToFetchByParent[parentId] = [latestNewId];
        allIdsToFetch.push(latestNewId);
      }

      const uniqueIdsToFetch = Array.from(new Set(allIdsToFetch));
      if (!uniqueIdsToFetch.length) return;

      const details = await getJobCardsDetails({ jobcards: uniqueIdsToFetch });
      if (!details || !details.length) return;

      const detailsById = new Map();
      details.forEach((d) => {
        if (d?.id !== undefined) detailsById.set(d.id, d);
      });

      for (const [parentIdStr, ids] of Object.entries(idsToFetchByParent)) {
        const parentId = parseInt(parentIdStr, 10);
        const alreadyApplied = new Set(
          (newSolutionAppliedNewIdsByParentRef.current?.[parentId] || []).map((x) =>
            parseInt(x, 10)
          )
        );
        newSolutionAppliedNewIdsByParentRef.current = {
          ...(newSolutionAppliedNewIdsByParentRef.current || {}),
          [parentId]: Array.from(new Set([...alreadyApplied, ...ids])),
        };
      }

      const parentsResolvedThisTick = [];
      setJobCardDetailsList((prev) => {
        const next = [...prev];
        for (const [parentIdStr, ids] of Object.entries(idsToFetchByParent)) {
          const parentId = parseInt(parentIdStr, 10);
          let idx = next.findIndex((x) => x?.id === parentId);
          if (idx === -1 && replanParentId != null && parentId === replanParentId && next.length > 0) {
            idx = 0;
          }
          if (idx === -1) continue;

          const fetchedDetails = ids.map((id) => detailsById.get(id)).filter(Boolean);
          if (!fetchedDetails.length) continue;

          const latestFetched =
            ids
              .map((id) => detailsById.get(id))
              .filter(Boolean)
              .slice(-1)[0] || fetchedDetails.slice(-1)[0];

          next[idx] = {
            ...next[idx],
            newlyCreatedJobCardsDetails: latestFetched ? [latestFetched] : [],
          };
          parentsResolvedThisTick.push(parentId);
        }
        setNewCompareSolSummaryData({ solution1: next, solution2: next });
        return next;
      });

      parentsResolvedThisTick.forEach((pid) => markParentResolved(pid));
    } catch (e) {
      newSolutionPollingActiveRef.current = false;
      setIsNewSolutionPolling(false);
    } finally {
      newSolutionPollingInFlightRef.current = false;
    }
  };

  useInterval(() => {
    pollReadyNewSolutionOnce();
  }, 5000);
  const selectedJobCardId = jobCardDetailsList[jobIndex]?.id;
  const defaultOrdersIdList =
    jobCardDetailsList[jobIndex]?.jobcard?.group?.orders
      ?.filter((order) => order.item_type == "order")
      .map((order) => order.order_id) || [];
  const currentOrdersIdList = selectedJobCardId
    ? (ordersIdListByJobCard[selectedJobCardId] ?? defaultOrdersIdList)
    : [];
  const showToaster = () => {
    setVisibleToaster(true);
    setTimeout(() => setVisibleToaster(false), 2000);
  };
  const fetchOrdersData = async (page, size) => {};
  useEffect(() => {
    let temp = {};
    for (let i = 0; i < 50; i++) {
      temp = { ...temp, [i]: false };
    }
    setFailedNewSol(temp);
  }, []);

  useEffect(() => {
    fetchOrdersData(currentPage, pageSize);
  }, [currentPage, pageSize]);

  const onPaginationChange = (page, pageSize, isUnfulfilled) => {
    // console.log(page, pageSize);
    setCurrentPage(page);
    setPageSize(pageSize);
    isUnfulfilled && setIsUnfulfilledTab(true);
  };

  function onChange(pagination, filters, sorter, extra) {
    // console.log("params", pagination, filters, sorter, extra);
    if (pagination) onPaginationChange(pagination.current, pagination.pageSize);
  }

  useEffect(() => {
    // console.log(totalFulfilledOrders, totalUnfulfilledOrders);
  }, [totalFulfilledOrders, totalUnfulfilledOrders]);
  useEffect(() => {
    setOptimizePartition(false);
    setMinimizeOverfulfillment(false);
  }, [jobIndex]);
  useEffect(() => {}, [failedJobs, stockSizeDetailsList1, failedJobOrders]);
  const getIntermediateListItems = (
    ordersList,
    jobcard,
    solution,
    isNewSolution,
  ) => {
    // console.log(jobIndex, jobCardDetailsList[jobIndex]);
    if (!solution || acceptSolCounter) return;
    getIntermediateList(ordersList, jobcard, solution).then((response) => {
      // console.log(response);
      if (!response) return;
      const intermediateData = response?.map((item, index) => {
        const reelSpecifications = item.reel_specification?.map((spec) => {
          const outerDiameters = Array.isArray(spec?.reel_od)
            ? spec.reel_od.join(", ")
            : spec.reel_od;
          return `${outerDiameters} / ${
            spec?.core_id
          } (${spec?.fulfilled_weight?.toFixed(3)} ${weightUnit[
            spec?.units?.fulfilled_weight
          ]?.displayName?.toUpperCase()}, ${spec.fulfilled}R)`;
        });

        return {
          key: index,
          srno: index + 1,
          reel_size: `${item.reel_size} ${lengthUnit[
            item.units.reel_size
          ]?.displayName?.toUpperCase()}`,
          order_size: item.length
            ? `${item.width} ${lengthUnit[
                item.units.width
              ]?.displayName?.toUpperCase()} x ${item.length} ${lengthUnit[
                item.units.length
              ]?.displayName?.toUpperCase()}`
            : `${item.width} ${lengthUnit[
                item.units.width
              ]?.displayName?.toUpperCase()}`,
          grain: item.grain,
          quantity: `${item.quantity?.toFixed(3)} ${weightUnit[
            item.units.quantity
          ]?.displayName?.toUpperCase()}`,
          reelSpecification: reelSpecifications?.join("\n"),
        };
      });
      if (!isNewSolution) {
        if (solution === "solution_1") setIntermediateData1(intermediateData);
        else setIntermediateData2(intermediateData);
        return;
      }
      if (solution === "solution_1")
        setIntermediateNewSolutionData1(intermediateData);
      else setIntermediateNewSolutionData2(intermediateData);
    });
  };

  const capitalize = (item) => item?.charAt(0)?.toUpperCase() + item?.slice(1);

  const history = useNavigate();
  useEffect(async () => {
    return async () => {
      if (isCancelJobCard.current) {
        await setFormObject(null);
      }
    };
  }, []);
  const routeChange = async () => {
    isCancelJobCard.current = false;
    setStopCancelled(true);
    stopCancellApi.current = true;
    setFormObject(paperMachineFormValues);

    let remainingGroups = [];

    if (acceptedJCGrpCode.length > 0) {
      try {
        const res = await unselectGrpOfAcceptedJobcards(acceptedJCGrpCode);
        const resultData = res?.data?.data || [];
        removeGrpsFromOrderSummary(resultData);
        remainingGroups = resultData;
      } catch (err) {
        console.log("API Error:", err);
      }
    }

    if (location?.state?.isDummyJC && location?.state?.type != "replan") {
      if (acceptSolCounter) {
        handleResetAll();
        cancelJobCard();
        history("../job-cards");
      } else {
        handleResetAll();
        cancelJobCard();
        history("../../order-entry/order-details", {
          state: {
            soNumber: location?.state?.so,
            isSo: true,
            dummyOrders: true,
            route: "add-new-so",
          },
        });
      }
    } else if (location?.state?.type === "replan") {
      if (acceptSolCounter) {
        history("../job-cards");
        handleResetAll();
        cancelJobCard();
      } else {
        history("../job-card-details", {
          state: {
            id: location?.state?.parentJCid,
            jobcardType: location?.state?.jobcardType,
          },
        });
        handleResetAll();
        cancelJobCard();
      }
    } else {
      const shouldGoToOrderSummary =
        handleBackPathForJC() &&
        (acceptedJCGrpCode.length > 0
          ? remainingGroups?.groups?.length > 0
          : true);
      if (!shouldGoToOrderSummary) {
        handleResetAll();
        cancelJobCard();
      }
      history(
        shouldGoToOrderSummary ? "../order-summary" : "../create-new-job-cards",
        {
          state: {
            body: location.state.body,
            data: location?.state?.data,
            orderResponse: location.state.orderResponse,
            maximum_burst_factor: location.state.maximum_burst_factor,
            minimum_burst_factor: location.state.minimum_burst_factor,
            maximum_gsm: location.state.maximum_gsm,
            minimum_gsm: location.state.minimum_gsm,
            selected_rewinder: location.state.selected_rewinder,
            selected_cutter: location.state.selected_cutter,
            selected_rewinder_unit: location.state.selected_rewinder_unit,
            selected_cutter_unit: location.state.selected_cutter_unit,
            rewinder_data: location.state.rewinder_data,
            cutter_data: location.state.cutter_data,
            selected_type: location.state.selected_type,
            rewinder_minWidth: location.state.rewinder_minWidth,
            rewinder_maxWidth: location.state.rewinder_maxWidth,
            cutter_minWidth: location.state.cutter_minWidth,
            cutter_maxWidth: location.state.cutter_maxWidth,
            max_NoOfCutters: location.state.max_NoOfCutters,
            minWeight: location.state.minWeight,
            left_edge_trim: location.state.left_edge_trim,
            right_edge_trim: location.state.right_edge_trim,
            initital_OrderType: location.state.initital_OrderType,
            code: location.state.code,
            machine_code: location.state.machine_code,
            processType: location.state.processType,
          },
        },
      );
    }
  };

  // Discard modal condition

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  // process failed groups to fetch and set to failedGroups
  async function process_failed_groups() {
    let previousJobcardCount = 0;
    while (true) {
      try {
        // keep checking the algo status
        const response = await getAlgorithmCompletionStatus();
        if (
          response.data.done &&
          response.data.jobcards.length > previousJobcardCount
        ) {
          // console.log(response.data.jobcards)
          setJobcardIds((prev) => {
            const next = response.data.jobcards || [];
            return JSON.stringify(prev) === JSON.stringify(next) ? prev : next;
          });
        }
        // if(response.)
        if (response.data.done && response.data.failed_groups.length > 0) {
          // console.log(response.data);
          // setReFetch(true)
          setFailedGroups(response.data.failed_groups);
          // return;
        }
        if (
          response.data.total_groups ==
          response.data.jobcards.length + response.data.failed_groups.length
        ) {
          // console.log(response.data.jobcards)
          setJobcardIds((prev) => {
            const next = response.data.jobcards || [];
            return JSON.stringify(prev) === JSON.stringify(next) ? prev : next;
          });
          return;
        }
        previousJobcardCount = response.data.jobcards.length;
      } catch (error) {
        // console.log(error);
        return;
      } finally {
      }
      await sleep(5000);
    }
  }

  useEffect(() => {
    if(location?.state?.type !== "replan"){
    setTimeout(process_failed_groups, 5000);
    }
  }, []);

  const discardModalShow = (value) => {
    setIsDiscardModal(true);
  };

  const discardModalClose = () => {
    setIsDiscardModal(false);
  };
  useEffect(() => {}, [jobCardDetailsList, isFetchingData]);
  const discardModalConfirm = () => {
    setIsDiscardModal(false);
    const newSolutionDetail =
      jobCardDetailsList?.[jobIndex]?.newlyCreatedJobCardsDetails?.[0];

    let jobCardId =
      solutionId == 1 || solutionId == 2
        ? jobCardDetailsList?.[jobIndex]?.id
        : newSolutionDetail?.id;

    if (!jobCardId) return;
    let solutionState =
      solutionId == 1 || solutionId == 3 ? "solution_1" : "solution_2";
    putSolutionStatus(jobCardId, solutionState, "reject")
      .then((response) => {
        // !response.error && setReFetch(true);
        if (!response.error) {
          setJobCardDetailsList((prev) => {
            const next = [...prev];
            const row = next[jobIndex];
            if (!row) return prev;
            if (solutionId == 1 || solutionId == 2) {
              next[jobIndex] = {
                ...row,
                jobcard: {
                  ...row.jobcard,
                  [solutionState]: {
                    ...row.jobcard?.[solutionState],
                    status: "reject",
                  },
                },
              };
            } else {
              const ncd = row?.newlyCreatedJobCardsDetails || [];
              if (!ncd.length) return prev;
              const first = ncd[0];
              const updatedFirst = {
                ...first,
                jobcard: {
                  ...first.jobcard,
                  [solutionState]: {
                    ...first.jobcard?.[solutionState],
                    status: "reject",
                  },
                },
              };
              next[jobIndex] = {
                ...row,
                newlyCreatedJobCardsDetails: [updatedFirst, ...ncd.slice(1)],
              };
            }
            return next;
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // Accepting solution

  const acceptModalShow = (value) => {
    setIsAcceptModal(true);
  };

  const acceptModalClose = () => {
    setIsAcceptModal(false);
  };
  const acceptModalConfirm = () => {
    setIsAcceptModal(false);
    const newSolutionDetail =
      jobCardDetailsList?.[jobIndex]?.newlyCreatedJobCardsDetails?.[0];

    let jobCardId =
      solutionId == 1 || solutionId == 2
        ? jobCardDetailsList[jobIndex]?.id
        : newSolutionDetail?.id;

    let groupId =
      solutionId == 1 || solutionId == 2
        ? jobCardDetailsList[jobIndex]?.jobcard?.group?.group_id
        : newSolutionDetail?.jobcard?.group?.group_id;
    
        if (!jobCardId || !groupId) return;

    setAcceptedJCGrpCode([...acceptedJCGrpCode, groupId]);
    let solutionState =
      solutionId == 1 || solutionId == 3 ? "solution_1" : "solution_2";
    let rejectedSolution =
      solutionId == 1 || solutionId == 3 ? "solution_2" : "solution_1";
    putSolutionStatus(jobCardId, solutionState, "accept")
      .then((response) => {
        // !response.error && setReFetch(true);
        if (!response.error) {
          setRenderKey(true);
          setJobCardDetailsList((prev) => {
            const next = [...prev];
            const row = next[jobIndex];
            if (!row) return prev;
            const jcCode = getJCCode(response?.data?.jobcard_code);

            if (solutionId == 1 || solutionId == 2) {
              const updatedRow = {
                ...row,
                jc_code: jcCode,
                state: "pending",
                jobcard: {
                  ...row.jobcard,
                  [solutionState]: {
                    ...row.jobcard?.[solutionState],
                    status: "accept",
                  },
                  [rejectedSolution]: {
                    ...row.jobcard?.[rejectedSolution],
                    status: "reject",
                  },
                },
              };

              const ncd = row?.newlyCreatedJobCardsDetails || [];
              if (ncd.length) {
                const first = ncd[0];
                const updatedFirst = {
                  ...first,
                  jobcard: {
                    ...first.jobcard,
                    [solutionState]: {
                      ...first.jobcard?.[solutionState],
                      status: "reject",
                    },
                    [rejectedSolution]: {
                      ...first.jobcard?.[rejectedSolution],
                      status: "reject",
                    },
                  },
                };
                updatedRow.newlyCreatedJobCardsDetails = [
                  updatedFirst,
                  ...ncd.slice(1),
                ];
              }

              next[jobIndex] = updatedRow;
              return next;
            }

            const ncd = row?.newlyCreatedJobCardsDetails || [];
            if (!ncd.length) return prev;
            const first = ncd[0];
            const updatedFirst = {
              ...first,
              state: "pending",
              jobcard: {
                ...first.jobcard,
                [solutionState]: {
                  ...first.jobcard?.[solutionState],
                  status: "accept",
                },
                [rejectedSolution]: {
                  ...first.jobcard?.[rejectedSolution],
                  status: "reject",
                },
              },
            };

            next[jobIndex] = {
              ...row,
              jc_code: jcCode,
              state: "pending",
              jobcard: {
                ...row.jobcard,
                [solutionState]: {
                  ...row.jobcard?.[solutionState],
                  status: "reject",
                },
                [rejectedSolution]: {
                  ...row.jobcard?.[rejectedSolution],
                  status: "reject",
                },
              },
              newlyCreatedJobCardsDetails: [updatedFirst, ...ncd.slice(1)],
            };
            return next;
          });
          setAcceptSolCounter(true);
          setActiveTab("1");
          setSolutionId("1");
          setSolId("1");
        }
      })
      .catch((error) => {
        console.log(error);
        setActionToaster({
          error: error.response.data.error,
          msg: error.response.data.msg,
        });
        showToaster();
      });
  };

  const showViewDrawer = (value, record) => {
    setSelectedOrderNo(value);
    setSelectedOrder(record);
    setViewOrder(true);
  };

  const closeViewDrawer = () => {
    setViewOrder(false);
  };

  const getJobCardsListDetails = (
    jobcardIds,
    parentJobCardId = 0,
    uuid = "",
  ) => {
    let newsolcnt = false;
    getJobCardsDetails({ jobcards: jobcardIds })
      .then((response) => {
        if (!createNewSolutionClicked.isClicked) {
          setJobCardDetailsList((prev) => {
            const next = [...(prev || [])];
            (response || []).forEach((jobs) => {
              if (!next.some((j) => j?.id === jobs?.id)) next.push(jobs);
            });
            return next.length ? next : response;
          });
          setCompareSolSummaryData({
            solution1: response,
            solution2: response,
          });
        } else {
          newsolcnt = true;
          setJobCardDetailsList((prev) => {
            const next = [...(prev || [])];
            const filteredJobCardIndex = next.findIndex((jobCardDetails) => {
              return jobCardDetails.uuid == uuid;
            });
            if (filteredJobCardIndex === -1) return prev;

            next[filteredJobCardIndex] = {
              ...next[filteredJobCardIndex],
              newlyCreatedJobCardsDetails: response,
            };
            setNewCompareSolSummaryData({ solution1: next, solution2: next });
            return next;
          });
          setCreateNewSolutionClicked({ isClicked: false, index: -1 });
          // detailsList[filteredJobCardIndex]["newlyCreatedJobCardsDetails"] =
          //   response;
        }
        let stockMachineValue = formValuesForStock?.[jobIndex];
        // stockMachineValue["min_deckle_length"] =
        //   response[0].jobcard.group.machines[0].deckle_size_lb;
        // stockMachineValue["max_deckle_length"] =
        //   response[0].jobcard.group.machines[0].deckle_size_ub +
        //   (response[0].jobcard.group.machines[0].left_edge_trim +
        //   response[0].jobcard.group.machines[0].right_edge_trim) * CoversionFactorUnitsToCM[response[0].jobcard.group.machines[0].units?.right_edge_trim] * CoversionFactorCMToUnits[response[0].jobcard.group.machines[0].units?.deckle_size_ub];
        // stockMachineValue["maximum_cutters"] =
        //   response[0].jobcard.group.machines[0].original_cutters;
        // stockMachineValue["effective_deckle_length"] =
        //   response[0].jobcard.group.machines[0].effective_deckle_length;
        // stockMachineValue["left_edge_trim"] =
        //   response[0].jobcard.group.machines[0].left_edge_trim;
        // stockMachineValue["right_edge_trim"] =
        //   response[0].jobcard.group.machines[0].right_edge_trim;
        // stockMachineValue["units"] =
        //   response[0].jobcard.group.machines[0].units;
        const rewinderMachine = response[0]?.jobcard?.group?.machines?.find(
          (machine) => machine.machine_type === "rewinder",
        );
        if (rewinderMachine) {
          const {
            deckle_size_lb,
            deckle_size_ub,
            left_edge_trim,
            right_edge_trim,
            original_cutters,
            effective_deckle_length,
            units,
            machine_type,
            machine_code,
          } = rewinderMachine;

          const rightEdgeTrimConversionFactor =
            CoversionFactorUnitsToCM[units.right_edge_trim];
          const deckleSizeUbConversionFactor =
            CoversionFactorCMToUnits[units.deckle_size_ub];

          const minDeckleLength = deckle_size_lb;
          const maxDeckleLength =
            deckle_size_ub +
            (left_edge_trim + right_edge_trim) *
              rightEdgeTrimConversionFactor *
              deckleSizeUbConversionFactor;

          stockMachineValue = {
            ...stockMachineValue,
            min_deckle_length: minDeckleLength,
            max_deckle_length: maxDeckleLength,
            maximum_cutters: original_cutters,
            effective_deckle_length: effective_deckle_length,
            left_edge_trim: left_edge_trim,
            right_edge_trim: right_edge_trim,
            units: units,
          };
        }

        setFormValuesForStock({
          ...formValuesForStock,
          [jobIndex]: stockMachineValue,
        });

        const orderIds = [];
        // console.log(response);
        // response.forEach((item) => {
        //   item.jobcard?.group?.orders?.map((order) => {
        //     orderIds.push(order.order_id);
        //   });
        // });
        // // console.log(orderIds);
        // setOrderIdList(orderIds);
      })
      .catch((error) => console.log(error))
      .finally(() => {
        jobCardsDetailsFetchInFlightRef.current = false;
        newsolcnt && setSolId("3");
        newsolcnt && setSolutionId("3");
      });
  };
  const getFailedGroupsData = (response, jobcard) => {
    const failedJobData = response.data?.map((item, index) => {
      // const orderData = jobcard.group.orders
      // console.log("res", response);
      // console.log("jb", jobcard);
      return {
        key: index + 1,
        pono: item.po,
        sono: item.so,
        category: item.category,
        orderno: item.id,
        type: capitalize(item.this_item_type),
        overfulfillmentPercentage:`${( ( (item.fulfilled_weight/item.requirement) -1 )* 100).toFixed(2)}%`,

        customercode: item.customer,
        customername: item.customer_name,
        customer_alias: item.customer_alias,
        consignee: item.consignee_name,
        productspec: item.product_spec,
        size: `${item.width}${
          item.length ? ` x ${item.length}` : ""
        } ${lengthUnit[item.units?.width]?.displayName?.toUpperCase()}`,
        plannedWeight:
          item.planned_weight +
          " " +
          capitalize(
            item.units?.planned_weight
              ? weightUnit[item.units?.planned_weight]?.displayName
              : "T",
          ),
        unFulflilledWeight:
          item.planned_weight +
          " " +
          capitalize(
            item.units?.planned_weight
              ? weightUnit[item.units?.planned_weight]?.displayName
              : "T",
          ),
        deliverydate:
          item.category === "so"
            ? "-"
            : moment(item.delivery_date).format("DD MMM YYYY"),

        remarks: item.remarks,
      };
    });
    setFailedJobOrders(failedJobData);
  };
  useEffect(() => {
    setTimeout(() => {
      if (isLoading === true) setIsLoading(false);
    }, 3000);
  }, []);

  useEffect(() => {
    if (rerender) {
      // console.log("Do something when triggered changes");
      // re-render will already happen if state affects UI
      setRerender(false);
    }
  }, [rerender]);

  const getJCCode = (str) => {
    if (str) {
      let splittedString = str?.split("~");
      let mergeString;
      mergeString = splittedString?.join("");
      return mergeString;
    }
  };
  const fetchOrders = async (solutionType, jobcard, solutionId) => {
    setIsFetchingData(true);
    const solution =
      solutionId === 1
        ? "solution_1"
        : solutionId === 2
          ? "solution_2"
          : solutionId === 3
            ? "solution_1"
            : solutionId === 4
              ? "solution_2"
              : "";
    const sizes = solution ? jobcard[solution].data.sizes : [];
    const orders = solution ? jobcard[solution].data.orders?.filter(order => order.item_type !== "trim_loss") || [] : [];
    const setSizes =
      solutionId === 1
        ? setsizeDetailsList1
        : solutionId === 2
          ? setsizeDetailsList2
          : solutionId === 3
            ? setNewSolSizeList1
            : setNewSolSizeList2;
    // : setFailedJobOrders;
    let sizeFulfillmentList = orders?.map((size, index) => {
      return {
        key: index + 1,
        type: size.item_type === "stock" ? "Stock" : "Order",
        size: `${size.size} ${
          size.lateral_size ? "X " + size.lateral_size : ""
        } ${" "} ${
          size.units && size.units.size
            ? lengthUnit[size.units.size]?.displayName?.toUpperCase()
            : "CM"
        }`,
        plannedReels: size.fulfilled + size.unfulfilled,
        plannedWeight:
          (size.fulfilled_weight + size.unfulfilled_weight).toFixed(3) +
          " " +
          (size?.units && size?.units?.fulfilled_weight
            ? capitalize(weightUnit[size.units.fulfilled_weight]?.displayName)
            : "T"),
        fulflilledReels: size.fulfilled,
        fulflilledWeight:
          size.fulfilled_weight.toFixed(3) +
          " " +
          (size?.units && size?.units?.fulfilled_weight
            ? capitalize(weightUnit[size.units.fulfilled_weight]?.displayName)
            : "T"),
        unFulflilledReels: size.unfulfilled,
        unFulflilledWeight:
          size.unfulfilled_weight.toFixed(3) +
          " " +
          (size?.units && size?.units?.unfulfilled_weight
            ? weightUnit[
                size.units.unfulfilled_weight
              ]?.displayName?.toUpperCase()
            : "T"),
        reelSpecification: size.diameter_fulfillment?.map((diaItem) => {
          const reelOd = diaItem.reel_od;
          const coreId = diaItem.core_id;
          const fulfilledWeight = diaItem.fulfilled_weight?.toFixed(3);
          const fulfilledValue = diaItem.fulfilled;
          const fulfilledWeightUnit = size?.units?.fulfilled_weight
            ? capitalize(weightUnit[size?.units?.fulfilled_weight]?.displayName)
            : "";
          return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue}R)\n`;
        }),
      };
    });
    setSizes(sizeFulfillmentList);
    if (solutionType == "current_solution") {
      // console.log(solutionId);

      const setList =
        solutionId === 1
          ? setOrderDetailsList1
          : solutionId === 2
            ? setOrderDetailsList2
            : setFailedJobOrders;
      // console.log(failedJobOrders);
      if (!solutionId) {
        setOrderDetailsList1();
        setOrderDetailsList2();
      }
      // console.log(solution);

      let ordersList = solution
        ? jobcard[solution]?.data.orders
            ?.filter((order) => {
              return order.item_type == "order";
            })
            ?.map((item) => item.order_id)
        : jobcard.group.orders
            ?.filter((order) => {
              return order.item_type == "order";
            })
            ?.map((item) => item.order_id);

      ordersList &&
        solution &&
        getIntermediateListItems(
          ordersList,
          jobCardDetailsList[jobIndex].id,
          solution,
        );
      const fulfilledOrdersList = solution
        ? jobcard[solution]?.data.orders
            ?.filter((order) => {
              return order.item_type == "order" && order.fulfilled_weight > 0;
            })
            ?.map((item) => item.order_id)
        : jobcard.group.orders
            ?.filter((order) => {
              return order.item_type == "order" && order.fulfilled_weight > 0;
            })
            ?.map((item) => item.order_id);
      const unfulfilledOrdersList = solution
        ? jobcard[solution]?.data.orders
            ?.filter((order) => {
              return order.item_type == "order" && order.unfulfilled_weight > 0;
            })
            ?.map((item) => item.order_id)
        : jobcard.group.orders
            ?.filter((order) => {
              return order.item_type == "order";
            })
            ?.map((item) => item.order_id);

      setTotalFulfilledOrders(
        solution
          ? jobcard[solution]?.data.orders?.filter((order) => {
              return order.fulfilled_weight > 0;
            })?.length
          : jobcard.group.orders?.filter((order) => {
              return order.fulfilled_weight > 0;
            })?.length,
      );
      setTotalUnfulfilledOrders(unfulfilledOrdersList.length);
      // console.log(tota)
      // if()
      const startIndex = (currentPage - 1) * pageSize;
      const endIndex = startIndex + pageSize;
      ordersList &&
        getOrdersList([
          ...fulfilledOrdersList.slice(),
          ...unfulfilledOrdersList.slice(),
        ])
          .then((response) => {
            let orderTypeData;
            if (solutionId) {
              orderTypeData = [
                ...response.data?.map((item, index) => {
                  const orderData = solution
                    ? jobcard[solution].data.orders.filter(
                        (order) => parseFloat(order.order_id) === item.id,
                      )[0]
                    : jobcard.group.orders.filter(
                        (order) => parseFloat(order.order_id) === item.id,
                      )[0];

                  return {
                    key: index + 1,
                    pono: `${item.po}`,
                    sono: `${item.so}`,
                    category: `${item.category}`,
                    orderno: `${item.number}`,
                    type: `Order`,
                    overfulfillmentPercentage:`${( ( (orderData.fulfilled_weight/orderData.requirement) -1 )* 100).toFixed(2)}%`,
                    productspec: item.product_spec,
                    customercode: item.customer,
                    customername: item.customer_name,
                    customer_alias: item.customer_alias,
                    size: `${item.width}${
                      item.length ? ` x ${item.length}` : ""
                    } ${lengthUnit[
                      item.units?.width
                    ]?.displayName?.toUpperCase()}`,
                    plannedReels: orderData?.requirement,
                    plannedWeight: solution
                      ? orderData?.requirement?.toFixed(3) +
                        " " +
                        capitalize(
                          weightUnit[orderData?.units?.requirement]
                            ?.displayName,
                        )
                      : item.planned_weight?.toFixed(3) +
                        " " +
                        capitalize(
                          weightUnit[item.units?.planned_weight]?.displayName,
                        ),
                    fulflilledReels: orderData?.fulfilled,
                    fulflilledWeight:
                      orderData?.fulfilled_weight?.toFixed(3) +
                      " " +
                      (orderData?.units?.fulfilled_weight
                        ? capitalize(
                            weightUnit[orderData.units?.fulfilled_weight]
                              ?.displayName,
                          )
                        : ""),
                    unFulflilledReels: solution
                      ? orderData?.unfulfilled
                      : orderData?.requirement,
                    unFulflilledWeight: solution
                      ? orderData?.unfulfilled_weight?.toFixed(3) +
                        " " +
                        capitalize(
                          weightUnit[orderData.units?.unfulfilled_weight]
                            ?.displayName,
                        )
                      : item.planned_weight?.toFixed(3) +
                        " " +
                        capitalize(
                          weightUnit[item.units?.planned_weight]?.displayName,
                        ),
                    priority: item.forced,
                    deliverydate:
                      item.category === "so"
                        ? "-"
                        : moment(item.delivery_date).format("DD MMM YYYY"),

                    remarks: item.remarks,
                    customer_alias: item.customer_alias,
                    consignee: item.consignee_name,
                    reelSpecification: orderData?.diameter_fulfillment?.map(
                      (diaItem) => {
                        const reelOd = diaItem.reel_od;
                        const coreId = diaItem.core_id;
                        const fulfilledWeight =
                          diaItem.fulfilled_weight?.toFixed(3);
                        const fulfilledValue = diaItem.fulfilled;
                        const fulfilledWeightUnit = capitalize(
                          weightUnit[orderData.units?.fulfilled_weight]
                            ?.displayName,
                        );
                        return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue}R)\n`;
                      },
                    ),
                  };
                }),
              ];
              let dynamicStockInfo = [];
              let dynamicStock = jobcard[solution].data.orders?.filter(
                (order) => {
                  return (
                    order.creation_type == "dynamic" ||
                    order.creation_type == "static" ||
                    order.creation_type == "required"
                  );
                },
              );
              if (dynamicStock.length) {
                dynamicStockInfo = [
                  ...dynamicStock?.map((item, index) => {
                    // console.log(orderData);
                    return {
                      key: index + 1,
                      pono: "-",
                      orderno:
                        item.creation_type == "static" ? item.order_id : `-`,
                    overfulfillmentPercentage:`${( ( (item.fulfilled_weight/item.requirement) -1 )* 100).toFixed(2)}%`,

                      type: "Stock",
                      productspec: jobcard.group.product.product_spec,
                      customercode: "-",
                      customername: "-",
                      size: `${item.size} ${
                        item.units?.size
                          ? lengthUnit[
                              item.units?.size
                            ]?.displayName?.toUpperCase()
                          : "CM"
                      }`,
                      plannedReels: "-",
                      plannedWeight: "-",
                      fulflilledReels: item.fulfilled,
                      fulflilledWeight:
                        item.fulfilled_weight?.toFixed(3) +
                        " " +
                        (item.units?.fulfilled_weight
                          ? capitalize(
                              weightUnit[item.units?.fulfilled_weight]
                                ?.displayName,
                            )
                          : ""),
                      unFulflilledReels: "-",
                      unFulflilledWeight: "-",
                      priority: false,
                      deliverydate: "-",
                      remarks: "-",
                      consignee: "-",
                      reelSpecification: item?.diameter_fulfillment?.map(
                        (diaItem) => {
                          const reelOd = diaItem.reel_od;
                          const coreId = diaItem.core_id;
                          const fulfilledWeight =
                            diaItem.fulfilled_weight?.toFixed(3);
                          const fulfilledValue = diaItem.fulfilled;
                          const fulfilledWeightUnit = capitalize(
                            weightUnit[item.units?.fulfilled_weight]
                              ?.displayName,
                          );
                          return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue}R)\n`;
                        },
                      ),
                    };
                  }),
                ];
              }
              setList([...orderTypeData, ...dynamicStockInfo]);
            }
            !solutionId && getFailedGroupsData(response, jobcard);
          })
          .catch((error) => console.log(error))
          .finally(() => setIsFetchingData(false));
    }
    if (solutionType == "new_solution") {
      let ordersListInNewSolution = [];
      const ordersList = solution
        ? jobcard[solution].data.orders
            ?.filter((order) => {
              return order.item_type == "order";
            })
            ?.map((item) => item.order_id)
        : jobcard.group.orders?.map((item) => item.order_id);

      ordersList &&
        solution &&
        getIntermediateListItems(
          ordersList,
          jobCardDetailsList[jobIndex].id,
          solution,
          true,
        );

      const fulfilledOrdersList = solution
        ? jobcard[solution]?.data.orders
            ?.filter((order) => {
              return order.item_type == "order" && order.fulfilled_weight > 0;
            })
            ?.map((item) => item.order_id)
        : jobcard.group.orders
            ?.filter((order) => {
              return order.item_type == "order" && order.fulfilled_weight > 0;
            })
            ?.map((item) => item.order_id);
      const unfulfilledOrdersList = solution
        ? jobcard[solution]?.data.orders
            ?.filter((order) => {
              return order.item_type == "order" && order.unfulfilled_weight > 0;
            })
            ?.map((item) => item.order_id)
        : jobcard.group.orders
            ?.filter((order) => {
              return order.item_type == "order";
            })
            ?.map((item) => item.order_id);

      const startIndex = (currentPage - 1) * pageSize;
      const endIndex = startIndex + pageSize;
      let orderRes, stockRes;
      ordersList &&
        getOrdersList([...fulfilledOrdersList, ...unfulfilledOrdersList])
          .then((response) => {
            ordersListInNewSolution = [
              ...response.data?.map((item, index) => {
                const orderData = solution
                  ? jobcard[solution].data.orders.filter(
                      (order) => parseFloat(order.order_id) === item.number,
                    )[0]
                  : jobcard.group.orders.filter(
                      (order) => parseFloat(order.order_id) === item.number,
                    )[0];
                //console.log(orderData);
                orderRes = response;
                return {
                  key: index + 1,
                  pono: `${item.po}`,
                  sono: `${item.so}`,
                  category: `${item.category}`,
                  orderno: `${item.number}`,
                  overfulfillmentPercentage:`${( ( (orderData.fulfilled_weight/orderData.requirement) -1 )* 100).toFixed(2)}%`,
                  type: `Order`,
                  productspec: item.product_spec,
                  customercode: item.customer,
                  customername: item.customer_name,
                  size: `${item.width}${
                    item.length ? ` x ${item.length}` : ""
                  } ${lengthUnit[
                    item.units?.width
                  ]?.displayName?.toUpperCase()}`,
                  plannedReels: orderData.requirement,
                  plannedWeight: solution
                    ? orderData.requirement?.toFixed(3) +
                      " " +
                      capitalize(
                        weightUnit[orderData.units?.requirement]?.displayName,
                      )
                    : item.planned_weight?.toFixed(3) +
                      " " +
                      capitalize(
                        weightUnit[item.units?.planned_weight]?.displayName,
                      ),
                  fulflilledReels: orderData.fulfilled,
                  fulflilledWeight:
                    orderData.fulfilled_weight?.toFixed(3) +
                    " " +
                    (orderData.units?.fulfilled_weight
                      ? capitalize(
                          weightUnit[orderData.units?.fulfilled_weight]
                            ?.displayName,
                        )
                      : ""),
                  unFulflilledReels: solution
                    ? orderData.unfulfilled
                    : orderData.requirement,
                  unFulflilledWeight: solution
                    ? orderData.unfulfilled_weight?.toFixed(3) +
                      " " +
                      capitalize(
                        weightUnit[orderData.units?.unfulfilled_weight]
                          ?.displayName,
                      )
                    : item.planned_weight?.toFixed(3) +
                      " " +
                      capitalize(
                        weightUnit[item.units?.planned_weight]?.displayName,
                      ),
                  priority: item.forced,
                  deliverydate:
                    item.category === "so"
                      ? "-"
                      : moment(item.delivery_date).format("DD MMM YYYY"),

                  remarks: item.remarks,
                  customer_alias: item.customer_alias,
                  consignee: item.consignee_name,
                  reelSpecification: orderData?.diameter_fulfillment?.map(
                    (diaItem) => {
                      const reelOd = diaItem.reel_od;
                      const coreId = diaItem.core_id;
                      const fulfilledWeight =
                        diaItem.fulfilled_weight?.toFixed(3);
                      const fulfilledValue = diaItem.fulfilled;
                      const fulfilledWeightUnit = capitalize(
                        weightUnit[orderData.units?.fulfilled_weight]
                          ?.displayName,
                      );
                      return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue}R)\n`;
                    },
                  ),
                };
              }),
            ];

            const stockSizesList = solution
              ? jobcard[solution].data.orders
                  ?.filter((order) => {
                    return (
                      order.item_type == "product_stock_size" &&
                      order.creation_type != "dynamic" &&
                      order.creation_type != "required"
                    );
                  })
                  ?.map((item) => item.order_id)
              : jobcard.group.orders
                  ?.filter((order) => {
                    return (
                      order.item_type == "product_stock_size" &&
                      order.creation_type != "dynamic" &&
                      order.creation_type != "required"
                    );
                  })
                  ?.map((item) => item.order_id);
            stockSizesList &&
              getStockSizesDetailsByIds({ stock_sizes: stockSizesList })
                .then((response) => {
                  let sizesList = [
                    ...response.data?.map((item, index) => {
                      const orderData = solution
                        ? jobcard[solution].data.orders.filter(
                            (order) => order.order_id === item.id,
                          )[0]
                        : jobcard.group.orders.filter(
                            (order) => order.order_id === item.id,
                          )[0];
                      // console.log(orderData);
                      return {
                        key: index + 1,
                        pono: "-",
                        orderno: `${item.id}`,
                        type: "Stock",
                        overfulfillmentPercentage:`${( ( (orderData.fulfilled_weight/orderData.requirement) -1 )* 100).toFixed(2)}%`,

                        productspec: item.product_spec,
                        customercode: "-",
                        customername: "-",
                        size: `${item.width}${
                          item.length ? ` x ${item.length}` : ""
                        } ${lengthUnit[
                          item.units?.width
                        ]?.displayName?.toUpperCase()}`,
                        plannedReels: "-",
                        plannedWeight: "-",
                        fulflilledReels: orderData.fulfilled,
                        fulflilledWeight:
                          orderData.fulfilled_weight?.toFixed(3) +
                          " " +
                          (orderData.units?.fulfilled_weight
                            ? capitalize(
                                weightUnit[orderData.units?.fulfilled_weight]
                                  ?.displayName,
                              )
                            : ""),
                        unFulflilledReels: "-",
                        unFulflilledWeight: "-",
                        priority: false,
                        deliverydate: "-",
                        remarks: "-",
                        consignee: item.consignee_name,
                        reelSpecification: orderData?.diameter_fulfillment?.map(
                          (diaItem) => {
                            const reelOd = diaItem.reel_od;
                            const coreId = diaItem.core_id;
                            const fulfilledWeight =
                              diaItem.fulfilled_weight?.toFixed(3);
                            const fulfilledValue = diaItem.fulfilled;
                            const fulfilledWeightUnit = capitalize(
                              weightUnit[orderData.units?.fulfilled_weight]
                                ?.displayName,
                            );
                            return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue}R)\n`;
                          },
                        ),
                      };
                    }),
                  ];
                  stockRes = response;
                  // console.log(orderRes, stockRes)
                  let dynamicStockInfo = [];

                  let dynamicStock = jobcard[solution].data.orders?.filter(
                    (order) => {
                      return (
                        order.creation_type == "dynamic" ||
                        order.creation_type == "required"
                      );
                    },
                  );
                  if (dynamicStock.length) {
                    dynamicStockInfo = [
                      ...dynamicStock?.map((item, index) => {
                        // console.log(orderData);
                        return {
                          key: index + 1,
                          pono: "-",
                          orderno: `-`,
                          type: "Stock",
                          productspec: jobcard.group.product.product_spec,
                          overfulfillmentPercentage:`${( ( (item.fulfilled_weight/item.requirement) -1 )* 100).toFixed(2)}%`,

                          customercode: "-",
                          customername: "-",
                          size: `${item.size} ${
                            item.units?.size
                              ? lengthUnit[
                                  item.units?.size
                                ]?.displayName?.toUpperCase()
                              : "CM"
                          }`,
                          plannedReels: "-",
                          plannedWeight: "-",
                          fulflilledReels: item.fulfilled,
                          fulflilledWeight:
                            item.fulfilled_weight?.toFixed(3) +
                            " " +
                            (item.units?.fulfilled_weight
                              ? capitalize(
                                  weightUnit[item.units?.fulfilled_weight]
                                    ?.displayName,
                                )
                              : ""),
                          unFulflilledReels: "-",
                          unFulflilledWeight: "-",
                          priority: false,
                          deliverydate: "-",
                          remarks: "-",
                          consignee: "-",
                          reelSpecification: item?.diameter_fulfillment?.map(
                            (diaItem) => {
                              const reelOd = diaItem.reel_od;
                              const coreId = diaItem.core_id;
                              const fulfilledWeight =
                                diaItem.fulfilled_weight?.toFixed(3);
                              const fulfilledValue = diaItem.fulfilled;
                              const fulfilledWeightUnit = capitalize(
                                weightUnit[item.units?.fulfilled_weight]
                                  ?.displayName,
                              );
                              return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue}R)\n`;
                            },
                          ),
                        };
                      }),
                    ];
                  }

                  solutionId === 3
                    ? setStockSizeDetailsList1([
                        ...ordersListInNewSolution,
                        ...sizesList,
                        ...dynamicStockInfo,
                      ])
                    : setStockSizeDetailsList2([
                        ...ordersListInNewSolution,
                        ...sizesList,
                        ...dynamicStockInfo,
                      ]);
                  setTotalFulfilledOrders(
                    [
                      ...ordersListInNewSolution,
                      ...sizesList,
                      ...dynamicStockInfo,
                    ].length,
                  );
                  setTotalUnfulfilledOrders(unfulfilledOrdersList.length);
                })

                .catch((error) => console.log(error));
            !solutionId && getFailedGroupsData(response, jobcard);
          })
          .catch((error) => console.log(error))
          .finally(() => setIsFetchingData(false));
    }
    let tempOrdersArray = [];
    jobcard?.group?.orders?.map((order) => {
      if (order.item_type == "order") {
        tempOrdersArray.push(order.order_id);
      }
    });
    if (selectedJobCardId) {
      setOrdersIdListByJobCard((prev) => {
        if (prev[selectedJobCardId] !== undefined) {
          return prev;
        }
        return {
          ...prev,
          [selectedJobCardId]: tempOrdersArray,
        };
      });
    }
    // return () => {

    // };
    setRerender(!rerender);
  };

  const onClickCreateNewSolution = (index) => {
    setCreateNewSolutionClicked({ isClicked: true, index: index });
    // history("../create-new-job-cards");
    // history("../create-new-job-cards", {
    //   state: {
    //     jobCards: response.data,
    //     // failed: response.data.failed_groups,
    //     // total_groups: response.data.total_groups
    //   },
    // });
  };
  const calcStockValues = (index) => {
    if (formValuesForStock?.[index]) return;
    const rewinderMachine =
      jobCardDetailsList[index]?.jobcard?.group?.machines[0];
    let stockMachineValue = { ...formValuesForStock?.[index] };
    if (rewinderMachine) {
      const {
        deckle_size_lb,
        deckle_size_ub,
        left_edge_trim,
        right_edge_trim,
        original_cutters,
        effective_deckle_length,
        units,
        machine_type,
        machine_code,
      } = rewinderMachine;

      const rightEdgeTrimConversionFactor =
        CoversionFactorUnitsToCM[units.right_edge_trim];
      const deckleSizeUbConversionFactor =
        CoversionFactorCMToUnits[units.deckle_size_ub];

      const minDeckleLength = deckle_size_lb;
      const maxDeckleLength =
        deckle_size_ub +
        (left_edge_trim + right_edge_trim) *
          rightEdgeTrimConversionFactor *
          deckleSizeUbConversionFactor;

      stockMachineValue = {
        ...stockMachineValue,
        min_deckle_length: minDeckleLength,
        max_deckle_length: maxDeckleLength,
        maximum_cutters: original_cutters,
        effective_deckle_length: effective_deckle_length,
        left_edge_trim: left_edge_trim,
        right_edge_trim: right_edge_trim,
        units: units,
      };
    }
    setFormValuesForStock({
      ...formValuesForStock,
      [index]: stockMachineValue,
    });
  };
  const callbackKey = (key) => {
    setActiveTab("1");
    setSizeExpanded(false);
    setSizeExpanded(false);
    setSizeExpanded(false);
    setSizeExpanded(false);
    let ind = jobCardDetailsList.findIndex((ele) => ele.id == key);
    setSolId("compare");
    setSolutionId("compare");
    setJobIndex(parseInt(ind));
    // console.log(jobCardDetailsList, failedGroups, key);
    if (!jobCardDetailsList[parseInt(ind)])
      failedGroups.filter((item, index) => {
        if (item === parseInt(ind)) {
          setFailedjobIndex(index);
          return index;
        }
      });
    calcStockValues(parseInt(ind));
    setCreateNewSolutionClicked((prevState) => ({
      ...prevState,
      isClicked: false,
    }));
    setPageSize(10);
    setCurrentPage(1);
    setActiveKey1(ind);

    // let index = jobCardDetailsList.findIndex(ele => ele.id == key);
    let data = jobcardIdsWithCode[ind];
    setActiveJC(data?.jc_code);
    currentActiveJC.current = data?.id;
  };

  useEffect(() => {
    return () => {
      if (stopCancelled || stopCancellApi.current) return;
      cancelJobCard();
      stopCancellApi.current = false;
      setStopCancelled(false);
      handleResetAll();
    };
  }, []);
  // Fetch details whenever the jobcard id list changes (idempotent + deduped).
  useEffect(() => {
    if (!jobcardIds?.length) return;
    fetchJobcardDetailsIfNeeded(jobcardIds);
  }, [jobcardIds]);

  useEffect(() => {
    if (jobCardDetailsList && jobCardDetailsList.length !== 0) {
      if (jobCardDetailsList[jobIndex]) {
        if (solId == "1") {
          if (jobCardDetailsList[jobIndex].jobcard.solution_1.data.exception) {
            fetchOrders(
              "current_solution",
              jobCardDetailsList[jobIndex].jobcard,
            );
          } else {
            fetchOrders(
              "current_solution",
              jobCardDetailsList[jobIndex].jobcard,
              1,
            );
          }
        }
        if (solId == "2") {
          if (jobCardDetailsList[jobIndex].jobcard.solution_2.data.exception) {
            fetchOrders(
              "current_solution",
              jobCardDetailsList[jobIndex].jobcard,
            );
          } else {
            fetchOrders(
              "current_solution",
              jobCardDetailsList[jobIndex].jobcard,
              2,
            );
          }
        }

        if (solId == "3") {
          const newDetails =
            jobCardDetailsList[jobIndex]?.newlyCreatedJobCardsDetails?.[0];
          if (newDetails?.jobcard) {
            if (failedNewSol?.[jobIndex]) {
              fetchOrders(
                "current_solution",
                newDetails.jobcard,
              );
            } else if (
              newDetails.jobcard?.solution_1?.data?.exception
            ) {
              fetchOrders(
                "new_solution",
                newDetails.jobcard,
              );
            } else {
              fetchOrders(
                "new_solution",
                newDetails.jobcard,
                3,
              );
            }
          }
        }
        if (solId == "4") {
          const newDetails =
            jobCardDetailsList[jobIndex]?.newlyCreatedJobCardsDetails?.[0];
          if (!newDetails?.jobcard) return;

          if (newDetails.jobcard?.solution_2?.data?.exception) {
            fetchOrders("new_solution", newDetails.jobcard);
          } else {
            fetchOrders("new_solution", newDetails.jobcard, 4);
          }
        }
      } else {
        fetchOrders("current_solution", failedJobs[failedjobIndex]);
      }
    } else {
      if (failedJobs && failedJobs.length)
        fetchOrders("current_solution", failedJobs[failedjobIndex]);
    }
  }, [jobCardDetailsList, jobIndex, failedjobIndex, failedJobs, solId]);

  useEffect(() => {
    if (!failedGroups?.length) return;
    const t = setTimeout(() => {
      getFailedGroups({ failed_groups: failedGroups })
        .then((response) => {
          setFailedJobs(response);
        })
        .catch((error) =>
          console.log("Error Message in failed jobcards", error),
        );
    }, 9000);
    return () => clearTimeout(t);
  }, [failedGroups]);

  useEffect(() => {
    if (jobCardDetailsList?.length) {
      let jcData = [];
      let jcObj = {};
      jobCardDetailsList.map((item, index) => {
        jcObj = {};
        jcObj["id"] = item?.id;
        if (item?.isFailedJobcard) {
          if (
            item?.newlyCreatedJobCardsDetails?.length &&
            item?.isSuccessful &&
            item?.newlyCreatedJobCardsDetails[0]?.state == "pending"
          ) {
            jcObj["jc_code"] = item?.jc_code;
          } else {
            jcObj["jc_code"] = index + 1;
          }
        } else {
          if (item?.state == "pending") {
            jcObj["jc_code"] = item?.jc_code;
          } else {
            jcObj["jc_code"] = index + 1;
          }
        }
        jcData.push(jcObj);
      });
      // console.log(jcData);
      setJobcardIdsWithCode(jcData);
      if (currentActiveJC.current) {
        let currentJCCode = jcData.filter(
          (ele) => ele.id == currentActiveJC.current,
        );
        currentActiveJC.current = currentJCCode[0]?.id;
        setActiveJC(currentJCCode[0]?.jc_code);
      } else {
        let selectedData;
        if (jobcardIds.length) {
          selectedData = jcData?.filter((item) => item.id == jobcardIds[0]);
        } else {
          selectedData = jcData?.filter((item) => item.id == failedGroups[0]);
        }
        currentActiveJC.current = selectedData[0]?.id;
        setActiveJC(selectedData[0]?.jc_code);
      }
      // setActiveJC(jcData[0]?.jc_code);
      setRenderKey(false);
    }
  }, [jobcardIds, jobCardDetailsList, renderKey]);

  const columnsHead = [
    {
      title: "Po/So.No",
      dataIndex: "pono",
      width: "9%",
      fixed: "left",
      align: "center",
      render: (text, record) => {
        const value =
          record.category === "po"
            ? toHandlePOName(record.pono)
            : record.category === "so"
              ? toHandlePOName(record.sono)
              : toHandlePOName(record.pono);

        return (
          <span
            style={{
              whiteSpace: "normal",
              wordBreak: "break-word",
              lineHeight: "1.4",
            }}
          >
            {value?.match(/.{1,15}/g)?.map((chunk, index) => (
              <span key={index}>
                {chunk}
                <br />
              </span>
            ))}
          </span>
        );
      },
    },
    {
      title: "Order/Stock No",
      dataIndex: "orderno",
      width: "5%",
      fixed: "left",
    },
    {
      title: "Type",
      dataIndex: "type",
      width: "7%",
      fixed: "left",
    },
    {
      title: "Customer",
      dataIndex: "customer_alias",
      width: "10%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          {record.category === "so" ? (
            "-"
          ) : (
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={`${record.customercode}-${record.customername}`}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                {record?.customer_alias || "-"}
              </Tooltip>
            </Styled>
          )}
        </div>
      ),
    },
    {
      title: "Consignee",
      dataIndex: "consignee",
      width: "10%",
      render(text, record) {
        <span>{record.category === "so" ? "-" : record.consignee || "-"}</span>;
      },
    },
    {
      title: (
        <div>
          Product Spec
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={
                "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      dataIndex: "productspec",
      width: "14%",
    },
    {
      title: "Size(WxL)",
      dataIndex: "size",
      width: "9%",
    },

    // {
    //   title: "Planned Reels",
    //   dataIndex: "plannedReels",
    //   width: "8%",
    //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
    // },
    {
      title: "Planned Quantity",
      dataIndex: "plannedWeight",
      width: "10%",
    },
    // {
    //   title: "Fulfilled Reels",
    //   dataIndex: "fulflilledReels",
    //   width: "8%",
    //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
    // },
    {
      title: "Fulfilled Quantity",
      dataIndex: "fulflilledWeight",
      width: "10%",
    },
    {
      title: "REEL SPECIFICATION",
      dataIndex: "reelSpecification",
      width: "25%",
      render: (text) => (
        <div
          dangerouslySetInnerHTML={{
            __html: String(text).replace(/\n/g, "<br />"),
          }}
        />
      ),
    },
    // {
    //   title: "Type",
    //   dataIndex: "type",
    //   width: "5%",
    // },
    {
      title: "Del Date",
      dataIndex: "deliverydate",
      width: "10%",
    },
    // {
    //   title: "Remarks",
    //   dataIndex: "remarks",
    //   width: "9%",
    //   render: (text, record) => (
    //     <div className="actionBtn">
    //       <Styled>
    //         <Tooltip
    //           placement="bottomRight"
    //           title={record.remarks}
    //           className="edit-tooltip"
    //           getPopupContainer={(triggerNode) => triggerNode}
    //         >
    //           <Button style={{ cursor: "default" }}>
    //             <Iconmoon icon="message" size={16} color="#EA655B" />
    //           </Button>
    //         </Tooltip>
    //       </Styled>
    //     </div>
    //   ),
    //   align: "center",
    // },
    {
      title: "Actions",
      dataIndex: "action",
      width: "9%",
      render: (text, record) =>
        record.type === "Order" && (
          <div className="actionBtn">
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={"View details of this order"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button onClick={() => showViewDrawer(record.orderno, record)}>
                  <Iconmoon icon="file-view" size={16} color="#A19F9D" />
                </Button>
              </Tooltip>
            </Styled>
          </div>
        ),
      align: "center",
    },
  ];

  const orderFulfillmentColumnsHead = [
      {
        title: "Po/So.No",
        dataIndex: "pono",
        width: "8%",
        fixed: "left",
        align: "center",
        render: (text, record) => {
          const value =
            record.category === "po"
              ? toHandlePOName(record.pono)
              : record.category === "so"
              ? toHandlePOName(record.sono)
              : toHandlePOName(record.pono);
  
          return (
            <span
              style={{
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: "1.4",
              }}
            >
              {value?.match(/.{1,15}/g)?.map((chunk, index) => (
                <span key={index}>
                  {chunk}
                  <br />
                </span>
              ))}
            </span>
          );
        },
      },
      // {
      //   title: "Order No/Stock No",
      //   dataIndex: "orderno",
      //   width: "10%",
      //   fixed: "left",
      // },
      {
      title: (
        <div>
          Product Spec
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={
                "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      dataIndex: "productspec",
      width: "14%",
      },
      {
        title: "Size(WxL)",
        dataIndex: "size",
        width: "9%",
      },
      {
        title: "Planned Quantity",
        dataIndex: "plannedWeight",
        width: "10%",
      },
      {
        title: "Fulfilled Quanitity",
        dataIndex: "fulflilledWeight",
        width: "10%",
      },
      {
        title: "Overfulfilment %",
        dataIndex: "overfulfillmentPercentage",
        width: "10%",
      },
      {
        title: "REEL SPECIFICATION",
        dataIndex: "reelSpecification",
        width: "22%",
        render: (text) => (
          <div
            dangerouslySetInnerHTML={{
              __html: String(text).replace(/\n/g, "<br />"),
            }}
          />
        ),
      },
      {
        title: "Remarks",
        dataIndex: "remarks",
        width: "10%",
        render: (text, record) =>
          record.type === "Order" && (
            <div className="actionBtn">
              <Styled>
                <Tooltip
                  placement="bottomRight"
                  title={record.remarks}
                  className="edit-tooltip"
                  getPopupContainer={(triggerNode) => triggerNode}
                >
                  <Button style={{ cursor: "default" }}>
                    <Iconmoon icon="message" size={16} color="#EA655B" />
                  </Button>
                </Tooltip>
              </Styled>
            </div>
          ),
        align: "center",
      },
      {
        title: "Actions",
        dataIndex: "action",
        width: "10%",
        render: (text, record) =>
          record.type === "Order" && (
            <div className="actionBtn">
              <Styled>
                <Tooltip
                  placement="bottomRight"
                  title={"View details of this order"}
                  className="edit-tooltip"
                  getPopupContainer={(triggerNode) => triggerNode}
                >
                  <Button onClick={() => showViewDrawer(record.orderno, record)}>
                    <Iconmoon icon="file-view" size={16} color="#A19F9D" />
                  </Button>
                </Tooltip>
              </Styled>
            </div>
          ),
        align: "center",
      },
  ];

  const intermediateColumnsHead = [
    {
      title: "Sr.No",
      dataIndex: "srno",
      width: 6,
      fixed: "left",
      align: "center",
    },
    {
      title: "Reel Size",
      dataIndex: "reel_size",
      width: 8,
      fixed: "left",
      align: "center",
    },
    {
      title: "Order Size (WxL)",
      dataIndex: "order_size",
      width: 10,
      align: "center",
    },
    {
      title: "Matched Grain",
      dataIndex: "grain",
      width: 8,
      align: "center",
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      width: 8,
      align: "center",
    },
    {
      title: "REEL SPECIFICATION",
      dataIndex: "reelSpecification",
      width: 16,
      align: "center",
      render: (text) => (
        <div
          dangerouslySetInnerHTML={{
            __html: String(text).replace(/\n/g, "<br />"),
          }}
        />
      ),
    },
  ];

  const unfulfilledColumnsHead = [
    {
      title: "Po/So.No",
      dataIndex: "pono",
      width: "9%",
      fixed: "left",
      align: "center",
      render: (text, record) => {
        const value =
          record.category === "po"
            ? toHandlePOName(record.pono)
            : record.category === "so"
              ? toHandlePOName(record.sono)
              : toHandlePOName(record.pono);

        return (
          <span
            style={{
              whiteSpace: "normal",
              wordBreak: "break-word",
              lineHeight: "1.4",
            }}
          >
            {value?.match(/.{1,15}/g)?.map((chunk, index) => (
              <span key={index}>
                {chunk}
                <br />
              </span>
            ))}
          </span>
        );
      },
    },
    {
      title: "Order/Stock No",
      dataIndex: "orderno",
      width: "5%",
      fixed: "left",
    },
    {
      title: "Type",
      dataIndex: "type",
      width: "7%",
      fixed: "left",
    },
    {
      title: "Customer",
      dataIndex: "customer_alias",
      width: "10%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          {record.category === "so" ? (
            "-"
          ) : (
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={`${record.customercode}-${record.customername}`}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                {record?.customer_alias || "-"}
              </Tooltip>
            </Styled>
          )}
        </div>
      ),
    },
    {
      title: "Consignee",
      dataIndex: "consignee",
      width: "10%",
      render(text, record) {
        <span>{record.category === "so" ? "-" : record.consignee || "-"}</span>;
      },
    },
    {
      title: (
        <div>
          Product Spec
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={
                "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      dataIndex: "productspec",
      width: "14%",
    },
    {
      title: "Size(WxL)",
      dataIndex: "size",
      width: "9%",
    },
    // {
    //   title: "Planned Reels",
    //   dataIndex: "plannedReels",
    //   width: "8%",
    //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
    // },
    {
      title: "Planned Quantity",
      dataIndex: "plannedWeight",
      width: "10%",
    },
    // {
    //   title: "Unfulfilled Reels",
    //   dataIndex: "unFulflilledReels",
    //   width: "8%",
    //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
    // },
    {
      title: "Unfulfilled Quantity",
      dataIndex: "unFulflilledWeight",
      width: "10%",
    },
    // {
    //   title: "Type",
    //   dataIndex: "type",
    //   width: "5%",
    // },
    {
      title: "Del Date",
      dataIndex: "deliverydate",
      width: "10%",
    },
    // {
    //   title: "Remarks",
    //   dataIndex: "remarks",
    //   width: "9%",
    //   render: (text, record) => (
    //     <div className="actionBtn">
    //       <Styled>
    //         <Tooltip
    //           placement="bottomRight"
    //           title={record.remarks}
    //           className="edit-tooltip"
    //           getPopupContainer={(triggerNode) => triggerNode}
    //         >
    //           <Button style={{ cursor: "default" }}>
    //             <Iconmoon icon="message" size={16} color="#EA655B" />
    //           </Button>
    //         </Tooltip>
    //       </Styled>
    //     </div>
    //   ),
    //   align: "center",
    // },
    {
      title: "Actions",
      dataIndex: "action",
      width: "10%",
      render: (text, record) =>
        record.type === "Order" && (
          <div className="actionBtn">
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={"View details of this order"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button onClick={() => showViewDrawer(record.orderno, record)}>
                  <Iconmoon icon="file-view" size={16} color="#A19F9D" />
                </Button>
              </Tooltip>
            </Styled>
          </div>
        ),
      align: "center",
    },
  ];

  const sizeFulfillmentColumnsHead = [
    {
      title: "Sr.No",
      dataIndex: "key",
      width: "7%",
      fixed: "left",
      align: "center",
    },
    // {
    //   title: "Type",
    //   dataIndex: "type",
    //   width: "7%",
    //   fixed: "left",
    // },
    {
      title: "Size(WxL)",
      dataIndex: "size",
      width: "9%",
    },
    {
      title: "Planned Quantity",
      dataIndex: "plannedWeight",
      width: "10%",
    },
    {
      title: "Fulfilled Quantity",
      dataIndex: "fulflilledWeight",
      width: "10%",
    },
    {
      title: "UnFulfilled/(Overfulfilled) Quantity",
      dataIndex: "unFulflilledWeight",
      width: "12%",
      render: (text, record) => {
        const parsedValue = parseFloat(text?.split(" ")[0]);
        const positiveValue = Math.abs(parsedValue);
        return parsedValue < 0 ? (
          <div>
            ({positiveValue} {text?.split(" ")[1]})
          </div>
        ) : (
          text
        );
      },
    },
    {
      title: "REEL SPECIFICATION",
      dataIndex: "reelSpecification",
      width: "25%",
      render: (text) => (
        <div
          dangerouslySetInnerHTML={{
            __html: String(text).replace(/\n/g, "<br />"),
          }}
        />
      ),
    },
    // {
    //   title: "Planned Reels",
    //   dataIndex: "plannedReels",
    //   width: "8%",
    //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
    // },
    // {
    //   title: "Fulfilled Reels",
    //   dataIndex: "fulflilledReels",
    //   width: "8%",
    //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
    // },
    // {
    //   title: "Unfulfilled Reels",
    //   dataIndex: "unFulflilledReels",
    //   width: "8%",
    //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
    // },
  ];

  const onClickCreateSolution = async (e, jobCardId, uuid, ind) => {
    setActiveTab("1");
    setSizeExpanded(false);
    setSizeExpanded(false);
    setSizeExpanded(false);
    setSizeExpanded(false);
    const pendingParentId = getNewSolutionParentJobcardId(jobCardId);
    const baselineNewId =
      jobCardDetailsList?.[jobIndex]?.newlyCreatedJobCardsDetails?.[0]?.id ??
      jobCardDetailsList?.[jobIndex]?.id ??
      null;
    resetNewSolutionPollStateForParent(pendingParentId, baselineNewId, jobIndex);
    setShowAimation((prev) => ({ ...prev, [jobIndex]: true }));
    let sizes = [];
    setCreateNewSolutionFormValuesByJobCard((prev) => ({
      ...prev,
      [jobCardId]: e,
    }));
    if (e.selectedSizes.length > 0) {
      e.selectedSizes.forEach((size) => {
        let sizeObject = {
          id: size.stockSizeId,
          size: parseFloat(size.stockSize),
          allowed_quantity: parseFloat(size.allowedQuantity),
          planned_weight: parseFloat(size.plannedWeight),
          units: size.units,
          creation_type: size.creation_type,
          ...(size.creation_type == "required" && {
            weight_lb: size.weight_lb,
            weight_ub: size.weight_ub,
            priority_stock: size.priority_stock,
          }),
          type: "reel",
        };
        sizes.push(sizeObject);
      });
    }

    let updatedFormValues = {};
    updatedFormValues["max_deckle_length"] = e.maxDeckleLength
      ? parseFloat(e.maxDeckleLength)
      : formValuesForStock?.[jobIndex]?.max_deckle_length;
    updatedFormValues["min_deckle_length"] = e.minDeckleLength
      ? parseFloat(e.minDeckleLength)
      : formValuesForStock?.[jobIndex]?.min_deckle_length;
    updatedFormValues["left_edge_trim"] = e.minWidth
      ? parseFloat(e.minWidth)
      : formValuesForStock?.[jobIndex]?.left_edge_trim;
    updatedFormValues["right_edge_trim"] = e.maxWidth
      ? parseFloat(e.maxWidth)
      : formValuesForStock?.[jobIndex]?.right_edge_trim;
    updatedFormValues["maximum_cutters"] = e.cutters
      ? parseFloat(e.cutters)
      : formValuesForStock?.[jobIndex]?.maximum_cutters;
    updatedFormValues["effective_deckle_length"] = e.cutters
      ? parseFloat(e.effectiveDeckleLength)
      : "";
    updatedFormValues["units"] = {
      max_deckle_length: e.deckleLengthUnit,
      min_deckle_length: e.deckleLengthUnit,
      left_edge_trim: e.widthUnit,
      right_edge_trim: e.widthUnit,
      effective_deckle_length: e.effectiveDeckleLengthUnit,
      deckle_size_lb: e.deckleLengthUnit,
      deckle_size_ub: e.deckleLengthUnit,
    };
    setFormValuesForStock({
      ...formValuesForStock,
      [jobIndex]: updatedFormValues,
    });

    let request = {
      jobcard: getNewSolutionParentJobcardId(jobCardId),
      run_type: "selected_sizes",
      machine_selection_data: {
        maximum_deckle_size: e.maxDeckleLength
          ? parseFloat(e.maxDeckleLength)
          : formValuesForStock?.[jobIndex]?.max_deckle_length,
        minimum_deckle_size: e.minDeckleLength
          ? parseFloat(e.minDeckleLength)
          : formValuesForStock?.[jobIndex]?.min_deckle_length,
        left_edge_trim: e.minWidth
          ? parseFloat(e.minWidth)
          : formValuesForStock?.[jobIndex]?.left_edge_trim,
        right_edge_trim: e.maxWidth
          ? parseFloat(e.maxWidth)
          : formValuesForStock?.[jobIndex]?.right_edge_trim,
        maximum_cutters: e.cutters
          ? parseFloat(e.cutters)
          : formValuesForStock?.[jobIndex]?.maximum_cutters,
        effective_deckle_length: e.effectiveDeckleLength
          ? parseFloat(e.effectiveDeckleLength)
          : "",
        units: {
          maximum_deckle_size: e.deckleLengthUnit,
          minimum_deckle_size: e.deckleLengthUnit,
          left_edge_trim: e.widthUnit,
          right_edge_trim: e.widthUnit,
          effective_deckle_length: e.effectiveDeckleLengthUnit,
        },
      },
      sizes: sizes,
      optimize_unique_partitions: optimizePartition,
      minimize_overfulfillment: minimizeOverfulfillment,
    };
    // Keep the current newlyCreatedJobCardsDetails visible until the ready
    // API/polling returns the new job id. This avoids UI flicker/crashes.
    try {
      // This API triggers async creation; it does not return the jobcard data immediately.
      await createNewSolution(request);
      // allow user to start new solution for other jobcards while this one cooks
      setCreateNewSolutionClicked({ isClicked: false, index: -1 });
      newSolutionPollingActiveRef.current = true;
      setIsNewSolutionPolling(true);
      newSolutionPendingParentsRef.current = isReplanMode
        ? new Set([pendingParentId])
        : new Set([
            ...(newSolutionPendingParentsRef.current || new Set()),
            pendingParentId,
          ]);
      pollReadyNewSolutionOnce();
      // setShowAimation(false);
      setFailedNewSol((prev) => {
        return { ...prev, [jobIndex]: false };
      });
    } catch (error) {
      let jobcardResp = [];

      let jobCard = await getAlgorithmCompletionStatus();
      let response = await getFailedGroups({
        failed_groups: jobCard.data.failed_groups,
      });

      // setShowAimation(false);
      let detailsList = jobCardDetailsList;
      let filteredJobCardIndex = detailsList.findIndex(
        function (jobCardDetails) {
          return jobCardDetails.uuid == uuid;
        },
      );

      let data = {
        orders: [],
        partitions: [],
        sizes: [],
        summary: {},
      };

      let jobcardData = {
        created_at: response[0].created_at,
        uuid: response[0].uuid,
        id: response[0].id,
        user_id: response[0].user_id,
        updated_at: response[0].updated_at,
        jobcard: {
          group: response[0].group,
          solution_1: { data },
          solution_2: { data },
        },
      };
      jobcardResp.push(jobcardData);
      // console.log(jobcardData)
      detailsList[filteredJobCardIndex]["newlyCreatedJobCardsDetails"] =
        jobcardResp;
      setJobCardDetailsList(detailsList);
      setSolId("3");
      setSolutionId("3");
      // fetchOrders("current_solution", jobcardData.jobcard);
      // console.log(detailsList)
      setFailedNewSol((prev) => {
        return { ...prev, [jobIndex]: true };
      });
      // setRerendering(!rerendering);
      setCreateNewSolutionClicked({ isClicked: false, index: -1 });
    } finally {
      setCreateNewSolutionClicked({ isClicked: false, index: -1 });
      setTimeout(() => {
        setShowAimation((prev) => {
          const pending = newSolutionPendingParentsRef.current;
          const pendingParentId = getNewSolutionParentJobcardId(jobCardId);
          if (pending && pending.has(pendingParentId)) return prev;
          return { ...prev, [jobIndex]: false };
        });
      }, 4000);
    }
  };

  const setActiveKey = (activeKey) => {
    setSolutionId(activeKey);
    setSolId(activeKey);
    setPageSize(10);
    setCurrentPage(1);
  };
  const tabChange = (key) => {
    setCurrentPage(1);
    setPageSize(10);
    setActiveTab(key);
  };

  return !isLoading ? (
    totalGroups && (
      <RightLayoutContainer>
        <PageTitleComp>
          <PageHeader
            ghost={false}
            title="Deckle Match Results"
            extra={
              !createNewSolutionClicked.isClicked && [
                <Button
                  key="1"
                  className="themeBtn noBg noMargin"
                  onClick={routeChange}
                >
                  Go Back
                </Button>,
              ]
            }
          ></PageHeader>
        </PageTitleComp>

        {/* if failed groups are empty and total groups are not same as jobcards */}
        {failedGroups.length + jobcardIds.length != totalGroups &&
          location?.state?.type !== "replan" && (
            <div className="failedProgress">
              <span className="failedJobMessage">
                {jobcardIds.length + failedGroups.length} out of {totalGroups}{" "}
                Job Cards are generated, &nbsp;
                {totalGroups - (jobcardIds.length + failedGroups.length)} job
                cards are still in process
              </span>
              <Progress
                percent={
                  ((jobcardIds.length + failedGroups.length) / totalGroups) *
                  100
                }
                showInfo={false}
              />
            </div>
          )}
        {/* if failed groups and jobcards are eaul to total passed groups ? */}
        {failedGroups.length + jobcardIds.length == totalGroups &&
          location?.state?.type !== "replan" && (
            <div className="failedProgress">
              <span className="failedJobMessage">
                All {totalGroups} Job Cards are generated
              </span>
              <Progress
                percent={
                  ((jobcardIds.length + failedGroups.length) / totalGroups) *
                  100
                }
                showInfo={false}
              />
            </div>
          )}

        <ResultWrap1>
          <DetailFields>
            {(jobCardDetailsList || failedJobs) && (
              <Tabs
                // defaultActiveKey={0}
                defaultActiveKey={
                  // jobcardIds.length
                  //   ? jobcardIds[0]?.toString()
                  //   : failedGroups[0]?.toString()
                  "compare"
                }
                // activeKey={activeKey}
                tabPosition="left"
                className="leftPostTab"
                onChange={callbackKey}
                style={{ backgroundColor: "#faf9f8" }}
              >
                {jobCardDetailsList &&
                  jobCardDetailsList?.map((job, index) => (
                    <TabPane
                      // key={index}
                      key={job.id}
                      style={{
                        backgroundColor: "#ffffff",
                        borderLeft: "1px solid #ebebeb",
                      }}
                      tab={
                        <div className="deckleMatchIcon disabled">
                          <img
                            src={
                              job.jobcard.solution_1.status === "accept" ||
                              job.jobcard.solution_2.status === "accept" ||
                              (job.newlyCreatedJobCardsDetails &&
                                job.newlyCreatedJobCardsDetails.length &&
                                job.newlyCreatedJobCardsDetails[0].jobcard
                                  .solution_1.status === "accept") ||
                              (job.newlyCreatedJobCardsDetails &&
                                job.newlyCreatedJobCardsDetails.length &&
                                job.newlyCreatedJobCardsDetails[0].jobcard
                                  .solution_2.status === "accept")
                                ? alerttrue
                                : job.jobcard.solution_1.status === "reject" &&
                                    job.jobcard.solution_2.status ===
                                      "reject" &&
                                    job.newlyCreatedJobCardsDetails &&
                                    job.newlyCreatedJobCardsDetails.length &&
                                    job.newlyCreatedJobCardsDetails[0].jobcard
                                      .solution_1.status === "reject" &&
                                    job.newlyCreatedJobCardsDetails &&
                                    job.newlyCreatedJobCardsDetails.length &&
                                    job.newlyCreatedJobCardsDetails[0].jobcard
                                      .solution_2.status === "reject"
                                  ? wrongIco
                                  : job.jobcard.solution_1.data.exception ||
                                      job.jobcard.solution_2.data.exception ||
                                      (job.newlyCreatedJobCardsDetails &&
                                        job.newlyCreatedJobCardsDetails
                                          .length &&
                                        job.newlyCreatedJobCardsDetails[0]
                                          .jobcard.solution_1.data.exception) ||
                                      (job.newlyCreatedJobCardsDetails &&
                                        job.newlyCreatedJobCardsDetails
                                          .length &&
                                        job.newlyCreatedJobCardsDetails[0]
                                          .jobcard.solution_2.data.exception)
                                    ? warningjob
                                    : vectorIco
                            }
                          />
                          {/* {job?.jc_code ? job?.jc_code : ("JC " + (index+1))} */}
                                                {console.log("Job",job)}
                          {job?.jc_code ? (
                            job?.jc_code?.length > 20 ? (
                              <Tooltip
                                placement="bottomLeft"
                                title={job?.jc_code}
                              >
                                {job?.jc_code?.slice(0, 21) + "..."}
                              </Tooltip>
                            ) : (
                              job?.jc_code
                            )
                          ) : (
                            "JC " + (index + 1)
                          )}
                        </div>
                      }
                    >
                      {createNewSolutionClicked.isClicked &&
                      createNewSolutionClicked.index == index ? (
                        !showAimation[jobIndex] &&
                        jobCardDetailsList?.[jobIndex] ? (
                          <CreateNewSolution
                            onClickCreateSolution={(e) =>
                              onClickCreateSolution(
                                e,
                                jobCardDetailsList[jobIndex].id,
                                jobCardDetailsList[jobIndex].uuid,
                                index,
                              )
                            }
                            formValuesForStock={formValuesForStock?.[jobIndex]}
                            // job.jobcard.group.grouping_params.core_id
                            jobCardDetails={
                              jobCardDetailsList[jobIndex].jobcard
                            }
                            backButtonClicked={() => {
                              setCreateNewSolutionClicked({
                                isClicked: false,
                                index: -1,
                              });
                              setRerender(!rerender);
                              // setActiveTab('compare');
                              setSolId("compare");
                            }}
                            stockSizesArray={
                              stockSizesByJobCard[jobCardDetailsList[jobIndex].id] || []
                            }
                            setStockSizesArray={(updatedStockSizes) => {
                              const selectedJobCardId = jobCardDetailsList[jobIndex]?.id;
                              if (!selectedJobCardId) return;
                              setStockSizesByJobCard((prev) => ({
                                ...prev,
                                [selectedJobCardId]:
                                  typeof updatedStockSizes === "function"
                                    ? updatedStockSizes(prev[selectedJobCardId] || [])
                                    : updatedStockSizes,
                              }));
                            }}
                            createNewSolutionFormValuesForSizes={
                              createNewSolutionFormValuesByJobCard[
                                jobCardDetailsList[jobIndex].id
                              ]
                            }
                            unselectedOrders={
                              jobCardDetailsList[jobIndex]
                                ?.newlyCreatedJobCardsDetails
                                ? jobCardDetailsList[jobIndex]
                                    ?.newlyCreatedJobCardsDetails[0]?.jobcard
                                    ?.group?.unselected_orders
                                : jobCardDetailsList[jobIndex]?.jobcard?.group
                                    ?.unselected_orders
                            }
                            ordersIdList={currentOrdersIdList}
                            updateOrdersIdList={(updatedOrdersIdList) => {
                              const activeJobCardId = jobCardDetailsList[jobIndex]?.id;
                              if (!activeJobCardId) return;
                              setOrdersIdListByJobCard((prev) => ({
                                ...prev,
                                [activeJobCardId]:
                                  typeof updatedOrdersIdList === "function"
                                    ? updatedOrdersIdList(prev[activeJobCardId] || [])
                                    : updatedOrdersIdList,
                              }));
                            }}
                            optimizePartition={optimizePartition}
                            minimizeOverfulfillment={minimizeOverfulfillment}
                            onOptimizePartitionChange={
                              handleOptimizePartitionChange
                            }
                            onMinimizeOverfulfillmentChange={
                              handleMinimizeOverfulfillmentChange
                            }
                            machineData={location.state.body}
                            jobId={jobCardDetailsList[jobIndex].id}
                            solutionId={solutionId}
                            completeJCDetails={jobCardDetailsList[jobIndex]}
                            dummy_orders={location.state.isDummyJC}
                            so_number={location.state.so}
                          ></CreateNewSolution>
                        ) : (
                          <RightLayoutContainer>
                            <ContentMiddle>
                              <div className="imageAnimate">
                                <div className="imageCover">
                                  <LottieAnimation lotti={JobcardPrepare} />
                                  <p>
                                    Our algorithms are cooking a job card for
                                    you <br />
                                    please wait, it will take less than a minute
                                  </p>
                                </div>
                              </div>
                            </ContentMiddle>
                          </RightLayoutContainer>
                        )
                      ) : showAimation[jobIndex] ? (
                        <RightLayoutContainer>
                          <ContentMiddle>
                            <div className="imageAnimate">
                              <div className="imageCover">
                                <LottieAnimation lotti={JobcardPrepare} />
                                <p>
                                  Our algorithms are cooking a job card for you{" "}
                                  <br />
                                  please wait, it will take less than a minute
                                </p>
                              </div>
                            </div>
                          </ContentMiddle>
                        </RightLayoutContainer>
                      ) : (
                        <>
                          {index === jobIndex && (
                            <Tabs
                              defaultActiveKey="compare"
                              className="topPostTab"
                              onChange={(activeKey) => {
                                setActiveTab("1");
                                setSizeExpanded(false);
                                setSizeExpanded(false);
                                setSizeExpanded(false);
                                setSizeExpanded(false);
                                setActiveKey(activeKey);
                              }}
                              activeKey={solId}
                              tabBarExtraContent={
                                !(
                                  jobCardDetailsList[jobIndex]?.jobcard
                                    .solution_1.status === "accept" ||
                                  jobCardDetailsList[jobIndex]?.jobcard
                                    .solution_2.status === "accept" ||
                                  jobCardDetailsList[jobIndex]
                                    ?.newlyCreatedJobCardsDetails?.[0]
                                    ?.jobcard?.solution_1?.status === "accept" ||
                                  jobCardDetailsList[jobIndex]
                                    ?.newlyCreatedJobCardsDetails?.[0]
                                    ?.jobcard?.solution_2?.status === "accept"
                                ) &&
                                currentOrdersIdList.length > 0 &&
                                solId !== "compare" && (
                                  <Button
                                    key="5"
                                    className="textTypeBtn"
                                    onClick={() =>
                                      onClickCreateNewSolution(index)
                                    }
                                    disabled={!userDetails.roles.job_cards.edit}
                                    style={{ marginBottom: "3px" }}
                                  >
                                    <Iconmoon
                                      icon="addcircle"
                                      size={14}
                                      color="#ea655b"
                                      style={{
                                        paddingTop: "2px",
                                        marginRight: "3px",
                                      }}
                                    />
                                    Create New Solution
                                  </Button>
                                )
                              }
                            >
                              {/* Compare solution tab */}
                              {
                                <Panes tab="Compare Solution" key="compare">
                                  <SolutionContainer>
                                    {/* <div className="MatchResult"> */}
                                    <CreateNewSolCompare
                                      summary={compareSolSummaryData}
                                      newSummaryData={newCompareSolSummaryData}
                                      onAccept={acceptModalShow}
                                      setSolutionId={setSolutionId}
                                      jobIndex={jobIndex}
                                    />
                                    {/* </div> */}
                                  </SolutionContainer>
                                </Panes>
                              }
                              {job.jobcard.solution_1.data.summary &&
                                job.jobcard.solution_2.status != "accept" &&
                                job?.newlyCreatedJobCardsDetails?.[0]?.jobcard
                                  ?.solution_1.status != "accept" &&
                                job?.newlyCreatedJobCardsDetails?.[0]?.jobcard
                                  ?.solution_2.status != "accept" && (
                                  <Panes
                                    tab="Solution 1"
                                    key={
                                      job.jobcard.solution_1.status === "accept"
                                        ? "1"
                                        : "1"
                                    }
                                  >
                                    <PageTitleComp
                                      style={{ borderBottom: "0" }}
                                    >
                                      <PageHeader
                                        ghost={false}
                                        title={
                                          <div
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "50px",
                                            }}
                                          >
                                            <span>
                                              {job.state == "pending"
                                                ? activeJC &&
                                                  activeJC != undefined
                                                  ? activeJC
                                                  : ""
                                                : "Job Card " +
                                                  (activeJC &&
                                                  activeJC != undefined
                                                    ? activeJC
                                                    : "")}
                                            </span>
                                            {/* {job.state == "pending" ? (
                                        (activeJC?.length > 20 ? (
                                          <Tooltip placement="bottomLeft" title={activeJC}>
                                            {activeJC?.slice(0,21)+"..."}
                                          </Tooltip>
                                          ) : (
                                            activeJC
                                        ))
                                        ) : (
                                        ("Job Card " + activeJC)
                                        )
                                      } */}
                                          </div>
                                        }
                                        extra={
                                          !job.jobcard.solution_1.data
                                            .exception && [
                                            job.jobcard.solution_1.status ===
                                            "accept" ? (
                                              <AlertContainer
                                                color="green"
                                                icon={alertGreen}
                                                msg="The solution is sent for approval"
                                              />
                                            ) : job.jobcard.solution_1
                                                .status === "reject" ? (
                                              job.jobcard.solution_2.status ===
                                              "accept" ? (
                                                <AlertContainer
                                                  color="green"
                                                  icon={alertGreen}
                                                  msg="The solution 2 is already accepted"
                                                />
                                              ) : job.newlyCreatedJobCardsDetails &&
                                                job
                                                  .newlyCreatedJobCardsDetails[0]
                                                  ?.jobcard?.solution_1
                                                  .status === "accept" ? (
                                                <AlertContainer
                                                  color="green"
                                                  icon={alertGreen}
                                                  msg="The new solution 1 is already accepted"
                                                />
                                              ) : job.newlyCreatedJobCardsDetails &&
                                                job
                                                  .newlyCreatedJobCardsDetails[0]
                                                  .jobcard.solution_2.status ===
                                                  "accept" ? (
                                                <AlertContainer
                                                  color="green"
                                                  icon={alertGreen}
                                                  msg="The new solution 2 is already accepted"
                                                />
                                              ) : (
                                                <AlertContainer
                                                  color="red"
                                                  icon={alertRed}
                                                  msg="The solution is discarded by the user"
                                                />
                                              )
                                            ) : (
                                              <RightSideSolution>
                                                <div className="rightSideSolutionButtons">
                                                  <Button
                                                    key="1"
                                                    className="themeBtn noBg"
                                                    onClick={() =>
                                                      discardModalShow(
                                                        "solution1",
                                                      )
                                                    }
                                                    disabled={
                                                      !userDetails.roles
                                                        .job_cards.edit
                                                    }
                                                  >
                                                    <Iconmoon
                                                      icon="wrong"
                                                      size={14}
                                                      color="#EA4E2C"
                                                    />
                                                    Discard Solution
                                                  </Button>
                                                  <Button
                                                    key="2"
                                                    className="themeBtn"
                                                    onClick={() =>
                                                      acceptModalShow(
                                                        "solution1",
                                                      )
                                                    }
                                                    disabled={
                                                      !userDetails.roles
                                                        .job_cards.edit
                                                    }
                                                  >
                                                    <Iconmoon
                                                      icon="correct"
                                                      size={14}
                                                      color="#ffffff"
                                                    />
                                                    Accept Solution
                                                  </Button>
                                                </div>
                                              </RightSideSolution>
                                            ),
                                          ]
                                        }
                                      ></PageHeader>
                                    </PageTitleComp>
                                    <div className="MatchResult">
                                      <Row
                                        span={24}
                                        className="pipeBlockCylinder"
                                      >
                                        {((!sizeExpanded && activeTab == "2") ||
                                          (!sizeExpanded && activeTab == "3") ||
                                          (!sizeExpanded && activeTab == "4") ||
                                          (!sizeExpanded && activeTab == "5") ||
                                          activeTab == "1") && (
                                          <Col
                                            span={15}
                                            className="pipeBlock"
                                            style={{ paddingRight: "20px" }}
                                          >
                                            <RightSideSolution>
                                              {!job.jobcard.solution_1.data
                                                .exception ? (
                                                // jobCardDetailsList &&
                                                <JobCardCylinderContainer
                                                  jobId={job.jobcard.solution_1.status === "accept" && location?.state?.type === "replan" ? location?.state?.parentJCid : job.id}
                                                  solution={1}
                                                  multiView={true}
                                                  deckle_match_page={true}
                                                  // style={{width:'80%'}}
                                                  solId={solId}
                                                />
                                              ) : (
                                                <>
                                                  <div className="deckleCoverImage">
                                                    <img
                                                      src={deckleCover}
                                                      alt="deckle match result"
                                                    />
                                                  </div>
                                                  {/* Exception message */}
                                                  <div className="colLayoutBlock deckleErrorLayout">
                                                    <p
                                                      style={{
                                                        color: "#EA655B",
                                                      }}
                                                    >
                                                      {
                                                        job.jobcard.solution_1
                                                          .data.exception
                                                      }
                                                    </p>
                                                  </div>
                                                </>
                                              )}
                                            </RightSideSolution>
                                          </Col>
                                        )}
                                        <Col
                                          span={
                                            ((sizeExpanded &&
                                              activeTab == "2") ||
                                              (sizeExpanded &&
                                                activeTab == "3") ||
                                              (sizeExpanded &&
                                                activeTab == "4") ||
                                              (sizeExpanded &&
                                                activeTab == "5")) &&
                                            activeTab != "1"
                                              ? 24
                                              : 9
                                          }
                                          className="colLayoutBlock"
                                        >
                                          <Tabs
                                            defaultActiveKey={activeTab}
                                            activeKey={activeTab}
                                            className="topPostTab innerPostTab"
                                            onChange={tabChange}
                                          >
                                            <Panes
                                              tab="Solution 1 summary"
                                              key="1"
                                              // disabled={solutionSummary?.solution1.exception}
                                            >
                                              <div className="lossValue">
                                                {!job.jobcard.solution_1.data
                                                  .exception && (
                                                  <>
                                                    <Row span={24}>
                                                      <Col span={12}>
                                                        <div className="summaryValue">
                                                          <h5>
                                                            <span className="trimCut"></span>{" "}
                                                            Trim Loss
                                                          </h5>
                                                          <span>
                                                            {`${job?.jobcard?.solution_1?.data?.summary?.match_trim_loss_percentage?.toFixed(
                                                              3,
                                                            )} %`}
                                                          </span>
                                                          {
                                                            // job.jobcard.solution_1.data.summary
                                                            //   .max_fulfilled_orders_match_trim_loss_comparison_pp ? (
                                                            job.jobcard
                                                              ?.comparison?.[
                                                              matchTrimLossKey
                                                            ] > 0 ? (
                                                              <span className="lesserSolution">
                                                                <img
                                                                  src={
                                                                    greaterRange
                                                                  }
                                                                  style={{
                                                                    marginRight:
                                                                      "10px",
                                                                  }}
                                                                />
                                                                {job.jobcard
                                                                  ?.comparison?.[
                                                                  matchTrimLossKey
                                                                ]
                                                                  ? Math.abs(
                                                                      job
                                                                        .jobcard
                                                                        ?.comparison?.[
                                                                        matchTrimLossKey
                                                                      ],
                                                                    )?.toFixed(
                                                                      3,
                                                                    )
                                                                  : 0}{" "}
                                                                % pts greater
                                                                than sol 2
                                                              </span>
                                                            ) : (
                                                              <span className="lesserSolution">
                                                                <img
                                                                  src={
                                                                    lowerRange
                                                                  }
                                                                  style={{
                                                                    marginRight:
                                                                      "10px",
                                                                  }}
                                                                />
                                                                {job.jobcard
                                                                  ?.comparison?.[
                                                                  matchTrimLossKey
                                                                ]
                                                                  ? Math.abs(
                                                                      job
                                                                        .jobcard
                                                                        ?.comparison?.[
                                                                        matchTrimLossKey
                                                                      ],
                                                                    )?.toFixed(
                                                                      3,
                                                                    )
                                                                  : 0}{" "}
                                                                % pts lesser
                                                                than sol 2
                                                              </span>
                                                            )
                                                            // ) : (
                                                            //   <></>
                                                            // )
                                                          }
                                                        </div>
                                                      </Col>

                                                      <Col span={12}>
                                                        <div className="summaryValue">
                                                          <h5>
                                                            <span className="trimBox"></span>{" "}
                                                            Fulfillment
                                                          </h5>
                                                          <span>
                                                            {`${job.jobcard.solution_1?.data?.summary?.requirement_fulfilled_percentage?.toFixed(
                                                              3,
                                                            )} %`}
                                                          </span>
                                                          {
                                                            // job.jobcard.solution_1.data.summary
                                                            //   .max_fulfilled_orders_requirement_fulfillment_comparison_pp ? (
                                                            job.jobcard
                                                              ?.comparison?.[
                                                              matchFulfilmentKey
                                                            ] > 0 ? (
                                                              <span className="lesserSolution">
                                                                <img
                                                                  src={
                                                                    greaterRange
                                                                  }
                                                                  style={{
                                                                    marginRight:
                                                                      "10px",
                                                                  }}
                                                                />
                                                                {job.jobcard
                                                                  ?.comparison?.[
                                                                  matchFulfilmentKey
                                                                ]
                                                                  ? Math.abs(
                                                                      job
                                                                        .jobcard
                                                                        ?.comparison?.[
                                                                        matchFulfilmentKey
                                                                      ],
                                                                    )?.toFixed(
                                                                      3,
                                                                    )
                                                                  : 0}{" "}
                                                                % pts greater
                                                                than sol 2
                                                              </span>
                                                            ) : (
                                                              <span className="lesserSolution">
                                                                <img
                                                                  src={
                                                                    lowerRange
                                                                  }
                                                                  style={{
                                                                    marginRight:
                                                                      "10px",
                                                                  }}
                                                                />
                                                                {job.jobcard
                                                                  ?.comparison?.[
                                                                  matchFulfilmentKey
                                                                ]
                                                                  ? Math.abs(
                                                                      job
                                                                        .jobcard
                                                                        ?.comparison?.[
                                                                        matchFulfilmentKey
                                                                      ],
                                                                    )?.toFixed(
                                                                      3,
                                                                    )
                                                                  : 0}{" "}
                                                                % pts lesser
                                                                than sol 2
                                                              </span>
                                                            )
                                                            // ) : (
                                                            //   <></>
                                                            // )
                                                          }
                                                        </div>
                                                      </Col>
                                                    </Row>
                                                    <Row span={24}>
                                                      <Col span={12}>
                                                        <div className="summaryValue">
                                                          <h5>
                                                            <span className="trimCut"></span>{" "}
                                                            Net Trim Loss:{" "}
                                                            {job.jobcard?.solution_1?.data?.summary?.net_trim_loss_percentage?.toFixed(
                                                              3,
                                                            )}{" "}
                                                            %
                                                            <p>
                                                              Loss including
                                                              edge trim
                                                            </p>
                                                          </h5>
                                                        </div>
                                                      </Col>
                                                      <Col span={12}>
                                                        <div className="summaryValue">
                                                          <h5>
                                                            <span className="trimBox"></span>{" "}
                                                            Weight:{" "}
                                                            {job.jobcard.solution_1.data.summary.job_card_weight?.toFixed(
                                                              3,
                                                            )}{" "}
                                                            {capitalize(
                                                              weightUnit[
                                                                job.jobcard
                                                                  .solution_1
                                                                  .data.summary
                                                                  .units
                                                                  ?.job_card_weight
                                                              ]?.displayName,
                                                            )}
                                                            <p className="lesserSolution">
                                                              Total weight of
                                                              Job Card
                                                            </p>
                                                          </h5>
                                                        </div>
                                                      </Col>
                                                    </Row>
                                                  </>
                                                )}
                                                <Row span={24}>
                                                  <Col span={12}>
                                                    <ul>
                                                      <li>
                                                        <span>
                                                          Paper Machine
                                                        </span>
                                                        <p>
                                                          {
                                                            job.jobcard.group
                                                              .machines[0].name
                                                          }
                                                        </p>
                                                      </li>{" "}
                                                      <li>
                                                        <span>Ply</span>
                                                        <p>{job.ply}</p>
                                                      </li>
                                                      <li>
                                                        <span>
                                                          Deckle Width
                                                        </span>
                                                        <p>{`${(
                                                          job.jobcard.group
                                                            .machines[0]
                                                            .deckle_size_ub +
                                                          (job.jobcard.group
                                                            .machines[0]
                                                            .left_edge_trim +
                                                            job.jobcard.group
                                                              .machines[0]
                                                              .right_edge_trim) *
                                                            CoversionFactorUnitsToCM[
                                                              job.jobcard.group
                                                                .machines[0]
                                                                .units
                                                                ?.right_edge_trim
                                                            ] *
                                                            CoversionFactorCMToUnits[
                                                              job.jobcard.group
                                                                .machines[0]
                                                                .units
                                                                ?.deckle_size_ub
                                                            ]
                                                        )?.toFixed(
                                                          3,
                                                        )} - ${job.jobcard.group.machines[0]?.deckle_size_lb?.toFixed(
                                                          3,
                                                        )} ${lengthUnit[
                                                          job.jobcard.group
                                                            .machines[0].units
                                                            ?.deckle_size_ub
                                                        ]?.displayName.toUpperCase()}`}</p>
                                                      </li>
                                                      <li>
                                                        <span>
                                                          Edge Trim ( Left /
                                                          Right )
                                                        </span>
                                                        <p>{`${
                                                          job.jobcard.group
                                                            .machines[0]
                                                            .left_edge_trim
                                                        } ${lengthUnit[
                                                          job.jobcard.group
                                                            .machines[0].units
                                                            ?.left_edge_trim
                                                        ]?.displayName.toUpperCase()} / ${
                                                          job.jobcard.group
                                                            .machines[0]
                                                            .right_edge_trim
                                                        } ${lengthUnit[
                                                          job.jobcard.group
                                                            .machines[0].units
                                                            ?.right_edge_trim
                                                        ]?.displayName.toUpperCase()}`}</p>
                                                      </li>
                                                      <li>
                                                        <span>
                                                          Number of Unique Sets
                                                        </span>
                                                        <p>
                                                          {job.jobcard
                                                            .solution_1.data
                                                            .summary
                                                            .unique_partitions
                                                            ? job.jobcard
                                                                .solution_1.data
                                                                .summary
                                                                .unique_partitions
                                                            : 0}
                                                        </p>
                                                      </li>
                                                      <li>
                                                        <span>
                                                          Avg. Deckle
                                                          Utilization
                                                        </span>
                                                        <p
                                                          style={{
                                                            wordWrap:
                                                              "break-word",
                                                          }}
                                                        >
                                                          {job.jobcard.solution_1?.data.summary?.[
                                                            "avg_utilized_deckle_" +
                                                              job.jobcard?.group
                                                                ?.machines[0]
                                                                ?.machine_id
                                                          ]?.toFixed(3)}{" "}
                                                          {job.jobcard?.group?.machines[0]?.machine_id &&
                                                          job.jobcard.solution_1.summary?.units
                                                            ? lengthUnit[
                                                                job.jobcard.solution_1.summary?.units[
                                                                  "avg_utilized_deckle_" +
                                                                  job.jobcard?.group?.machines[0]?.machine_id
                                                                ]
                                                              ]?.displayName?.toUpperCase()
                                                            : "CM"}
                                                        </p>
                                                      </li>
                                                    </ul>
                                                  </Col>
                                                  <Col span={12}>
                                                    <ul>
                                                      <li>
                                                        <span>Rewinder</span>
                                                        <p
                                                          style={{
                                                            wordWrap:
                                                              "break-word",
                                                          }}
                                                        >
                                                          {
                                                            job.jobcard?.group
                                                              ?.machines[0]
                                                              ?.rewinder_name
                                                          }
                                                        </p>
                                                      </li>
                                                      <li>
                                                        <span>
                                                          Product Specifications
                                                        </span>
                                                        <p
                                                          style={{
                                                            wordWrap:
                                                              "break-word",
                                                          }}
                                                        >
                                                          {
                                                            job.jobcard.product
                                                              .product_spec
                                                          }
                                                        </p>
                                                      </li>
                                                      <li>
                                                        <span>
                                                          Fulfilled Quantity
                                                        </span>
                                                        <p>
                                                          {job.jobcard
                                                            .solution_1.data
                                                            .summary
                                                            .fulfilled_requirement_weight
                                                            ? `${job.jobcard.solution_1.data.summary.fulfilled_requirement_weight.toFixed(
                                                                3,
                                                              )} ${capitalize(
                                                                weightUnit[
                                                                  job.jobcard
                                                                    .solution_1
                                                                    .data
                                                                    .summary
                                                                    .units
                                                                    ?.fulfilled_requirement_weight
                                                                ]?.displayName,
                                                              )}`
                                                            : 0}
                                                        </p>
                                                      </li>
                                                      {/* <li>
                                              <span>Core ID / Reel OD</span>
                                              <p>{`${
                                                job.jobcard.group
                                                  .grouping_params.core_id
                                              } ${lengthUnit[
                                                job.jobcard.group
                                                  .grouping_params.units
                                                  ?.core_id
                                              ]?.displayName.toUpperCase()} / ${
                                                job.jobcard.group
                                                  .grouping_params.reel_od
                                              } ${lengthUnit[
                                                job.jobcard.group
                                                  .grouping_params.units
                                                  ?.reel_od
                                              ]?.displayName.toUpperCase()}`}</p>
                                            </li> */}
                                                      <li>
                                                        <span>
                                                          Total Number of Sets
                                                        </span>
                                                        <p>
                                                          {job.jobcard
                                                            .solution_1.data
                                                            .summary
                                                            .total_partitions
                                                            ? job.jobcard
                                                                .solution_1.data
                                                                .summary
                                                                .total_partitions
                                                            : 0}
                                                        </p>
                                                      </li>
                                                      <li>
                                                        <span>
                                                          Priority Quantity
                                                        </span>
                                                        <p>
                                                          {job.jobcard
                                                            .solution_1.data
                                                            .summary
                                                            ?.forced_requirement_fulfilled
                                                            ? job.jobcard.solution_1.data.summary.forced_requirement_fulfilled.toFixed(
                                                                3,
                                                              )
                                                            : 0}{" "}
                                                          {job.jobcard
                                                            .solution_1.data
                                                            .summary?.units
                                                            ?.forced_requirement_fulfilled
                                                            ? capitalize(
                                                                weightUnit[
                                                                  job.jobcard
                                                                    .solution_1
                                                                    .data
                                                                    .summary
                                                                    ?.units
                                                                    .forced_requirement_fulfilled
                                                                ].displayName,
                                                              )
                                                            : "T"}
                                                        </p>
                                                      </li>
                                                    </ul>
                                                  </Col>
                                                </Row>
                                                {/* Removed Approved Remarks */}
                                              </div>
                                            </Panes>
                                            <Panes
                                              tab={
                                                <span>
                                                  Size Fulfilment
                                                  {activeTab == "2" && (
                                                    <Button
                                                      key="1"
                                                      style={{ border: "none" }}
                                                      onClick={(e) =>
                                                        setSizeExpanded(
                                                          !sizeExpanded,
                                                        )
                                                      }
                                                    >
                                                      <Iconmoon
                                                        icon={
                                                          sizeExpanded
                                                            ? "contract_arrow"
                                                            : "expand_arrow"
                                                        }
                                                        size={14}
                                                        color="#EA4E2C"
                                                      />
                                                    </Button>
                                                  )}
                                                </span>
                                              }
                                              key="2"
                                            >
                                              <TableLayoutData>
                                                <div
                                                  className="tableDataFormat  "
                                                  style={{ marginTop: "25px" }}
                                                >
                                                  <Table
                                                    columns={
                                                      sizeFulfillmentColumnsHead
                                                    }
                                                    dataSource={
                                                      !job.jobcard.solution_1
                                                        .data.exception &&
                                                      sizeDetailsList1
                                                    }
                                                    onChange={(
                                                      pagination,
                                                    ) => {}}
                                                    scroll={{ x: 1200 }}
                                                    rowClassName={(record) =>
                                                      record.priority && "true"
                                                    }
                                                    pagination={{
                                                      current: currentPage,
                                                      pageSize: pageSize,
                                                      total:
                                                        !job.jobcard.solution_1
                                                          .data.exception &&
                                                        sizeDetailsList1?.length,
                                                      onChange:
                                                        onPaginationChange,
                                                      showSizeChanger: true,
                                                      showQuickJumper: true,
                                                      // showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                                                    }}
                                                  />
                                                </div>
                                              </TableLayoutData>
                                            </Panes>
                                            {!job.jobcard.solution_1.data
                                              .exception && (
                                              <Panes
                                                tab={
                                                  <span>
                                                    Order Fulfillment
                                                    {activeTab == "3" && (
                                                      <Button
                                                        key="1"
                                                        style={{
                                                          border: "none",
                                                        }}
                                                        onClick={(e) =>
                                                          setSizeExpanded(
                                                            !sizeExpanded,
                                                          )
                                                        }
                                                      >
                                                        <Iconmoon
                                                          icon={
                                                            sizeExpanded
                                                              ? "contract_arrow"
                                                              : "expand_arrow"
                                                          }
                                                          size={14}
                                                          color="#EA4E2C"
                                                        />
                                                      </Button>
                                                    )}
                                                  </span>
                                                }
                                                key="3"
                                                // disabled={solutionSummary?.solution1.exception}
                                              >
                                                <TableLayoutData>
                                                  <div
                                                    className="tableDataFormat"
                                                    style={{
                                                      marginTop: "25px",
                                                    }}
                                                  >
                                                    {isFetchingData ? (
                                                      <TableShimmer
                                                        header={orderFulfillmentColumnsHead}
                                                        scroll={1400}
                                                      />
                                                    ) : (
                                                      <Table
                                                        columns={orderFulfillmentColumnsHead}
                                                        dataSource={orderDetailsList1}
                                                        onChange={onChange}
                                                        scroll={{ x: 1800 }}
                                                        rowClassName={(
                                                          record,
                                                        ) =>
                                                          record.priority &&
                                                          "true"
                                                        }
                                                        pagination={{
                                                          current: currentPage,
                                                          pageSize: pageSize,
                                                          total:
                                                            orderDetailsList1?.length,
                                                          onChange:
                                                            onPaginationChange,
                                                          showSizeChanger: true,
                                                          showQuickJumper: true,
                                                          // showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                                                        }}
                                                      />
                                                    )}
                                                  </div>
                                                </TableLayoutData>
                                              </Panes>
                                            )}
                                            {/* <Panes
                                              tab={
                                                <span>
                                                  Unfulfilled Orders
                                                  {activeTab == "4" && (
                                                    <Button
                                                      key="1"
                                                      style={{ border: "none" }}
                                                      onClick={(e) =>
                                                        setSizeExpanded(
                                                          !sizeExpanded,
                                                        )
                                                      }
                                                    >
                                                      <Iconmoon
                                                        icon={
                                                          sizeExpanded
                                                            ? "contract_arrow"
                                                            : "expand_arrow"
                                                        }
                                                        size={14}
                                                        color="#EA4E2C"
                                                      />
                                                    </Button>
                                                  )}
                                                </span>
                                              }
                                              key="4"
                                              // disabled={solutionSummary?.solution1.exception}
                                            >
                                              <TableLayoutData>
                                                <div
                                                  className="tableDataFormat"
                                                  style={{ marginTop: "25px" }}
                                                >
                                                  {isFetchingData ? (
                                                    <TableShimmer
                                                      header={
                                                        unfulfilledColumnsHead
                                                      }
                                                      scroll={1400}
                                                    />
                                                  ) : (
                                                    <Table
                                                      columns={
                                                        unfulfilledColumnsHead
                                                      }
                                                      dataSource={
                                                        job.jobcard.solution_1
                                                          .data.exception
                                                          ? failedJobOrders
                                                          : orderDetailsList1?.filter(
                                                              (order) =>
                                                                parseFloat(
                                                                  order.unFulflilledWeight.split(
                                                                    " ",
                                                                  )[0],
                                                                ) > 0,
                                                            )
                                                      }
                                                      onChange={(pagination) =>
                                                        onChange(
                                                          pagination,
                                                          true,
                                                        )
                                                      }
                                                      scroll={{ x: 1800 }}
                                                      rowClassName={(record) =>
                                                        record.priority &&
                                                        "true"
                                                      }
                                                      pagination={{
                                                        current: currentPage,
                                                        pageSize: pageSize,
                                                        total:
                                                          totalUnfulfilledOrders,
                                                        onChange:
                                                          onPaginationChange,
                                                        showSizeChanger: true,
                                                        showQuickJumper: true,
                                                        // showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                                                      }}
                                                    />
                                                  )}
                                                </div>
                                              </TableLayoutData>
                                            </Panes> */}
                                            <Panes
                                              tab={
                                                <span>
                                                  Intermediate Reels
                                                  {activeTab == "5" && (
                                                    <Button
                                                      key="1"
                                                      style={{ border: "none" }}
                                                      onClick={(e) =>
                                                        setSizeExpanded(
                                                          !sizeExpanded,
                                                        )
                                                      }
                                                    >
                                                      <Iconmoon
                                                        icon={
                                                          sizeExpanded
                                                            ? "contract_arrow"
                                                            : "expand_arrow"
                                                        }
                                                        size={14}
                                                        color="#EA4E2C"
                                                      />
                                                    </Button>
                                                  )}
                                                </span>
                                              }
                                              key="5"
                                              // disabled={solutionSummary?.solution1.exception}
                                            >
                                              <TableLayoutData>
                                                <div
                                                  className="tableDataFormat"
                                                  style={{ marginTop: "25px" }}
                                                >
                                                  <Table
                                                    columns={
                                                      intermediateColumnsHead
                                                    }
                                                    dataSource={
                                                      intermediateData1
                                                    }
                                                    onChange={(
                                                      pagination,
                                                    ) => {}}
                                                    scroll={{ x: 1200 }}
                                                    rowClassName={(record) =>
                                                      record.priority && "true"
                                                    }
                                                  />
                                                </div>
                                              </TableLayoutData>
                                            </Panes>
                                          </Tabs>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Panes>
                                )}
                              {job.jobcard.solution_2.data.summary &&
                                job.jobcard.solution_1.status != "accept" &&
                                job?.newlyCreatedJobCardsDetails?.[0]?.jobcard
                                  ?.solution_1.status != "accept" &&
                                job?.newlyCreatedJobCardsDetails?.[0]?.jobcard
                                  ?.solution_2.status != "accept" && (
                                  <Panes
                                    tab="Solution 2"
                                    key={
                                      job.jobcard.solution_2.status === "accept"
                                        ? "1"
                                        : "2"
                                    }
                                  >
                                    <PageTitleComp
                                      style={{ borderBottom: "0" }}
                                    >
                                      <PageHeader
                                        ghost={false}
                                        title={
                                          <div
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "50px",
                                            }}
                                          >
                                            <span>
                                              {job.state == "pending"
                                                ? activeJC &&
                                                  activeJC != undefined
                                                  ? activeJC
                                                  : ""
                                                : "Job Card " +
                                                  (activeJC &&
                                                  activeJC != undefined
                                                    ? activeJC
                                                    : "")}
                                            </span>
                                            {/* {job.state == "pending" ? (
                                          (activeJC?.length > 20 ? (
                                            <Tooltip placement="bottomLeft" title={activeJC}>
                                              {activeJC?.slice(0,21)+"..."}
                                            </Tooltip>
                                            ) : (
                                              activeJC
                                          ))
                                          ) : (
                                          ("Job Card " + activeJC)
                                          )
                                        } */}
                                          </div>
                                        }
                                        extra={
                                          !job.jobcard.solution_2.data
                                            .exception && [
                                            job.jobcard.solution_2.status ===
                                            "accept" ? (
                                              <AlertContainer
                                                color="green"
                                                icon={alertGreen}
                                                msg="The solution is sent for approval"
                                              />
                                            ) : job.jobcard.solution_2
                                                .status === "reject" ? (
                                              job.jobcard.solution_1.status ===
                                              "accept" ? (
                                                <AlertContainer
                                                  color="green"
                                                  icon={alertGreen}
                                                  msg="The solution 1 is already accepted"
                                                />
                                              ) : job.newlyCreatedJobCardsDetails &&
                                                job
                                                  .newlyCreatedJobCardsDetails[0]
                                                  ?.jobcard?.solution_1
                                                  .status === "accept" ? (
                                                <AlertContainer
                                                  color="green"
                                                  icon={alertGreen}
                                                  msg="The new solution 1 is already accepted"
                                                />
                                              ) : job.newlyCreatedJobCardsDetails &&
                                                job
                                                  .newlyCreatedJobCardsDetails[0]
                                                  .jobcard.solution_2.status ===
                                                  "accept" ? (
                                                <AlertContainer
                                                  color="green"
                                                  icon={alertGreen}
                                                  msg="The new solution 2 is already accepted"
                                                />
                                              ) : (
                                                <AlertContainer
                                                  color="red"
                                                  icon={alertRed}
                                                  msg="The solution is discarded by the user"
                                                />
                                              )
                                            ) : (
                                              <RightSideSolution>
                                                <div className="rightSideSolutionButtons">
                                                  <Button
                                                    key="1"
                                                    className="themeBtn noBg"
                                                    onClick={() =>
                                                      discardModalShow(
                                                        "solution2",
                                                      )
                                                    }
                                                    // disabled={
                                                    //   jobCardDetailsList[jobIndex]?.jobcard.solution_1.exception
                                                    // }
                                                  >
                                                    <Iconmoon
                                                      icon="wrong"
                                                      size={14}
                                                      color="#EA4E2C"
                                                    />
                                                    Discard Solution
                                                  </Button>

                                                  <Button
                                                    key="2"
                                                    className="themeBtn"
                                                    onClick={() =>
                                                      acceptModalShow(
                                                        "solution2",
                                                      )
                                                    }
                                                    // disabled={
                                                    //   jobCardDetailsList[jobIndex]?.jobcard.solution_1.exception
                                                    // }
                                                  >
                                                    <Iconmoon
                                                      icon="correct"
                                                      size={14}
                                                      color="#ffffff"
                                                    />
                                                    Accept Solution
                                                  </Button>
                                                </div>
                                              </RightSideSolution>
                                            ),
                                          ]
                                        }
                                      ></PageHeader>
                                    </PageTitleComp>
                                    <div className="MatchResult">
                                      <Row
                                        span={24}
                                        className="pipeBlockCylinder"
                                      >
                                        {((!sizeExpanded && activeTab == "2") ||
                                          (!sizeExpanded && activeTab == "3") ||
                                          (!sizeExpanded && activeTab == "4") ||
                                          (!sizeExpanded && activeTab == "5") ||
                                          activeTab == "1") && (
                                          <Col
                                            span={15}
                                            className="pipeBlock"
                                            style={{ paddingRight: "20px" }}
                                          >
                                            <RightSideSolution>
                                              {!job.jobcard.solution_2.data
                                                .exception ? (
                                                // jobCardDetailsList && (
                                                <JobCardCylinderContainer
                                                  jobId={job.jobcard.solution_2.status === "accept" && location?.state?.type === "replan" ? location?.state?.parentJCid : job.id}
                                                  solution={2}
                                                  multiView={true}
                                                  deckle_match_page={true}
                                                  solId={solId}
                                                />
                                              ) : (
                                                // )
                                                <>
                                                  <div className="deckleCoverImage">
                                                    <img
                                                      src={deckleCover}
                                                      alt="deckle match result"
                                                    />
                                                  </div>
                                                  {/* Exception message */}
                                                  <div className="colLayoutBlock deckleErrorLayout">
                                                    <p
                                                      style={{
                                                        color: "#EA655B",
                                                      }}
                                                    >
                                                      {
                                                        job.jobcard.solution_2
                                                          .data.exception
                                                      }
                                                    </p>
                                                  </div>
                                                </>
                                              )}
                                            </RightSideSolution>
                                          </Col>
                                        )}
                                        <Col
                                          span={
                                            ((sizeExpanded &&
                                              activeTab == "2") ||
                                              (sizeExpanded &&
                                                activeTab == "3") ||
                                              (sizeExpanded &&
                                                activeTab == "4") ||
                                              (sizeExpanded &&
                                                activeTab == "5")) &&
                                            activeTab != "1"
                                              ? 24
                                              : 9
                                          }
                                          className="colLayoutBlock"
                                        >
                                          {/* Exception message */}
                                          {/* {!jobCardDetailsList[jobIndex]?.solution2.summary ? (
                            <></>
                          ) : (
                            <p style={{ color: "#EA655B" }}>
                              {job.solution2.exception}
                            </p>
                          )} */}
                                          <Tabs
                                            defaultActiveKey={activeTab}
                                            activeKey={activeTab}
                                            className="topPostTab innerPostTab"
                                            onChange={tabChange}
                                          >
                                            <Panes
                                              tab="Solution 2 summary"
                                              key="1"
                                              // disabled={jobCardDetailsList[jobIndex]?.solution2.exception}
                                            >
                                              <div className="lossValue">
                                                {!job.jobcard.solution_2.data
                                                  .exception && (
                                                  <>
                                                    <Row span={24}>
                                                      <Col span={12}>
                                                        <div className="summaryValue">
                                                          <h5>
                                                            <span className="trimCut"></span>{" "}
                                                            Trim Loss
                                                          </h5>
                                                          <span>
                                                            {`${job.jobcard.solution_2.data.summary.match_trim_loss_percentage.toFixed(
                                                              3,
                                                            )} %`}
                                                          </span>
                                                          {
                                                            // job.jobcard.solution_1.data
                                                            //   .summary
                                                            //   .max_fulfilled_orders_match_trim_loss_comparison_pp ? (
                                                            job.jobcard
                                                              ?.comparison?.[
                                                              matchTrimLossKey
                                                            ] < 0 ? (
                                                              <span className="lesserSolution">
                                                                <img
                                                                  src={
                                                                    greaterRange
                                                                  }
                                                                  style={{
                                                                    marginRight:
                                                                      "10px",
                                                                  }}
                                                                />
                                                                {job.jobcard
                                                                  ?.comparison?.[
                                                                  matchTrimLossKey
                                                                ]
                                                                  ? Math.abs(
                                                                      job
                                                                        .jobcard
                                                                        ?.comparison?.[
                                                                        matchTrimLossKey
                                                                      ],
                                                                    )?.toFixed(
                                                                      3,
                                                                    )
                                                                  : 0}{" "}
                                                                % pts greater
                                                                than sol 1
                                                              </span>
                                                            ) : (
                                                              <span className="lesserSolution">
                                                                <img
                                                                  src={
                                                                    lowerRange
                                                                  }
                                                                  style={{
                                                                    marginRight:
                                                                      "10px",
                                                                  }}
                                                                />
                                                                {job.jobcard
                                                                  ?.comparison?.[
                                                                  matchTrimLossKey
                                                                ]
                                                                  ? Math.abs(
                                                                      job
                                                                        .jobcard
                                                                        ?.comparison?.[
                                                                        matchTrimLossKey
                                                                      ],
                                                                    )?.toFixed(
                                                                      3,
                                                                    )
                                                                  : 0}{" "}
                                                                % pts lesser
                                                                than sol 1
                                                              </span>
                                                            )
                                                            // ) : (
                                                            //   <></>
                                                            // )
                                                          }
                                                        </div>
                                                      </Col>
                                                      <Col span={12}>
                                                        <div className="summaryValue">
                                                          <h5>
                                                            <span className="trimBox"></span>{" "}
                                                            Fulfillment
                                                          </h5>
                                                          <span>
                                                            {`${job.jobcard.solution_2.data.summary.requirement_fulfilled_percentage?.toFixed(
                                                              3,
                                                            )} %`}
                                                          </span>
                                                          {
                                                            // job.jobcard.solution_1.data
                                                            //   .summary
                                                            //   .max_fulfilled_orders_requirement_fulfillment_comparison_pp ? (
                                                            job.jobcard
                                                              ?.comparison?.[
                                                              matchFulfilmentKey
                                                            ] < 0 ? (
                                                              <span className="lesserSolution">
                                                                <img
                                                                  src={
                                                                    greaterRange
                                                                  }
                                                                  style={{
                                                                    marginRight:
                                                                      "10px",
                                                                  }}
                                                                />
                                                                {job.jobcard
                                                                  ?.comparison?.[
                                                                  matchFulfilmentKey
                                                                ]
                                                                  ? Math.abs(
                                                                      job
                                                                        .jobcard
                                                                        ?.comparison?.[
                                                                        matchFulfilmentKey
                                                                      ],
                                                                    )?.toFixed(
                                                                      3,
                                                                    )
                                                                  : 0}{" "}
                                                                % pts greater
                                                                than sol 1
                                                              </span>
                                                            ) : (
                                                              <span className="lesserSolution">
                                                                <img
                                                                  src={
                                                                    lowerRange
                                                                  }
                                                                  style={{
                                                                    marginRight:
                                                                      "10px",
                                                                  }}
                                                                />
                                                                {job.jobcard
                                                                  ?.comparison?.[
                                                                  matchFulfilmentKey
                                                                ]
                                                                  ? Math.abs(
                                                                      job
                                                                        .jobcard
                                                                        ?.comparison?.[
                                                                        matchFulfilmentKey
                                                                      ],
                                                                    )?.toFixed(
                                                                      3,
                                                                    )
                                                                  : 0}{" "}
                                                                % pts lesser
                                                                than sol 1
                                                              </span>
                                                            )
                                                            // ) : (
                                                            //   <></>
                                                            // )
                                                          }
                                                        </div>
                                                      </Col>
                                                    </Row>
                                                    <Row span={24}>
                                                      <Col span={12}>
                                                        <div className="summaryValue">
                                                          <h5>
                                                            <span className="trimCut"></span>{" "}
                                                            Net Trim Loss:{" "}
                                                            {job.jobcard.solution_2.data.summary.net_trim_loss_percentage?.toFixed(
                                                              3,
                                                            )}{" "}
                                                            %
                                                            <p>
                                                              Loss including
                                                              edge trim
                                                            </p>
                                                          </h5>
                                                        </div>
                                                      </Col>
                                                      <Col span={12}>
                                                        <div className="summaryValue">
                                                          <h5>
                                                            <span className="trimBox"></span>{" "}
                                                            Weight:{" "}
                                                            {job.jobcard.solution_2.data.summary.job_card_weight?.toFixed(
                                                              3,
                                                            )}{" "}
                                                            {capitalize(
                                                              weightUnit[
                                                                job.jobcard
                                                                  .solution_2
                                                                  .data.summary
                                                                  .units
                                                                  ?.job_card_weight
                                                              ]?.displayName,
                                                            )}
                                                            <p className="lesserSolution">
                                                              Total weight of
                                                              Job Card
                                                            </p>
                                                          </h5>
                                                        </div>
                                                      </Col>
                                                    </Row>
                                                  </>
                                                )}
                                                <Row span={24}>
                                                  <Col span={12}>
                                                    <ul>
                                                      <li>
                                                        <span>
                                                          Paper Machine
                                                        </span>
                                                        <p>
                                                          {
                                                            job.jobcard.group
                                                              .machines[0].name
                                                          }
                                                        </p>
                                                      </li>
                                                      <li>
                                                        <span>Ply</span>
                                                        <p>{job.ply}</p>
                                                      </li>
                                                      <li>
                                                        <span>
                                                          Deckle Width
                                                        </span>
                                                        <p>{`${(
                                                          job.jobcard.group
                                                            .machines[0]
                                                            .deckle_size_ub +
                                                          (job.jobcard.group
                                                            .machines[0]
                                                            .left_edge_trim +
                                                            job.jobcard.group
                                                              .machines[0]
                                                              .right_edge_trim) *
                                                            CoversionFactorUnitsToCM[
                                                              job.jobcard.group
                                                                .machines[0]
                                                                .units
                                                                ?.right_edge_trim
                                                            ] *
                                                            CoversionFactorCMToUnits[
                                                              job.jobcard.group
                                                                .machines[0]
                                                                .units
                                                                ?.deckle_size_ub
                                                            ]
                                                        )?.toFixed(
                                                          3,
                                                        )} - ${job.jobcard.group.machines[0]?.deckle_size_lb?.toFixed(
                                                          3,
                                                        )} ${lengthUnit[
                                                          job.jobcard.group
                                                            .machines[0].units
                                                            ?.deckle_size_ub
                                                        ]?.displayName.toUpperCase()}`}</p>
                                                      </li>
                                                      <li>
                                                        <span>
                                                          Edge Trim ( Left /
                                                          Right )
                                                        </span>
                                                        <p>{`${
                                                          job.jobcard.group
                                                            .machines[0]
                                                            .left_edge_trim
                                                        } ${lengthUnit[
                                                          job.jobcard.group
                                                            .machines[0].units
                                                            ?.left_edge_trim
                                                        ]?.displayName.toUpperCase()} / ${
                                                          job.jobcard.group
                                                            .machines[0]
                                                            .right_edge_trim
                                                        } ${lengthUnit[
                                                          job.jobcard.group
                                                            .machines[0].units
                                                            ?.right_edge_trim
                                                        ]?.displayName.toUpperCase()}`}</p>
                                                      </li>
                                                      <li>
                                                        <span>
                                                          Number of Unique Sets
                                                        </span>
                                                        <p>
                                                          {job.jobcard
                                                            .solution_2.data
                                                            .summary
                                                            .unique_partitions
                                                            ? job.jobcard
                                                                .solution_2.data
                                                                .summary
                                                                .unique_partitions
                                                            : 0}
                                                        </p>
                                                      </li>
                                                      <li>
                                                        <span>
                                                          Avg. Deckle
                                                          Utilization
                                                        </span>
                                                        <p
                                                          style={{
                                                            wordWrap:
                                                              "break-word",
                                                          }}
                                                        >
                                                          {job.jobcard.solution_2?.data.summary?.[
                                                            "avg_utilized_deckle_" +
                                                              job.jobcard?.group
                                                                ?.machines[0]
                                                                ?.machine_id
                                                          ]?.toFixed(3)}{" "}
                                                          {job.jobcard?.group?.machines[0]?.machine_id &&
                                                          job.jobcard.solution_2.summary?.units
                                                            ? lengthUnit[
                                                                job.jobcard.solution_2.summary?.units[
                                                                  "avg_utilized_deckle_" +
                                                                  job.jobcard?.group?.machines[0]?.machine_id
                                                                ]
                                                              ]?.displayName?.toUpperCase()
                                                            : "CM"}
                                                        </p>
                                                      </li>
                                                    </ul>
                                                  </Col>
                                                  <Col span={12}>
                                                    <ul>
                                                      <li>
                                                        <span>Rewinder</span>
                                                        <p
                                                          style={{
                                                            wordWrap:
                                                              "break-word",
                                                          }}
                                                        >
                                                          {
                                                            job.jobcard?.group
                                                              ?.machines[0]
                                                              ?.rewinder_name
                                                          }
                                                        </p>
                                                      </li>
                                                      <li>
                                                        <span>
                                                          Product Specifications
                                                        </span>
                                                        <p
                                                          style={{
                                                            wordWrap:
                                                              "break-word",
                                                          }}
                                                        >
                                                          {
                                                            job.jobcard.product
                                                              .product_spec
                                                          }
                                                        </p>
                                                      </li>
                                                      <li>
                                                        <span>
                                                          Fulfilled Quantity
                                                        </span>
                                                        <p>
                                                          {job.jobcard
                                                            .solution_2.data
                                                            .summary
                                                            .fulfilled_requirement_weight
                                                            ? `${job.jobcard.solution_2.data.summary.fulfilled_requirement_weight.toFixed(
                                                                3,
                                                              )} ${capitalize(
                                                                weightUnit[
                                                                  job.jobcard
                                                                    .solution_2
                                                                    .data
                                                                    .summary
                                                                    .units
                                                                    ?.fulfilled_requirement_weight
                                                                ]?.displayName,
                                                              )}`
                                                            : 0}
                                                        </p>
                                                      </li>{" "}
                                                      <li>
                                                        <span>
                                                          Total Number of Sets
                                                        </span>
                                                        <p>
                                                          {job.jobcard
                                                            .solution_2?.data
                                                            ?.summary
                                                            ?.total_partitions
                                                            ? job.jobcard
                                                                .solution_2
                                                                ?.data?.summary
                                                                ?.total_partitions
                                                            : 0}
                                                        </p>
                                                      </li>
                                                      <li>
                                                        <span>
                                                          Priority Quantity
                                                        </span>
                                                        <p>
                                                          {job.jobcard
                                                            .solution_2.data
                                                            .summary
                                                            ?.forced_requirement_fulfilled
                                                            ? job.jobcard.solution_2.data.summary.forced_requirement_fulfilled.toFixed(
                                                                3,
                                                              )
                                                            : 0}{" "}
                                                          {job.jobcard
                                                            .solution_2.data
                                                            .summary?.units
                                                            ?.forced_requirement_fulfilled
                                                            ? capitalize(
                                                                weightUnit[
                                                                  job.jobcard
                                                                    .solution_2
                                                                    .data
                                                                    .summary
                                                                    ?.units
                                                                    .forced_requirement_fulfilled
                                                                ].displayName,
                                                              )
                                                            : "T"}
                                                        </p>
                                                      </li>
                                                    </ul>
                                                  </Col>
                                                </Row>

                                                {/* Removed Approved Remarks     */}
                                              </div>
                                            </Panes>
                                            <Panes
                                              tab={
                                                <span>
                                                  Size Fulfilment
                                                  {activeTab == "2" && (
                                                    <Button
                                                      key="1"
                                                      style={{ border: "none" }}
                                                      onClick={(e) =>
                                                        setSizeExpanded(
                                                          !sizeExpanded,
                                                        )
                                                      }
                                                    >
                                                      <Iconmoon
                                                        icon={
                                                          sizeExpanded
                                                            ? "contract_arrow"
                                                            : "expand_arrow"
                                                        }
                                                        size={14}
                                                        color="#EA4E2C"
                                                      />
                                                    </Button>
                                                  )}
                                                </span>
                                              }
                                              key="2"
                                            >
                                              <TableLayoutData>
                                                <div
                                                  className="tableDataFormat  "
                                                  style={{ marginTop: "25px" }}
                                                >
                                                  <Table
                                                    columns={
                                                      sizeFulfillmentColumnsHead
                                                    }
                                                    dataSource={
                                                      !job.jobcard.solution_2
                                                        .data.exception &&
                                                      sizeDetailsList2
                                                    }
                                                    pagination={{
                                                      current: currentPage,
                                                      pageSize: pageSize,
                                                      total:
                                                        !job.jobcard.solution_2
                                                          .data.exception &&
                                                        sizeDetailsList2?.length,
                                                      onChange:
                                                        onPaginationChange,
                                                      showSizeChanger: true,
                                                      showQuickJumper: true,
                                                      // showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                                                    }}
                                                    onChange={(
                                                      pagination,
                                                    ) => {}}
                                                    scroll={{ x: 1200 }}
                                                    rowClassName={(record) =>
                                                      record.priority && "true"
                                                    }
                                                  />
                                                </div>
                                              </TableLayoutData>
                                            </Panes>
                                            {!job.jobcard.solution_2.data
                                              .exception && (
                                              <Panes
                                                tab={
                                                  <span>
                                                    Order Fulfillment
                                                    {activeTab == "3" && (
                                                      <Button
                                                        key="1"
                                                        style={{
                                                          border: "none",
                                                        }}
                                                        onClick={(e) =>
                                                          setSizeExpanded(
                                                            !sizeExpanded,
                                                          )
                                                        }
                                                      >
                                                        <Iconmoon
                                                          icon={
                                                            sizeExpanded
                                                              ? "contract_arrow"
                                                              : "expand_arrow"
                                                          }
                                                          size={14}
                                                          color="#EA4E2C"
                                                        />
                                                      </Button>
                                                    )}
                                                  </span>
                                                }
                                                key="3"
                                                // disabled={jobCardDetailsList[jobIndex]?.solution2.exception}
                                              >
                                                <TableLayoutData>
                                                  <div
                                                    className="tableDataFormat"
                                                    style={{
                                                      marginTop: "25px",
                                                    }}
                                                  >
                                                    {isFetchingData ? (
                                                      <TableShimmer
                                                        header={orderFulfillmentColumnsHead}
                                                        scroll={1400}
                                                      />
                                                    ) : (
                                                      <Table
                                                        columns={orderFulfillmentColumnsHead}
                                                        dataSource={orderDetailsList2}
                                                        onChange={onChange}
                                                        scroll={{ x: 1800 }}
                                                        rowClassName={(
                                                          record,
                                                        ) =>
                                                          record.priority &&
                                                          "true"
                                                        }
                                                        pagination={{
                                                          current: currentPage,
                                                          pageSize: pageSize,
                                                          total:
                                                            orderDetailsList2?.length,
                                                          onChange:
                                                            onPaginationChange,
                                                          showSizeChanger: true,
                                                          showQuickJumper: true,
                                                          // showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                                                        }}
                                                      />
                                                    )}
                                                  </div>
                                                </TableLayoutData>
                                              </Panes>
                                            )}
                                            {/* <Panes
                                              tab={
                                                <span>
                                                  Unfulfilled Orders
                                                  {activeTab == "4" && (
                                                    <Button
                                                      key="1"
                                                      style={{ border: "none" }}
                                                      onClick={(e) =>
                                                        setSizeExpanded(
                                                          !sizeExpanded,
                                                        )
                                                      }
                                                    >
                                                      <Iconmoon
                                                        icon={
                                                          sizeExpanded
                                                            ? "contract_arrow"
                                                            : "expand_arrow"
                                                        }
                                                        size={14}
                                                        color="#EA4E2C"
                                                      />
                                                    </Button>
                                                  )}
                                                </span>
                                              }
                                              key="4"
                                              // disabled={jobCardDetailsList[jobIndex]?.solution2.exception}
                                            >
                                              <TableLayoutData>
                                                <div
                                                  className="tableDataFormat"
                                                  style={{ marginTop: "25px" }}
                                                >
                                                  {isFetchingData ? (
                                                    <TableShimmer
                                                      header={
                                                        unfulfilledColumnsHead
                                                      }
                                                      scroll={1300}
                                                    />
                                                  ) : (
                                                    <Table
                                                      columns={
                                                        unfulfilledColumnsHead
                                                      }
                                                      dataSource={
                                                        job.jobcard.solution_1
                                                          .data.exception
                                                          ? failedJobOrders
                                                          : orderDetailsList2?.filter(
                                                              (order) =>
                                                                parseFloat(
                                                                  order.unFulflilledWeight.split(
                                                                    " ",
                                                                  )[0],
                                                                ) > 0,
                                                            )
                                                      }
                                                      onChange={(pagination) =>
                                                        onChange(
                                                          pagination,
                                                          true,
                                                        )
                                                      }
                                                      scroll={{ x: 1800 }}
                                                      rowClassName={(record) =>
                                                        record.priority &&
                                                        "true"
                                                      }
                                                      pagination={{
                                                        current: currentPage,
                                                        pageSize: pageSize,
                                                        total:
                                                          totalUnfulfilledOrders,
                                                        onChange:
                                                          onPaginationChange,
                                                        showSizeChanger: true,
                                                        showQuickJumper: true,
                                                        // showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                                                      }}
                                                    />
                                                  )}
                                                </div>
                                              </TableLayoutData>
                                            </Panes> */}
                                            <Panes
                                              tab={
                                                <span>
                                                  Intermediate Reels
                                                  {activeTab == "5" && (
                                                    <Button
                                                      key="1"
                                                      style={{ border: "none" }}
                                                      onClick={(e) =>
                                                        setSizeExpanded(
                                                          !sizeExpanded,
                                                        )
                                                      }
                                                    >
                                                      <Iconmoon
                                                        icon={
                                                          sizeExpanded
                                                            ? "contract_arrow"
                                                            : "expand_arrow"
                                                        }
                                                        size={14}
                                                        color="#EA4E2C"
                                                      />
                                                    </Button>
                                                  )}
                                                </span>
                                              }
                                              key="5"
                                              // disabled={solutionSummary?.solution1.exception}
                                            >
                                              <TableLayoutData>
                                                <div
                                                  className="tableDataFormat"
                                                  style={{ marginTop: "25px" }}
                                                >
                                                  <Table
                                                    columns={
                                                      intermediateColumnsHead
                                                    }
                                                    dataSource={
                                                      intermediateData2
                                                    }
                                                    onChange={(
                                                      pagination,
                                                    ) => {}}
                                                    scroll={{ x: 1200 }}
                                                    rowClassName={(record) =>
                                                      record.priority && "true"
                                                    }
                                                  />
                                                </div>
                                              </TableLayoutData>
                                            </Panes>
                                          </Tabs>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Panes>
                                )}
                              //FAILED NEW SOLUTION
                              {failedNewSol[jobIndex] &&
                                job.newlyCreatedJobCardsDetails[0] && (
                                  <Panes tab="New Solution 1" key="3">
                                    <PageTitleComp
                                      style={{ borderBottom: "0" }}
                                    >
                                      <PageHeader
                                        ghost={false}
                                        title="Job Card"
                                      ></PageHeader>
                                    </PageTitleComp>
                                    <div className="MatchResult">
                                      <Row
                                        span={24}
                                        className="pipeBlockCylinder"
                                      >
                                        {((!sizeExpanded && activeTab == "2") ||
                                          (!sizeExpanded && activeTab == "3") ||
                                          (!sizeExpanded && activeTab == "4") ||
                                          (!sizeExpanded && activeTab == "5") ||
                                          activeTab == "1") && (
                                          <Col
                                            span={15}
                                            className="pipeBlock"
                                            style={{ paddingRight: "20px" }}
                                          >
                                            <RightSideSolution>
                                              <div className="deckleCoverImage">
                                                <img
                                                  src={deckleCover}
                                                  alt="deckle match result"
                                                />
                                              </div>
                                            </RightSideSolution>
                                          </Col>
                                        )}
                                        <Col
                                          span={
                                            ((sizeExpanded &&
                                              activeTab == "2") ||
                                              (sizeExpanded &&
                                                activeTab == "3") ||
                                              (sizeExpanded &&
                                                activeTab == "4") ||
                                              (sizeExpanded &&
                                                activeTab == "5")) &&
                                            activeTab != "1"
                                              ? 24
                                              : 9
                                          }
                                          className="colLayoutBlock"
                                        >
                                          <Tabs
                                            defaultActiveKey={activeTab}
                                            activeKey={activeTab}
                                            className="topPostTab innerPostTab"
                                            onChange={tabChange}
                                          >
                                            <Panes
                                              tab="Summary"
                                              key="1"
                                              // disabled={solutionSummary?.solution1.exception}
                                            >
                                              <div className="lossValue">
                                                <Row span={24}>
                                                  <Col span={12}>
                                                    <ul>
                                                      <li>
                                                        <span>
                                                          Paper Machine
                                                        </span>
                                                        <p>
                                                          {
                                                            job
                                                              .newlyCreatedJobCardsDetails[0]
                                                              ?.jobcard.group
                                                              .machines[0]
                                                              .machine_id
                                                          }
                                                        </p>
                                                      </li>
                                                      <li>
                                                        <span>Ply</span>
                                                        <p>{job.ply}</p>
                                                      </li>
                                                      <li>
                                                        <span>
                                                          Edge Trim ( Left /
                                                          Right )
                                                        </span>
                                                        <p>{`${
                                                          job
                                                            .newlyCreatedJobCardsDetails[0]
                                                            ?.jobcard.group
                                                            .machines[0]
                                                            .left_edge_trim
                                                        } ${lengthUnit[
                                                          job
                                                            .newlyCreatedJobCardsDetails[0]
                                                            ?.jobcard.group
                                                            .machines[0].units
                                                            ?.left_edge_trim
                                                        ]?.displayName.toUpperCase()} / ${
                                                          job
                                                            .newlyCreatedJobCardsDetails[0]
                                                            ?.jobcard.group
                                                            .machines[0]
                                                            .right_edge_trim
                                                        } ${lengthUnit[
                                                          job
                                                            .newlyCreatedJobCardsDetails[0]
                                                            ?.jobcard.group
                                                            .machines[0].units
                                                            ?.right_edge_trim
                                                        ]?.displayName.toUpperCase()}`}</p>
                                                      </li>
                                                      <li>
                                                        <span>
                                                          Product Specifications
                                                        </span>
                                                        <p
                                                          style={{
                                                            wordWrap:
                                                              "break-word",
                                                          }}
                                                        >
                                                          {
                                                            job
                                                              .newlyCreatedJobCardsDetails[0]
                                                              ?.jobcard.group
                                                              .product
                                                              .product_spec
                                                          }
                                                        </p>
                                                      </li>
                                                      <li>
                                                        <span>
                                                          Number of Fulfilled
                                                          Reels
                                                        </span>
                                                        <p>0</p>
                                                      </li>
                                                    </ul>
                                                  </Col>
                                                  <Col span={12}>
                                                    <ul>
                                                      <li>
                                                        <span>
                                                          Deckle Width
                                                        </span>
                                                        <p>
                                                          {`${(
                                                            job
                                                              ?.newlyCreatedJobCardsDetails[0]
                                                              ?.jobcard.group
                                                              .machines[0]
                                                              .deckle_size_ub +
                                                            (job
                                                              ?.newlyCreatedJobCardsDetails[0]
                                                              ?.jobcard.group
                                                              .machines[0]
                                                              .left_edge_trim +
                                                              job
                                                                ?.newlyCreatedJobCardsDetails[0]
                                                                ?.jobcard.group
                                                                .machines[0]
                                                                .right_edge_trim) *
                                                              CoversionFactorUnitsToCM[
                                                                job
                                                                  ?.newlyCreatedJobCardsDetails[0]
                                                                  ?.jobcard
                                                                  .group
                                                                  .machines[0]
                                                                  .units
                                                                  ?.right_edge_trim
                                                              ] *
                                                              CoversionFactorCMToUnits[
                                                                job
                                                                  ?.newlyCreatedJobCardsDetails[0]
                                                                  ?.jobcard
                                                                  .group
                                                                  .machines[0]
                                                                  .units
                                                                  ?.deckle_size_ub
                                                              ]
                                                          )?.toFixed(
                                                            3,
                                                          )} - ${job.newlyCreatedJobCardsDetails[0]?.jobcard.group.machines[0].deckle_size_lb?.toFixed(
                                                            3,
                                                          )} ${lengthUnit[
                                                            job
                                                              .newlyCreatedJobCardsDetails[0]
                                                              ?.jobcard.group
                                                              .machines[0].units
                                                              ?.deckle_size_ub
                                                          ]?.displayName.toUpperCase()}`}
                                                        </p>
                                                      </li>

                                                      <li>
                                                        <span>
                                                          Total Number of Sets
                                                        </span>
                                                        <p>0</p>
                                                      </li>
                                                      <li>
                                                        <span>
                                                          Priority Quantity
                                                        </span>
                                                        <p>0 T</p>
                                                      </li>
                                                    </ul>
                                                  </Col>
                                                </Row>
                                              </div>
                                            </Panes>
                                            {/* <Panes
                                              tab={
                                                <span>
                                                  Unfulfilled Orders
                                                  {activeTab == "4" && (
                                                    <Button
                                                      key="1"
                                                      style={{ border: "none" }}
                                                      onClick={(e) =>
                                                        setSizeExpanded(
                                                          !sizeExpanded,
                                                        )
                                                      }
                                                    >
                                                      <Iconmoon
                                                        icon={
                                                          sizeExpanded
                                                            ? "contract_arrow"
                                                            : "expand_arrow"
                                                        }
                                                        size={14}
                                                        color="#EA4E2C"
                                                      />
                                                    </Button>
                                                  )}
                                                </span>
                                              }
                                              key="4"
                                              // disabled={jobCardDetailsList[jobIndex]?.solution2.exception}
                                            >
                                              <TableLayoutData>
                                                <div
                                                  className="tableDataFormat"
                                                  style={{ marginTop: "25px" }}
                                                >
                                                  {isFetchingData ? (
                                                    <TableShimmer
                                                      header={
                                                        unfulfilledColumnsHead
                                                      }
                                                      scroll={1300}
                                                    />
                                                  ) : (
                                                    <Table
                                                      columns={
                                                        unfulfilledColumnsHead
                                                      }
                                                      dataSource={
                                                        failedJobOrders
                                                      }
                                                      onChange={(pagination) =>
                                                        onChange(
                                                          pagination,
                                                          true,
                                                        )
                                                      }
                                                      scroll={{ x: 1800 }}
                                                      rowClassName={(record) =>
                                                        record.priority &&
                                                        "true"
                                                      }
                                                      pagination={{
                                                        current: currentPage,
                                                        pageSize: pageSize,
                                                        total:
                                                          totalUnfulfilledOrders,
                                                        onChange:
                                                          onPaginationChange,
                                                        showSizeChanger: true,
                                                        showQuickJumper: true,
                                                        // showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                                                      }}
                                                    />
                                                  )}
                                                </div>
                                              </TableLayoutData>
                                            </Panes> */}
                                          </Tabs>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Panes>
                                )}
                              {!failedNewSol[jobIndex] &&
                                job.newlyCreatedJobCardsDetails &&
                                job.newlyCreatedJobCardsDetails[0]?.jobcard
                                  ?.solution_2.status != "accept" &&
                                job.jobcard.solution_1.status != "accept" &&
                                job.jobcard.solution_2.status != "accept" && (
                                  <Panes
                                    tab="New Solution 1"
                                    key={
                                      job.newlyCreatedJobCardsDetails[0]
                                        ?.jobcard?.solution_1.status ===
                                      "accept"
                                        ? "1"
                                        : "3"
                                    }
                                  >
                                    <PageTitleComp
                                      style={{ borderBottom: "0" }}
                                    >
                                      <PageHeader
                                        ghost={false}
                                        title={
                                          <div
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "50px",
                                            }}
                                          >
                                            <span>
                                              {job.state == "pending"
                                                ? activeJC &&
                                                  activeJC != undefined
                                                  ? activeJC
                                                  : ""
                                                : "Job Card " +
                                                  (activeJC &&
                                                  activeJC != undefined
                                                    ? activeJC
                                                    : "")}
                                            </span>
                                            {/* {job.state == "pending" ? (
                                            (activeJC?.length > 20 ? (
                                              <Tooltip placement="bottomLeft" title={activeJC}>
                                                {activeJC?.slice(0,21)+"..."}
                                              </Tooltip>
                                              ) : (
                                                activeJC
                                            ))
                                            ) : (
                                            ("Job Card " + activeJC)
                                            )
                                          } */}
                                          </div>
                                        }
                                        extra={
                                          !job.newlyCreatedJobCardsDetails[0]
                                            ?.jobcard?.solution_1.data
                                            .exception && [
                                            job.newlyCreatedJobCardsDetails[0]
                                              ?.jobcard?.solution_1.status ===
                                            "accept" ? (
                                              <AlertContainer
                                                color="green"
                                                icon={alertGreen}
                                                msg="The solution is sent for approval"
                                              />
                                            ) : job
                                                .newlyCreatedJobCardsDetails[0]
                                                ?.jobcard?.solution_1.status ===
                                              "reject" ? (
                                              job.newlyCreatedJobCardsDetails[0]
                                                .jobcard.solution_2.status ===
                                              "accept" ? (
                                                <AlertContainer
                                                  color="green"
                                                  icon={alertGreen}
                                                  msg="The new solution 2 is already accepted"
                                                />
                                              ) : job.jobcard.solution_1
                                                  .status === "accept" ? (
                                                <AlertContainer
                                                  color="green"
                                                  icon={alertGreen}
                                                  msg="The solution 1 is already accepted"
                                                />
                                              ) : job.jobcard.solution_2
                                                  .status === "accept" ? (
                                                <AlertContainer
                                                  color="green"
                                                  icon={alertGreen}
                                                  msg="The solution 2 is already accepted"
                                                />
                                              ) : (
                                                <AlertContainer
                                                  color="red"
                                                  icon={alertRed}
                                                  msg="The solution is discarded by the user"
                                                />
                                              )
                                            ) : (
                                              <RightSideSolution>
                                                <div className="rightSideSolutionButtons">
                                                  <Button
                                                    key="1"
                                                    className="themeBtn noBg"
                                                    onClick={() =>
                                                      discardModalShow(
                                                        "solution1",
                                                      )
                                                    }
                                                    disabled={
                                                      !userDetails.roles
                                                        .job_cards.edit
                                                    }
                                                  >
                                                    <Iconmoon
                                                      icon="wrong"
                                                      size={14}
                                                      color="#EA4E2C"
                                                    />
                                                    Discard Solution
                                                  </Button>
                                                  <Button
                                                    key="2"
                                                    className="themeBtn"
                                                    onClick={() =>
                                                      acceptModalShow(
                                                        "solution1",
                                                      )
                                                    }
                                                    disabled={
                                                      !userDetails.roles
                                                        .job_cards.edit
                                                    }
                                                  >
                                                    <Iconmoon
                                                      icon="correct"
                                                      size={14}
                                                      color="#ffffff"
                                                    />
                                                    Accept Solution
                                                  </Button>
                                                </div>
                                              </RightSideSolution>
                                            ),
                                          ]
                                        }
                                      ></PageHeader>
                                    </PageTitleComp>
                                    <div className="MatchResult">
                                      <Row
                                        span={24}
                                        className="pipeBlockCylinder"
                                      >
                                        {((!sizeExpanded && activeTab == "2") ||
                                          (!sizeExpanded && activeTab == "3") ||
                                          (!sizeExpanded && activeTab == "4") ||
                                          (!sizeExpanded && activeTab == "5") ||
                                          activeTab == "1") && (
                                          <Col
                                            span={15}
                                            className="pipeBlock"
                                            style={{ paddingRight: "20px" }}
                                          >
                                            <RightSideSolution>
                                              {!job
                                                .newlyCreatedJobCardsDetails[0]
                                                ?.jobcard?.solution_1.data
                                                .exception ? (
                                                // jobCardDetailsList &&
                                                <JobCardCylinderContainer
                                                  jobId={
                                                    job
                                                      .newlyCreatedJobCardsDetails[0]
                                                      ?.jobcard?.solution_1
                                                      .status === "accept"
                                                      ? location?.state?.type === "replan" ? location?.state?.parentJCid : job.id
                                                      : job
                                                          .newlyCreatedJobCardsDetails[0]
                                                          .id
                                                  }
                                                  solution={1}
                                                  multiView={true}
                                                  deckle_match_page={true}
                                                  solId={solId}
                                                />
                                              ) : (
                                                <>
                                                  <div className="deckleCoverImage">
                                                    <img
                                                      src={deckleCover}
                                                      alt="deckle match result"
                                                    />
                                                  </div>
                                                  {/* Exception message */}
                                                  <div className="colLayoutBlock deckleErrorLayout">
                                                    <p
                                                      style={{
                                                        color: "#EA655B",
                                                      }}
                                                    >
                                                      {
                                                        job
                                                          .newlyCreatedJobCardsDetails[0]
                                                          ?.jobcard?.solution_1
                                                          .data.exception
                                                      }
                                                    </p>
                                                  </div>
                                                </>
                                              )}
                                            </RightSideSolution>
                                          </Col>
                                        )}
                                        <Col
                                          span={
                                            ((sizeExpanded &&
                                              activeTab == "2") ||
                                              (sizeExpanded &&
                                                activeTab == "3") ||
                                              (sizeExpanded &&
                                                activeTab == "4") ||
                                              (sizeExpanded &&
                                                activeTab == "5")) &&
                                            activeTab != "1"
                                              ? 24
                                              : 9
                                          }
                                          className="colLayoutBlock"
                                        >
                                          <Tabs
                                            defaultActiveKey={activeTab}
                                            activeKey={activeTab}
                                            className="topPostTab innerPostTab"
                                            onChange={tabChange}
                                          >
                                            <Panes
                                              tab="Solution 1 summary"
                                              key="1"
                                              // disabled={solutionSummary?.solution1.exception}
                                            >
                                              <div className="lossValue">
                                                {!job
                                                  .newlyCreatedJobCardsDetails[0]
                                                  ?.jobcard?.solution_1.data
                                                  .exception && (
                                                  <>
                                                    <Row span={24}>
                                                      <Col span={12}>
                                                        <div className="summaryValue">
                                                          <h5>
                                                            <span className="trimCut"></span>{" "}
                                                            Trim Loss
                                                          </h5>
                                                          <span>
                                                            {`${job.newlyCreatedJobCardsDetails[0]?.jobcard?.solution_1?.data?.summary?.match_trim_loss_percentage?.toFixed(
                                                              3,
                                                            )} %`}
                                                          </span>
                                                          {
                                                            // job.jobcard.solution_1.data.summary
                                                            //   .max_fulfilled_orders_match_trim_loss_comparison_pp ? (
                                                            job
                                                              ?.newlyCreatedJobCardsDetails[0]
                                                              ?.jobcard
                                                              ?.comparison?.[
                                                              matchTrimLossKey
                                                            ] > 0 ? (
                                                              <span className="lesserSolution">
                                                                <img
                                                                  src={
                                                                    greaterRange
                                                                  }
                                                                  style={{
                                                                    marginRight:
                                                                      "10px",
                                                                  }}
                                                                />
                                                                {job
                                                                  ?.newlyCreatedJobCardsDetails[0]
                                                                  ?.jobcard
                                                                  ?.comparison?.[
                                                                  matchTrimLossKey
                                                                ]
                                                                  ? Math.abs(
                                                                      job
                                                                        ?.newlyCreatedJobCardsDetails[0]
                                                                        ?.jobcard
                                                                        ?.comparison?.[
                                                                        matchTrimLossKey
                                                                      ],
                                                                    )?.toFixed(
                                                                      3,
                                                                    )
                                                                  : 0}{" "}
                                                                % pts greater
                                                                than new sol 2
                                                              </span>
                                                            ) : (
                                                              <span className="lesserSolution">
                                                                <img
                                                                  src={
                                                                    lowerRange
                                                                  }
                                                                  style={{
                                                                    marginRight:
                                                                      "10px",
                                                                  }}
                                                                />
                                                                {job
                                                                  ?.newlyCreatedJobCardsDetails[0]
                                                                  ?.jobcard
                                                                  ?.comparison?.[
                                                                  matchTrimLossKey
                                                                ]
                                                                  ? Math.abs(
                                                                      job
                                                                        ?.newlyCreatedJobCardsDetails[0]
                                                                        ?.jobcard
                                                                        ?.comparison?.[
                                                                        matchTrimLossKey
                                                                      ],
                                                                    )?.toFixed(
                                                                      3,
                                                                    )
                                                                  : 0}{" "}
                                                                % pts lesser
                                                                than new sol 2
                                                              </span>
                                                            )
                                                            // ) : (
                                                            //   <></>
                                                            // )
                                                          }
                                                        </div>
                                                      </Col>

                                                      <Col span={12}>
                                                        <div className="summaryValue">
                                                          <h5>
                                                            <span className="trimBox"></span>{" "}
                                                            Fulfillment
                                                          </h5>
                                                          <span>
                                                            {`${job.newlyCreatedJobCardsDetails[0]?.jobcard?.solution_1?.data?.summary?.requirement_fulfilled_percentage?.toFixed(
                                                              3,
                                                            )} %`}
                                                          </span>
                                                          {
                                                            // job.jobcard.solution_1.data.summary
                                                            //   .max_fulfilled_orders_requirement_fulfillment_comparison_pp ? (
                                                            job
                                                              ?.newlyCreatedJobCardsDetails[0]
                                                              ?.jobcard
                                                              ?.comparison?.[
                                                              matchFulfilmentKey
                                                            ] > 0 ? (
                                                              <span className="lesserSolution">
                                                                <img
                                                                  src={
                                                                    greaterRange
                                                                  }
                                                                  style={{
                                                                    marginRight:
                                                                      "10px",
                                                                  }}
                                                                />
                                                                {job
                                                                  ?.newlyCreatedJobCardsDetails[0]
                                                                  ?.jobcard
                                                                  ?.comparison?.[
                                                                  matchFulfilmentKey
                                                                ]
                                                                  ? Math.abs(
                                                                      job
                                                                        ?.newlyCreatedJobCardsDetails[0]
                                                                        ?.jobcard
                                                                        ?.comparison?.[
                                                                        matchFulfilmentKey
                                                                      ],
                                                                    )?.toFixed(
                                                                      3,
                                                                    )
                                                                  : 0}{" "}
                                                                % pts greater
                                                                than new sol 2
                                                              </span>
                                                            ) : (
                                                              <span className="lesserSolution">
                                                                <img
                                                                  src={
                                                                    lowerRange
                                                                  }
                                                                  style={{
                                                                    marginRight:
                                                                      "10px",
                                                                  }}
                                                                />
                                                                {job
                                                                  ?.newlyCreatedJobCardsDetails[0]
                                                                  ?.jobcard
                                                                  ?.comparison?.[
                                                                  matchFulfilmentKey
                                                                ]
                                                                  ? Math.abs(
                                                                      job
                                                                        ?.newlyCreatedJobCardsDetails[0]
                                                                        ?.jobcard
                                                                        ?.comparison?.[
                                                                        matchFulfilmentKey
                                                                      ],
                                                                    )?.toFixed(
                                                                      3,
                                                                    )
                                                                  : 0}{" "}
                                                                % pts lesser
                                                                than new sol 2
                                                              </span>
                                                            )
                                                            // ) : (
                                                            //   <></>
                                                            // )
                                                          }
                                                        </div>
                                                      </Col>
                                                    </Row>
                                                    <Row span={24}>
                                                      <Col span={12}>
                                                        <div className="summaryValue">
                                                          <h5>
                                                            <span className="trimCut"></span>{" "}
                                                            Net Trim Loss:{" "}
                                                            {job.newlyCreatedJobCardsDetails[0]?.jobcard?.solution_1?.data?.summary?.net_trim_loss_percentage?.toFixed(
                                                              3,
                                                            )}{" "}
                                                            %
                                                            <p>
                                                              Loss including
                                                              edge trim
                                                            </p>
                                                          </h5>
                                                        </div>
                                                      </Col>
                                                      <Col span={12}>
                                                        <div className="summaryValue">
                                                          <h5>
                                                            <span className="trimBox"></span>{" "}
                                                            Weight:{" "}
                                                            {job.newlyCreatedJobCardsDetails[0]?.jobcard?.solution_1?.data?.summary?.job_card_weight?.toFixed(
                                                              3,
                                                            )}{" "}
                                                            {capitalize(
                                                              weightUnit[
                                                                job
                                                                  .newlyCreatedJobCardsDetails[0]
                                                                  ?.jobcard
                                                                  ?.solution_1
                                                                  ?.data
                                                                  ?.summary
                                                                  ?.units
                                                                  ?.job_card_weight
                                                              ]?.displayName,
                                                            )}
                                                            <p className="lesserSolution">
                                                              Total weight of
                                                              Job Card
                                                            </p>
                                                          </h5>
                                                        </div>
                                                      </Col>
                                                    </Row>
                                                  </>
                                                )}
                                                <Row span={24}>
                                                  <Col span={12}>
                                                    <ul>
                                                      <li>
                                                        <span>
                                                          Paper Machine
                                                        </span>
                                                        <p>
                                                          {
                                                            job
                                                              .newlyCreatedJobCardsDetails[0]
                                                              .jobcard.group
                                                              .machines[0].name
                                                          }
                                                        </p>
                                                      </li>
                                                      <li>
                                                        <span>Ply</span>
                                                        <p>{job.ply}</p>
                                                      </li>
                                                      <li>
                                                        <span>
                                                          Deckle Width
                                                        </span>
                                                        <p>{`${(
                                                          job
                                                            ?.newlyCreatedJobCardsDetails[0]
                                                            ?.jobcard.group
                                                            .machines[0]
                                                            .deckle_size_ub +
                                                          (job
                                                            ?.newlyCreatedJobCardsDetails[0]
                                                            ?.jobcard.group
                                                            .machines[0]
                                                            .left_edge_trim +
                                                            job
                                                              ?.newlyCreatedJobCardsDetails[0]
                                                              ?.jobcard.group
                                                              .machines[0]
                                                              .right_edge_trim) *
                                                            CoversionFactorUnitsToCM[
                                                              job
                                                                ?.newlyCreatedJobCardsDetails[0]
                                                                ?.jobcard.group
                                                                .machines[0]
                                                                .units
                                                                ?.right_edge_trim
                                                            ] *
                                                            CoversionFactorCMToUnits[
                                                              job
                                                                ?.newlyCreatedJobCardsDetails[0]
                                                                ?.jobcard.group
                                                                .machines[0]
                                                                .units
                                                                ?.deckle_size_ub
                                                            ]
                                                        )?.toFixed(
                                                          3,
                                                        )} - ${job.newlyCreatedJobCardsDetails[0]?.jobcard?.group.machines[0].deckle_size_lb?.toFixed(
                                                          3,
                                                        )}  ${lengthUnit[
                                                          job
                                                            .newlyCreatedJobCardsDetails[0]
                                                            .jobcard.group
                                                            .machines[0].units
                                                            ?.deckle_size_ub
                                                        ]?.displayName.toUpperCase()}`}</p>
                                                      </li>
                                                      <li>
                                                        <span>
                                                          Edge Trim ( Left /
                                                          Right )
                                                        </span>
                                                        <p>{`${
                                                          job
                                                            .newlyCreatedJobCardsDetails[0]
                                                            .jobcard.group
                                                            .machines[0]
                                                            .left_edge_trim
                                                        } ${lengthUnit[
                                                          job
                                                            .newlyCreatedJobCardsDetails[0]
                                                            .jobcard.group
                                                            .machines[0].units
                                                            ?.left_edge_trim
                                                        ]?.displayName.toUpperCase()} / ${
                                                          job
                                                            .newlyCreatedJobCardsDetails[0]
                                                            .jobcard.group
                                                            .machines[0]
                                                            .right_edge_trim
                                                        } ${lengthUnit[
                                                          job
                                                            .newlyCreatedJobCardsDetails[0]
                                                            .jobcard.group
                                                            .machines[0].units
                                                            ?.right_edge_trim
                                                        ]?.displayName.toUpperCase()}`}</p>
                                                      </li>
                                                      <li>
                                                        <span>
                                                          Number of Unique Sets
                                                        </span>
                                                        <p>
                                                          {job
                                                            .newlyCreatedJobCardsDetails[0]
                                                            ?.jobcard
                                                            ?.solution_1?.data
                                                            ?.summary
                                                            ?.unique_partitions
                                                            ? job
                                                                .newlyCreatedJobCardsDetails[0]
                                                                ?.jobcard
                                                                ?.solution_1
                                                                ?.data?.summary
                                                                ?.unique_partitions
                                                            : 0}
                                                        </p>
                                                      </li>
                                                      <li>
                                                        <span>
                                                          Avg. Deckle
                                                          Utilization
                                                        </span>
                                                        <p
                                                          style={{
                                                            wordWrap:
                                                              "break-word",
                                                          }}
                                                        >
                                                          {job?.newlyCreatedJobCardsDetails[0]?.jobcard?.solution_1?.data?.summary?.[
                                                            "avg_utilized_deckle_" +
                                                              job
                                                                ?.newlyCreatedJobCardsDetails[0]
                                                                ?.jobcard?.group
                                                                ?.machines[0]
                                                                ?.machine_id
                                                          ]?.toFixed(3)}{" "}
                                                          {job?.newlyCreatedJobCardsDetails[0]?.jobcard?.group?.machines[0]?.machine_id &&
                                                          job?.newlyCreatedJobCardsDetails[0]?.jobcard?.solution_1?.data?.summary?.units
                                                            ? lengthUnit[
                                                                job?.newlyCreatedJobCardsDetails[0]?.jobcard?.solution_1?.data?.summary?.units[
                                                                  "avg_utilized_deckle_" +
                                                                  job?.newlyCreatedJobCardsDetails[0]?.jobcard?.group?.machines[0]?.machine_id
                                                                ]
                                                              ]?.displayName?.toUpperCase()
                                                            : "CM"}
                                                        </p>
                                                      </li>
                                                    </ul>
                                                  </Col>
                                                  <Col span={12}>
                                                    <ul>
                                                      <li>
                                                        <span>Rewinder</span>
                                                        <p>
                                                          {
                                                            job
                                                              .newlyCreatedJobCardsDetails[0]
                                                              .jobcard.group
                                                              .machines[0].name
                                                          }
                                                        </p>
                                                      </li>
                                                      <li>
                                                        <span>
                                                          Product Specifications
                                                        </span>
                                                        <p
                                                          style={{
                                                            wordWrap:
                                                              "break-word",
                                                          }}
                                                        >
                                                          {
                                                            job
                                                              .newlyCreatedJobCardsDetails[0]
                                                              .jobcard.product
                                                              .product_spec
                                                          }
                                                        </p>
                                                      </li>
                                                      <li>
                                                        <span>
                                                          Fulfilled Quantity
                                                        </span>
                                                        <p>
                                                          {job
                                                            .newlyCreatedJobCardsDetails[0]
                                                            ?.jobcard
                                                            ?.solution_1?.data
                                                            ?.summary
                                                            ?.fulfilled_requirement_weight
                                                            ? `${job.newlyCreatedJobCardsDetails[0]?.jobcard?.solution_1?.data?.summary?.fulfilled_requirement_weight.toFixed(
                                                                3,
                                                              )} ${capitalize(
                                                                weightUnit[
                                                                  job
                                                                    ?.newlyCreatedJobCardsDetails[0]
                                                                    ?.jobcard
                                                                    ?.solution_1
                                                                    ?.data
                                                                    ?.summary
                                                                    ?.units
                                                                    ?.fulfilled_requirement_weight
                                                                ]?.displayName,
                                                              )}`
                                                            : 0}
                                                        </p>
                                                      </li>
                                                      <li>
                                                        <span>
                                                          Total Number of Sets
                                                        </span>
                                                        <p>
                                                          {job
                                                            .newlyCreatedJobCardsDetails[0]
                                                            ?.jobcard
                                                            ?.solution_1?.data
                                                            ?.summary
                                                            ?.total_partitions
                                                            ? job
                                                                .newlyCreatedJobCardsDetails[0]
                                                                ?.jobcard
                                                                ?.solution_1
                                                                ?.data?.summary
                                                                ?.total_partitions
                                                            : 0}
                                                        </p>
                                                      </li>
                                                      <li>
                                                        <span>
                                                          Priority Quantity
                                                        </span>
                                                        <p>
                                                          {job
                                                            ?.newlyCreatedJobCardsDetails[0]
                                                            ?.jobcard
                                                            ?.solution_1?.data
                                                            ?.summary
                                                            ?.forced_requirement_fulfilled
                                                            ? job.newlyCreatedJobCardsDetails[0]?.jobcard.solution_1.data.summary.forced_requirement_fulfilled.toFixed(
                                                                3,
                                                              )
                                                            : 0}{" "}
                                                          {job
                                                            ?.newlyCreatedJobCardsDetails[0]
                                                            ?.jobcard
                                                            ?.solution_1?.data
                                                            ?.summary?.units
                                                            ?.forced_requirement_fulfilled
                                                            ? capitalize(
                                                                weightUnit[
                                                                  job
                                                                    ?.newlyCreatedJobCardsDetails[0]
                                                                    ?.jobcard
                                                                    ?.solution_1
                                                                    ?.data
                                                                    ?.summary
                                                                    ?.units
                                                                    .forced_requirement_fulfilled
                                                                ].displayName,
                                                              )
                                                            : "T"}
                                                        </p>
                                                      </li>
                                                    </ul>
                                                  </Col>
                                                </Row>

                                                {/* Removed Approved Remarks */}
                                              </div>
                                            </Panes>
                                            <Panes
                                              tab={
                                                <span>
                                                  Size Fulfilment
                                                  {activeTab == "2" && (
                                                    <Button
                                                      key="1"
                                                      style={{ border: "none" }}
                                                      onClick={(e) =>
                                                        setSizeExpanded(
                                                          !sizeExpanded,
                                                        )
                                                      }
                                                    >
                                                      <Iconmoon
                                                        icon={
                                                          sizeExpanded
                                                            ? "contract_arrow"
                                                            : "expand_arrow"
                                                        }
                                                        size={14}
                                                        color="#EA4E2C"
                                                      />
                                                    </Button>
                                                  )}
                                                </span>
                                              }
                                              key="2"
                                            >
                                              <TableLayoutData>
                                                <div
                                                  className="tableDataFormat  "
                                                  style={{ marginTop: "25px" }}
                                                >
                                                  <Table
                                                    columns={
                                                      sizeFulfillmentColumnsHead
                                                    }
                                                    dataSource={
                                                      !job
                                                        ?.newlyCreatedJobCardsDetails[0]
                                                        ?.jobcard?.solution_1
                                                        ?.data.exception &&
                                                      newSolSizeList1
                                                    }
                                                    onChange={(
                                                      pagination,
                                                    ) => {}}
                                                    scroll={{ x: 1200 }}
                                                    rowClassName={(record) =>
                                                      record.priority && "true"
                                                    }
                                                    pagination={{
                                                      current: currentPage,
                                                      pageSize: pageSize,
                                                      total:
                                                        !job
                                                          ?.newlyCreatedJobCardsDetails[0]
                                                          ?.jobcard?.solution_1
                                                          ?.data.exception &&
                                                        newSolSizeList1?.length,
                                                      onChange:
                                                        onPaginationChange,
                                                      showSizeChanger: true,
                                                      showQuickJumper: true,
                                                      // showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                                                    }}
                                                  />
                                                </div>
                                              </TableLayoutData>
                                            </Panes>
                                            {!job.newlyCreatedJobCardsDetails[0]
                                              ?.jobcard?.solution_1.data
                                              .exception && (
                                              <Panes
                                                tab={
                                                  <span>
                                                    Order Fulfillment
                                                    {activeTab == "3" && (
                                                      <Button
                                                        key="1"
                                                        style={{
                                                          border: "none",
                                                        }}
                                                        onClick={(e) =>
                                                          setSizeExpanded(
                                                            !sizeExpanded,
                                                          )
                                                        }
                                                      >
                                                        <Iconmoon
                                                          icon={
                                                            sizeExpanded
                                                              ? "contract_arrow"
                                                              : "expand_arrow"
                                                          }
                                                          size={14}
                                                          color="#EA4E2C"
                                                        />
                                                      </Button>
                                                    )}
                                                  </span>
                                                }
                                                key="3"
                                                // disabled={solutionSummary?.solution1.exception}
                                              >
                                                <TableLayoutData>
                                                  <div
                                                    className="tableDataFormat"
                                                    style={{
                                                      marginTop: "25px",
                                                    }}
                                                  >
                                                    {isFetchingData ? (
                                                      <TableShimmer
                                                        header={orderFulfillmentColumnsHead}
                                                        scroll={1300}
                                                      />
                                                    ) : (
                                                      <Table
                                                        columns={orderFulfillmentColumnsHead}
                                                        dataSource={stockSizeDetailsList1}
                                                        onChange={onChange}
                                                        scroll={{ x: 1800 }}
                                                        rowClassName={(
                                                          record,
                                                        ) =>
                                                          record.priority &&
                                                          "true"
                                                        }
                                                        pagination={{
                                                          current: currentPage,
                                                          pageSize: pageSize,
                                                          total:
                                                            stockSizeDetailsList1?.length,
                                                          onChange:
                                                            onPaginationChange,
                                                          showSizeChanger: true,
                                                          showQuickJumper: true,
                                                          // showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                                                        }}
                                                      />
                                                    )}
                                                  </div>
                                                </TableLayoutData>
                                              </Panes>
                                            )}
                                            {/* <Panes
                                              tab={
                                                <span>
                                                  Unfulfilled Orders
                                                  {activeTab == "4" && (
                                                    <Button
                                                      key="1"
                                                      style={{ border: "none" }}
                                                      onClick={(e) =>
                                                        setSizeExpanded(
                                                          !sizeExpanded,
                                                        )
                                                      }
                                                    >
                                                      <Iconmoon
                                                        icon={
                                                          sizeExpanded
                                                            ? "contract_arrow"
                                                            : "expand_arrow"
                                                        }
                                                        size={14}
                                                        color="#EA4E2C"
                                                      />
                                                    </Button>
                                                  )}
                                                </span>
                                              }
                                              key="4"
                                              // disabled={solutionSummary?.solution1.exception}
                                            >
                                              <TableLayoutData>
                                                <div
                                                  className="tableDataFormat"
                                                  style={{ marginTop: "25px" }}
                                                >
                                                  {isFetchingData ? (
                                                    <TableShimmer
                                                      header={
                                                        unfulfilledColumnsHead
                                                      }
                                                      scroll={1300}
                                                    />
                                                  ) : (
                                                    <Table
                                                      columns={
                                                        unfulfilledColumnsHead
                                                      }
                                                      dataSource={
                                                        job
                                                          .newlyCreatedJobCardsDetails[0]
                                                          ?.jobcard?.solution_1
                                                          .data.exception
                                                          ? failedJobOrders
                                                          : stockSizeDetailsList1?.filter(
                                                              (order) =>
                                                                parseFloat(
                                                                  order.unFulflilledWeight.split(
                                                                    " ",
                                                                  )[0],
                                                                ) > 0,
                                                            )
                                                      }
                                                      onChange={(pagination) =>
                                                        onChange(
                                                          pagination,
                                                          true,
                                                        )
                                                      }
                                                      scroll={{ x: 1800 }}
                                                      rowClassName={(record) =>
                                                        record.priority &&
                                                        "true"
                                                      }
                                                      pagination={{
                                                        current: currentPage,
                                                        pageSize: pageSize,
                                                        total:
                                                          totalUnfulfilledOrders,
                                                        onChange:
                                                          onPaginationChange,
                                                        showSizeChanger: true,
                                                        showQuickJumper: true,
                                                        // showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                                                      }}
                                                    />
                                                  )}
                                                </div>
                                              </TableLayoutData>
                                            </Panes> */}
                                            <Panes
                                              tab={
                                                <span>
                                                  Intermediate Reels
                                                  {activeTab == "5" && (
                                                    <Button
                                                      key="1"
                                                      style={{ border: "none" }}
                                                      onClick={(e) =>
                                                        setSizeExpanded(
                                                          !sizeExpanded,
                                                        )
                                                      }
                                                    >
                                                      <Iconmoon
                                                        icon={
                                                          sizeExpanded
                                                            ? "contract_arrow"
                                                            : "expand_arrow"
                                                        }
                                                        size={14}
                                                        color="#EA4E2C"
                                                      />
                                                    </Button>
                                                  )}
                                                </span>
                                              }
                                              key="5"
                                              // disabled={solutionSummary?.solution1.exception}
                                            >
                                              <TableLayoutData>
                                                <div
                                                  className="tableDataFormat"
                                                  style={{ marginTop: "25px" }}
                                                >
                                                  <Table
                                                    columns={
                                                      intermediateColumnsHead
                                                    }
                                                    dataSource={
                                                      intermediateNewSolutionData1
                                                    }
                                                    onChange={(
                                                      pagination,
                                                    ) => {}}
                                                    scroll={{ x: 1200 }}
                                                    rowClassName={(record) =>
                                                      record.priority && "true"
                                                    }
                                                  />
                                                </div>
                                              </TableLayoutData>
                                            </Panes>
                                          </Tabs>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Panes>
                                )}
                              {!failedNewSol[jobIndex] &&
                                job.newlyCreatedJobCardsDetails?.length &&
                                job.newlyCreatedJobCardsDetails?.[0]?.jobcard
                                  ?.solution_2?.data?.summary &&
                                job.newlyCreatedJobCardsDetails?.[0]?.jobcard
                                  ?.solution_1?.status != "accept" &&
                                job.jobcard.solution_1.status != "accept" &&
                                job.jobcard.solution_2.status != "accept" && (
                                  <Panes
                                    tab="New Solution 2"
                                    key={
                                      job.newlyCreatedJobCardsDetails?.[0]
                                        ?.jobcard?.solution_2?.status ===
                                      "accept"
                                        ? "1"
                                        : "4"
                                    }
                                  >
                                    <PageTitleComp
                                      style={{ borderBottom: "0" }}
                                    >
                                      <PageHeader
                                        ghost={false}
                                        title={
                                          <div
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "50px",
                                            }}
                                          >
                                            <span>
                                              {job.state == "pending"
                                                ? activeJC &&
                                                  activeJC != undefined
                                                  ? activeJC
                                                  : ""
                                                : "Job Card " +
                                                  (activeJC &&
                                                  activeJC != undefined
                                                    ? activeJC
                                                    : "")}
                                            </span>
                                            {/* {job.state == "pending" ? (
                                            (activeJC?.length > 20 ? (
                                              <Tooltip placement="bottomLeft" title={activeJC}>
                                                {activeJC?.slice(0,21)+"..."}
                                              </Tooltip>
                                              ) : (
                                                activeJC
                                            ))
                                            ) : (
                                            ("Job Card " + activeJC)
                                            )
                                          } */}
                                          </div>
                                        }
                                        extra={
                                          !job.newlyCreatedJobCardsDetails?.[0]
                                            ?.jobcard?.solution_2?.data
                                            ?.exception && [
                                            job.newlyCreatedJobCardsDetails?.[0]
                                              ?.jobcard?.solution_2?.status ===
                                            "accept" ? (
                                              <AlertContainer
                                                color="green"
                                                icon={alertGreen}
                                                msg="The solution is sent for approval"
                                              />
                                            ) : job.newlyCreatedJobCardsDetails?.[0]
                                                ?.jobcard?.solution_2?.status ===
                                              "reject" ? (
                                              job.newlyCreatedJobCardsDetails?.[0]
                                                ?.jobcard?.solution_1.status ===
                                              "accept" ? (
                                                <AlertContainer
                                                  color="green"
                                                  icon={alertGreen}
                                                  msg="The new solution 1 is already accepted"
                                                />
                                              ) : job.jobcard.solution_1
                                                  .status === "accept" ? (
                                                <AlertContainer
                                                  color="green"
                                                  icon={alertGreen}
                                                  msg="The solution 1 is already accepted"
                                                />
                                              ) : job.jobcard.solution_2
                                                  .status === "accept" ? (
                                                <AlertContainer
                                                  color="green"
                                                  icon={alertGreen}
                                                  msg="The solution 2 is already accepted"
                                                />
                                              ) : (
                                                <AlertContainer
                                                  color="red"
                                                  icon={alertRed}
                                                  msg="The solution is discarded by the user"
                                                />
                                              )
                                            ) : (
                                              <RightSideSolution>
                                                <div className="rightSideSolutionButtons">
                                                  <Button
                                                    key="1"
                                                    className="themeBtn noBg"
                                                    onClick={() =>
                                                      discardModalShow(
                                                        "solution2",
                                                      )
                                                    }
                                                    // disabled={
                                                    //   jobCardDetailsList[jobIndex]?.jobcard.solution_1.exception
                                                    // }
                                                  >
                                                    <Iconmoon
                                                      icon="wrong"
                                                      size={14}
                                                      color="#EA4E2C"
                                                    />
                                                    Discard Solution
                                                  </Button>

                                                  <Button
                                                    key="2"
                                                    className="themeBtn"
                                                    onClick={() =>
                                                      acceptModalShow(
                                                        "solution2",
                                                      )
                                                    }
                                                    // disabled={
                                                    //   jobCardDetailsList[jobIndex]?.jobcard.solution_1.exception
                                                    // }
                                                  >
                                                    <Iconmoon
                                                      icon="correct"
                                                      size={14}
                                                      color="#ffffff"
                                                    />
                                                    Accept Solution
                                                  </Button>
                                                </div>
                                              </RightSideSolution>
                                            ),
                                          ]
                                        }
                                      ></PageHeader>
                                    </PageTitleComp>
                                    <div className="MatchResult">
                                      <Row
                                        span={24}
                                        className="pipeBlockCylinder"
                                      >
                                        {((!sizeExpanded && activeTab == "2") ||
                                          (!sizeExpanded && activeTab == "3") ||
                                          (!sizeExpanded && activeTab == "4") ||
                                          (!sizeExpanded && activeTab == "5") ||
                                          activeTab == "1") && (
                                          <Col
                                            span={15}
                                            className="pipeBlock"
                                            style={{ paddingRight: "20px" }}
                                          >
                                            <RightSideSolution>
                                              {!job
                                                .newlyCreatedJobCardsDetails[0]
                                                .jobcard.solution_2.data
                                                .exception ? (
                                                // jobCardDetailsList && (
                                                <JobCardCylinderContainer
                                                  jobId={
                                                    job
                                                      .newlyCreatedJobCardsDetails[0]
                                                      ?.jobcard?.solution_2
                                                      .status === "accept"
                                                      ? location?.state?.type === "replan" ? location?.state?.parentJCid : job.id
                                                      : job
                                                          .newlyCreatedJobCardsDetails[0]
                                                          .id
                                                  }
                                                  solution={2}
                                                  multiView={true}
                                                  deckle_match_page={true}
                                                  solId={solId}
                                                />
                                              ) : (
                                                // )
                                                <>
                                                  <div className="deckleCoverImage">
                                                    <img
                                                      src={deckleCover}
                                                      alt="deckle match result"
                                                    />
                                                  </div>
                                                  {/* Exception message */}
                                                  <div className="colLayoutBlock deckleErrorLayout">
                                                    <p
                                                      style={{
                                                        color: "#EA655B",
                                                      }}
                                                    >
                                                      {
                                                        job
                                                          .newlyCreatedJobCardsDetails[0]
                                                          .jobcard.solution_2
                                                          .data.exception
                                                      }
                                                    </p>
                                                  </div>
                                                </>
                                              )}
                                            </RightSideSolution>
                                          </Col>
                                        )}
                                        <Col
                                          span={
                                            ((sizeExpanded &&
                                              activeTab == "2") ||
                                              (sizeExpanded &&
                                                activeTab == "3") ||
                                              (sizeExpanded &&
                                                activeTab == "4") ||
                                              (sizeExpanded &&
                                                activeTab == "5")) &&
                                            activeTab != "1"
                                              ? 24
                                              : 9
                                          }
                                          className="colLayoutBlock"
                                        >
                                          {/* Exception message */}
                                          {/* {!jobCardDetailsList[jobIndex]?.solution2.summary ? (
                            <></>
                          ) : (
                            <p style={{ color: "#EA655B" }}>
                              {job.solution2.exception}
                            </p>
                          )} */}

                                          <Tabs
                                            defaultActiveKey={activeTab}
                                            activeKey={activeTab}
                                            className="topPostTab innerPostTab"
                                            onChange={tabChange}
                                          >
                                            <Panes
                                              tab="Solution 2 summary"
                                              key="1"
                                              // disabled={jobCardDetailsList[jobIndex]?.solution2.exception}
                                            >
                                              <div className="lossValue">
                                                {!job
                                                  .newlyCreatedJobCardsDetails[0]
                                                  .jobcard.solution_2.data
                                                  .exception && (
                                                  <>
                                                    <Row span={24}>
                                                      <Col span={12}>
                                                        <div className="summaryValue">
                                                          <h5>
                                                            <span className="trimCut"></span>{" "}
                                                            Trim Loss
                                                          </h5>
                                                          <span>
                                                            {`${job.newlyCreatedJobCardsDetails[0]?.jobcard?.solution_2?.data?.summary?.match_trim_loss_percentage.toFixed(
                                                              3,
                                                            )} %`}
                                                          </span>
                                                          {
                                                            // job.jobcard.solution_1.data
                                                            //   .summary
                                                            //   .max_fulfilled_orders_match_trim_loss_comparison_pp ? (
                                                            job
                                                              ?.newlyCreatedJobCardsDetails[0]
                                                              ?.jobcard
                                                              ?.comparison?.[
                                                              matchTrimLossKey
                                                            ] < 0 ? (
                                                              <span className="lesserSolution">
                                                                <img
                                                                  src={
                                                                    greaterRange
                                                                  }
                                                                  style={{
                                                                    marginRight:
                                                                      "10px",
                                                                  }}
                                                                />
                                                                {job
                                                                  ?.newlyCreatedJobCardsDetails[0]
                                                                  ?.jobcard
                                                                  ?.comparison?.[
                                                                  matchTrimLossKey
                                                                ]
                                                                  ? Math.abs(
                                                                      job
                                                                        ?.newlyCreatedJobCardsDetails[0]
                                                                        ?.jobcard
                                                                        ?.comparison?.[
                                                                        matchTrimLossKey
                                                                      ],
                                                                    )?.toFixed(
                                                                      3,
                                                                    )
                                                                  : 0}{" "}
                                                                % pts greater
                                                                than new sol 1
                                                              </span>
                                                            ) : (
                                                              <span className="lesserSolution">
                                                                <img
                                                                  src={
                                                                    lowerRange
                                                                  }
                                                                  style={{
                                                                    marginRight:
                                                                      "10px",
                                                                  }}
                                                                />
                                                                {job
                                                                  ?.newlyCreatedJobCardsDetails[0]
                                                                  ?.jobcard
                                                                  ?.comparison?.[
                                                                  matchTrimLossKey
                                                                ]
                                                                  ? Math.abs(
                                                                      job
                                                                        ?.newlyCreatedJobCardsDetails[0]
                                                                        ?.jobcard
                                                                        ?.comparison?.[
                                                                        matchTrimLossKey
                                                                      ],
                                                                    )?.toFixed(
                                                                      3,
                                                                    )
                                                                  : 0}{" "}
                                                                % pts lesser
                                                                than new sol 1
                                                              </span>
                                                            )
                                                            // ) : (
                                                            //   <></>
                                                            // )
                                                          }
                                                        </div>
                                                      </Col>
                                                      <Col span={12}>
                                                        <div className="summaryValue">
                                                          <h5>
                                                            <span className="trimBox"></span>{" "}
                                                            Fulfillment
                                                          </h5>
                                                          <span>
                                                            {`${job.newlyCreatedJobCardsDetails[0]?.jobcard?.solution_2?.data?.summary?.requirement_fulfilled_percentage?.toFixed(
                                                              3,
                                                            )} %`}
                                                          </span>
                                                          {
                                                            // job.jobcard.solution_1.data
                                                            //   .summary
                                                            //   .max_fulfilled_orders_requirement_fulfillment_comparison_pp ? (
                                                            job
                                                              ?.newlyCreatedJobCardsDetails[0]
                                                              ?.jobcard
                                                              ?.comparison?.[
                                                              matchFulfilmentKey
                                                            ] < 0 ? (
                                                              <span className="lesserSolution">
                                                                <img
                                                                  src={
                                                                    greaterRange
                                                                  }
                                                                  style={{
                                                                    marginRight:
                                                                      "10px",
                                                                  }}
                                                                />
                                                                {job
                                                                  ?.newlyCreatedJobCardsDetails[0]
                                                                  ?.jobcard
                                                                  ?.comparison?.[
                                                                  matchFulfilmentKey
                                                                ]
                                                                  ? Math.abs(
                                                                      job
                                                                        ?.newlyCreatedJobCardsDetails[0]
                                                                        ?.jobcard
                                                                        ?.comparison?.[
                                                                        matchFulfilmentKey
                                                                      ],
                                                                    )?.toFixed(
                                                                      3,
                                                                    )
                                                                  : 0}{" "}
                                                                % pts greater
                                                                than new sol 1
                                                              </span>
                                                            ) : (
                                                              <span className="lesserSolution">
                                                                <img
                                                                  src={
                                                                    lowerRange
                                                                  }
                                                                  style={{
                                                                    marginRight:
                                                                      "10px",
                                                                  }}
                                                                />
                                                                {job
                                                                  ?.newlyCreatedJobCardsDetails[0]
                                                                  ?.jobcard
                                                                  ?.comparison?.[
                                                                  matchFulfilmentKey
                                                                ]
                                                                  ? Math.abs(
                                                                      job
                                                                        ?.newlyCreatedJobCardsDetails[0]
                                                                        ?.jobcard
                                                                        ?.comparison?.[
                                                                        matchFulfilmentKey
                                                                      ],
                                                                    )?.toFixed(
                                                                      3,
                                                                    )
                                                                  : 0}{" "}
                                                                % pts lesser
                                                                than new sol 1
                                                              </span>
                                                            )
                                                            // ) : (
                                                            //   <></>
                                                            // )
                                                          }
                                                        </div>
                                                      </Col>
                                                    </Row>
                                                    <Row span={24}>
                                                      <Col span={12}>
                                                        <div className="summaryValue">
                                                          <h5>
                                                            <span className="trimCut"></span>{" "}
                                                            Net Trim Loss:{" "}
                                                            {job.newlyCreatedJobCardsDetails[0]?.jobcard?.solution_2?.data?.summary?.net_trim_loss_percentage?.toFixed(
                                                              3,
                                                            )}{" "}
                                                            %
                                                            <p>
                                                              Loss including
                                                              edge trim
                                                            </p>
                                                          </h5>
                                                        </div>
                                                      </Col>
                                                      <Col span={12}>
                                                        <div className="summaryValue">
                                                          <h5>
                                                            <span className="trimBox"></span>{" "}
                                                            Weight:{" "}
                                                            {job.newlyCreatedJobCardsDetails[0]?.jobcard?.solution_2?.data?.summary?.job_card_weight?.toFixed(
                                                              3,
                                                            )}{" "}
                                                            {capitalize(
                                                              weightUnit[
                                                                job
                                                                  .newlyCreatedJobCardsDetails[0]
                                                                  .jobcard
                                                                  .solution_2
                                                                  .data.summary
                                                                  .units
                                                                  ?.job_card_weight
                                                              ]?.displayName,
                                                            )}
                                                            <p className="lesserSolution">
                                                              Total weight of
                                                              Job Card
                                                            </p>
                                                          </h5>
                                                        </div>
                                                      </Col>
                                                    </Row>
                                                  </>
                                                )}
                                                <Row span={24}>
                                                  <Col span={12}>
                                                    <ul>
                                                      <li>
                                                        <span>
                                                          Paper Machine
                                                        </span>
                                                        <p>
                                                          {
                                                            job
                                                              .newlyCreatedJobCardsDetails[0]
                                                              .jobcard.group
                                                              .machines[0].name
                                                          }
                                                        </p>
                                                      </li>
                                                      <li>
                                                        <span>Ply</span>
                                                        <p>{job.ply}</p>
                                                      </li>
                                                      <li>
                                                        <span>
                                                          Deckle Width
                                                        </span>
                                                        <p>{`${(
                                                          job
                                                            ?.newlyCreatedJobCardsDetails[0]
                                                            ?.jobcard.group
                                                            .machines[0]
                                                            .deckle_size_ub +
                                                          (job
                                                            ?.newlyCreatedJobCardsDetails[0]
                                                            ?.jobcard.group
                                                            .machines[0]
                                                            .left_edge_trim +
                                                            job
                                                              ?.newlyCreatedJobCardsDetails[0]
                                                              ?.jobcard.group
                                                              .machines[0]
                                                              .right_edge_trim) *
                                                            CoversionFactorUnitsToCM[
                                                              job
                                                                ?.newlyCreatedJobCardsDetails[0]
                                                                ?.jobcard.group
                                                                .machines[0]
                                                                .units
                                                                ?.right_edge_trim
                                                            ] *
                                                            CoversionFactorCMToUnits[
                                                              job
                                                                ?.newlyCreatedJobCardsDetails[0]
                                                                ?.jobcard.group
                                                                .machines[0]
                                                                .units
                                                                ?.deckle_size_ub
                                                            ]
                                                        )?.toFixed(
                                                          3,
                                                        )} - ${job.newlyCreatedJobCardsDetails[0]?.jobcard?.group.machines[0].deckle_size_lb?.toFixed(
                                                          3,
                                                        )} ${lengthUnit[
                                                          job
                                                            .newlyCreatedJobCardsDetails[0]
                                                            .jobcard.group
                                                            .machines[0].units
                                                            ?.deckle_size_ub
                                                        ]?.displayName.toUpperCase()}`}</p>
                                                      </li>
                                                      <li>
                                                        <span>
                                                          Edge Trim ( Left /
                                                          Right )
                                                        </span>
                                                        <p>{`${
                                                          job
                                                            .newlyCreatedJobCardsDetails[0]
                                                            .jobcard.group
                                                            .machines[0]
                                                            .left_edge_trim
                                                        } ${lengthUnit[
                                                          job
                                                            .newlyCreatedJobCardsDetails[0]
                                                            .jobcard.group
                                                            .machines[0].units
                                                            ?.left_edge_trim
                                                        ]?.displayName.toUpperCase()} / ${
                                                          job
                                                            .newlyCreatedJobCardsDetails[0]
                                                            .jobcard.group
                                                            .machines[0]
                                                            .right_edge_trim
                                                        } ${lengthUnit[
                                                          job
                                                            .newlyCreatedJobCardsDetails[0]
                                                            .jobcard.group
                                                            .machines[0].units
                                                            ?.right_edge_trim
                                                        ]?.displayName.toUpperCase()}`}</p>
                                                      </li>
                                                      <li>
                                                        <span>
                                                          Number of Unique Sets
                                                        </span>
                                                        <p>
                                                          {job
                                                            .newlyCreatedJobCardsDetails[0]
                                                            .jobcard.solution_2
                                                            .data.summary
                                                            .unique_partitions
                                                            ? job
                                                                .newlyCreatedJobCardsDetails[0]
                                                                .jobcard
                                                                .solution_2.data
                                                                .summary
                                                                .unique_partitions
                                                            : 0}
                                                        </p>
                                                      </li>
                                                      <li>
                                                        <span>
                                                          Avg. Deckle
                                                          Utilization
                                                        </span>
                                                        <p
                                                          style={{
                                                            wordWrap:
                                                              "break-word",
                                                          }}
                                                        >
                                                          {job?.newlyCreatedJobCardsDetails[0]?.jobcard?.solution_2?.data?.summary?.[
                                                            "avg_utilized_deckle_" +
                                                              job
                                                                ?.newlyCreatedJobCardsDetails[0]
                                                                ?.jobcard?.group
                                                                ?.machines[0]
                                                                ?.machine_id
                                                          ]?.toFixed(3)}{" "}
                                                          {job?.newlyCreatedJobCardsDetails[0]?.jobcard?.group?.machines[0]?.machine_id &&
                                                          job?.newlyCreatedJobCardsDetails[0]?.jobcard?.solution_2?.data?.summary?.units
                                                            ? lengthUnit[
                                                                job?.newlyCreatedJobCardsDetails[0]?.jobcard?.solution_2?.data?.summary?.units[
                                                                  "avg_utilized_deckle_" +
                                                                  job?.newlyCreatedJobCardsDetails[0]?.jobcard?.group?.machines[0]?.machine_id
                                                                ]
                                                              ]?.displayName?.toUpperCase()
                                                            : "CM"}
                                                        </p>
                                                      </li>
                                                    </ul>
                                                  </Col>
                                                  <Col span={12}>
                                                    <ul>
                                                      <li>
                                                        <span>Rewinder</span>
                                                        <p
                                                          style={{
                                                            wordWrap:
                                                              "break-word",
                                                          }}
                                                        >
                                                          {
                                                            job
                                                              .newlyCreatedJobCardsDetails[0]
                                                              .jobcard.group
                                                              .machines[0]
                                                              .rewinder_name
                                                          }
                                                        </p>
                                                      </li>
                                                      <li>
                                                        <span>
                                                          Product Specifications
                                                        </span>
                                                        <p
                                                          style={{
                                                            wordWrap:
                                                              "break-word",
                                                          }}
                                                        >
                                                          {
                                                            job
                                                              .newlyCreatedJobCardsDetails[0]
                                                              .jobcard.product
                                                              .product_spec
                                                          }
                                                        </p>
                                                      </li>
                                                      <li>
                                                        <span>
                                                          Fulfilled Quantity
                                                        </span>
                                                        <p>
                                                          {job
                                                            .newlyCreatedJobCardsDetails[0]
                                                            .jobcard.solution_2
                                                            .data.summary
                                                            .fulfilled_requirement_weight
                                                            ? `${job.newlyCreatedJobCardsDetails[0]?.jobcard?.solution_2?.data?.summary?.fulfilled_requirement_weight.toFixed(
                                                                3,
                                                              )} ${capitalize(
                                                                weightUnit[
                                                                  job
                                                                    .newlyCreatedJobCardsDetails[0]
                                                                    .jobcard
                                                                    .solution_1
                                                                    .data
                                                                    .summary
                                                                    .units
                                                                    ?.fulfilled_requirement_weight
                                                                ]?.displayName,
                                                              )}`
                                                            : 0}
                                                        </p>
                                                      </li>
                                                      <li>
                                                        <span>
                                                          Total Number of Sets
                                                        </span>
                                                        <p>
                                                          {job
                                                            .newlyCreatedJobCardsDetails[0]
                                                            .jobcard.solution_2
                                                            .data.summary
                                                            .total_partitions
                                                            ? job
                                                                .newlyCreatedJobCardsDetails[0]
                                                                .jobcard
                                                                .solution_2.data
                                                                .summary
                                                                .total_partitions
                                                            : 0}
                                                        </p>
                                                      </li>
                                                      <li>
                                                        <span>
                                                          Priority Quantity
                                                        </span>
                                                        <p>
                                                          {job
                                                            ?.newlyCreatedJobCardsDetails[0]
                                                            ?.jobcard
                                                            ?.solution_2?.data
                                                            ?.summary
                                                            ?.forced_requirement_fulfilled
                                                            ? job.newlyCreatedJobCardsDetails[0]?.jobcard.solution_2.data.summary.forced_requirement_fulfilled.toFixed(
                                                                3,
                                                              )
                                                            : 0}{" "}
                                                          {job
                                                            ?.newlyCreatedJobCardsDetails[0]
                                                            ?.jobcard
                                                            ?.solution_2?.data
                                                            .summary?.units
                                                            ?.forced_requirement_fulfilled
                                                            ? capitalize(
                                                                weightUnit[
                                                                  job
                                                                    ?.newlyCreatedJobCardsDetails[0]
                                                                    ?.jobcard
                                                                    ?.solution_2
                                                                    ?.data
                                                                    .summary
                                                                    ?.units
                                                                    .forced_requirement_fulfilled
                                                                ].displayName,
                                                              )
                                                            : "T"}
                                                        </p>
                                                      </li>
                                                    </ul>
                                                  </Col>
                                                </Row>

                                                {/* Removed Approved Remarks     */}
                                              </div>
                                            </Panes>
                                            <Panes
                                              tab={
                                                <span>
                                                  Size Fulfilment
                                                  {activeTab == "2" && (
                                                    <Button
                                                      key="1"
                                                      style={{ border: "none" }}
                                                      onClick={(e) =>
                                                        setSizeExpanded(
                                                          !sizeExpanded,
                                                        )
                                                      }
                                                    >
                                                      <Iconmoon
                                                        icon={
                                                          sizeExpanded
                                                            ? "contract_arrow"
                                                            : "expand_arrow"
                                                        }
                                                        size={14}
                                                        color="#EA4E2C"
                                                      />
                                                    </Button>
                                                  )}
                                                </span>
                                              }
                                              key="2"
                                            >
                                              <TableLayoutData>
                                                <div
                                                  className="tableDataFormat  "
                                                  style={{ marginTop: "25px" }}
                                                >
                                                  <Table
                                                    columns={
                                                      sizeFulfillmentColumnsHead
                                                    }
                                                    dataSource={
                                                      !job
                                                        ?.newlyCreatedJobCardsDetails[0]
                                                        ?.jobcard?.solution_2
                                                        ?.data.exception &&
                                                      newSolSizeList2
                                                    }
                                                    onChange={(
                                                      pagination,
                                                    ) => {}}
                                                    scroll={{ x: 1200 }}
                                                    rowClassName={(record) =>
                                                      record.priority && "true"
                                                    }
                                                    pagination={{
                                                      current: currentPage,
                                                      pageSize: pageSize,
                                                      total:
                                                        !job
                                                          ?.newlyCreatedJobCardsDetails[0]
                                                          ?.jobcard?.solution_1
                                                          ?.data.exception &&
                                                        newSolSizeList2?.length,
                                                      onChange:
                                                        onPaginationChange,
                                                      showSizeChanger: true,
                                                      showQuickJumper: true,
                                                      // showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                                                    }}
                                                  />
                                                </div>
                                              </TableLayoutData>
                                            </Panes>
                                            {!job.newlyCreatedJobCardsDetails[0]
                                              .jobcard.solution_2.data
                                              .exception && (
                                              <Panes
                                                tab={
                                                  <span>
                                                    Order Fulfillment
                                                    {activeTab == "3" && (
                                                      <Button
                                                        key="1"
                                                        style={{
                                                          border: "none",
                                                        }}
                                                        onClick={(e) =>
                                                          setSizeExpanded(
                                                            !sizeExpanded,
                                                          )
                                                        }
                                                      >
                                                        <Iconmoon
                                                          icon={
                                                            sizeExpanded
                                                              ? "contract_arrow"
                                                              : "expand_arrow"
                                                          }
                                                          size={14}
                                                          color="#EA4E2C"
                                                        />
                                                      </Button>
                                                    )}
                                                  </span>
                                                }
                                                key="3"
                                                // disabled={jobCardDetailsList[jobIndex]?.solution2.exception}
                                              >
                                                <TableLayoutData>
                                                  <div
                                                    className="tableDataFormat"
                                                    style={{
                                                      marginTop: "25px",
                                                    }}
                                                  >
                                                    {isFetchingData ? (
                                                      <TableShimmer
                                                        header={orderFulfillmentColumnsHead}
                                                        scroll={1300}
                                                      />
                                                    ) : (
                                                      <Table
                                                        columns={orderFulfillmentColumnsHead}
                                                        dataSource={stockSizeDetailsList2}
                                                        onChange={onChange}
                                                        scroll={{ x: 1800 }}
                                                        rowClassName={(
                                                          record,
                                                        ) =>
                                                          record.priority &&
                                                          "true"
                                                        }
                                                        pagination={{
                                                          current: currentPage,
                                                          pageSize: pageSize,
                                                          total:
                                                            stockSizeDetailsList2?.length,
                                                          onChange:
                                                            onPaginationChange,
                                                          showSizeChanger: true,
                                                          showQuickJumper: true,
                                                          // showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                                                        }}
                                                      />
                                                    )}
                                                  </div>
                                                </TableLayoutData>
                                              </Panes>
                                            )}
                                            {/* <Panes
                                              tab={
                                                <span>
                                                  Unfulfilled Orders
                                                  {activeTab == "4" && (
                                                    <Button
                                                      key="1"
                                                      style={{ border: "none" }}
                                                      onClick={(e) =>
                                                        setSizeExpanded(
                                                          !sizeExpanded,
                                                        )
                                                      }
                                                    >
                                                      <Iconmoon
                                                        icon={
                                                          sizeExpanded
                                                            ? "contract_arrow"
                                                            : "expand_arrow"
                                                        }
                                                        size={14}
                                                        color="#EA4E2C"
                                                      />
                                                    </Button>
                                                  )}
                                                </span>
                                              }
                                              key="4"
                                              // disabled={jobCardDetailsList[jobIndex]?.solution2.exception}
                                            >
                                              <TableLayoutData>
                                                <div
                                                  className="tableDataFormat"
                                                  style={{ marginTop: "25px" }}
                                                >
                                                  {isFetchingData ? (
                                                    <TableShimmer
                                                      header={
                                                        unfulfilledColumnsHead
                                                      }
                                                      scroll={1300}
                                                    />
                                                  ) : (
                                                    <Table
                                                      columns={
                                                        unfulfilledColumnsHead
                                                      }
                                                      dataSource={
                                                        job
                                                          .newlyCreatedJobCardsDetails[0]
                                                          ?.jobcard?.solution_1
                                                          .data.exception
                                                          ? failedJobOrders
                                                          : stockSizeDetailsList2?.filter(
                                                              (order) =>
                                                                order.unFulflilledReels >
                                                                  0 &&
                                                                order.type ==
                                                                  "Order",
                                                            )
                                                      }
                                                      onChange={(pagination) =>
                                                        onChange(
                                                          pagination,
                                                          true,
                                                        )
                                                      }
                                                      scroll={{ x: 1800 }}
                                                      rowClassName={(record) =>
                                                        record.priority &&
                                                        "true"
                                                      }
                                                      pagination={{
                                                        current: currentPage,
                                                        pageSize: pageSize,
                                                        total:
                                                          totalUnfulfilledOrders,
                                                        onChange:
                                                          onPaginationChange,
                                                        showSizeChanger: true,
                                                        showQuickJumper: true,
                                                        // showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                                                      }}
                                                    />
                                                  )}
                                                </div>
                                              </TableLayoutData>
                                            </Panes> */}
                                            <Panes
                                              tab={
                                                <span>
                                                  Intermediate Reels
                                                  {activeTab == "5" && (
                                                    <Button
                                                      key="1"
                                                      style={{ border: "none" }}
                                                      onClick={(e) =>
                                                        setSizeExpanded(
                                                          !sizeExpanded,
                                                        )
                                                      }
                                                    >
                                                      <Iconmoon
                                                        icon={
                                                          sizeExpanded
                                                            ? "contract_arrow"
                                                            : "expand_arrow"
                                                        }
                                                        size={14}
                                                        color="#EA4E2C"
                                                      />
                                                    </Button>
                                                  )}
                                                </span>
                                              }
                                              key="5"
                                              // disabled={solutionSummary?.solution1.exception}
                                            >
                                              <TableLayoutData>
                                                <div
                                                  className="tableDataFormat"
                                                  style={{ marginTop: "25px" }}
                                                >
                                                  <Table
                                                    columns={
                                                      intermediateColumnsHead
                                                    }
                                                    dataSource={
                                                      intermediateNewSolutionData2
                                                    }
                                                    onChange={(
                                                      pagination,
                                                    ) => {}}
                                                    scroll={{ x: 1200 }}
                                                    rowClassName={(record) =>
                                                      record.priority && "true"
                                                    }
                                                  />
                                                </div>
                                              </TableLayoutData>
                                            </Panes>
                                          </Tabs>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Panes>
                                )}
                            </Tabs>
                          )}
                        </>
                      )}
                    </TabPane>
                  ))}

                {failedJobs &&
                  failedJobs?.map((failedJob, index) => (
                    <TabPane
                      key={failedJob.id}
                      tab={
                        <div className="deckleMatchIcon disabled">
                          <img src={failedIco} />
                          {"JC " +
                            (jobCardDetailsList?.length + index + 1) +
                            "(failed)"}
                        </div>
                      }
                      style={{ backgroundColor: "white" }}
                    >
                      {/* <Panes tab="Solution 1" key="1"> */}
                      <PageTitleComp style={{ borderBottom: "0" }}>
                        <PageHeader ghost={false} title="Job Card"></PageHeader>
                      </PageTitleComp>
                      <div className="MatchResult">
                        <Row span={24} className="pipeBlockCylinder">
                          {((!sizeExpanded && activeTab == "2") ||
                            (!sizeExpanded && activeTab == "3") ||
                            (!sizeExpanded && activeTab == "4") ||
                            (!sizeExpanded && activeTab == "5") ||
                            activeTab == "1") && (
                            <Col
                              span={15}
                              className="pipeBlock"
                              style={{ paddingRight: "20px" }}
                            >
                              <RightSideSolution>
                                <div className="deckleCoverImage">
                                  <img
                                    src={deckleCover}
                                    alt="deckle match result"
                                  />
                                </div>
                              </RightSideSolution>
                            </Col>
                          )}
                          <Col
                            span={
                              ((sizeExpanded && activeTab == "2") ||
                                (sizeExpanded && activeTab == "3") ||
                                (sizeExpanded && activeTab == "4") ||
                                (sizeExpanded && activeTab == "5")) &&
                              activeTab != "1"
                                ? 24
                                : 9
                            }
                            className="colLayoutBlock"
                          >
                            <Tabs
                              defaultActiveKey={activeTab}
                              activeKey={activeTab}
                              className="topPostTab innerPostTab"
                              onChange={tabChange}
                            >
                              <Panes
                                tab="Summary"
                                key="1"
                                // disabled={solutionSummary?.solution1.exception}
                              >
                                <div className="lossValue">
                                  <Row span={24}>
                                    <Col span={12}>
                                      <ul>
                                        <li>
                                          <span>Paper Machine</span>
                                          <p>
                                            {
                                              failedJob.group.machines[0]
                                                .machine_id
                                            }
                                          </p>
                                        </li>
                                        <li>
                                          <li>
                                            <span>Ply</span>
                                            <p>{failedJob.ply}</p>
                                          </li>
                                          <span>
                                            Edge Trim ( Left / Right )
                                          </span>
                                          <p>{`${
                                            failedJob.group.machines[0]
                                              .left_edge_trim
                                          } ${lengthUnit[
                                            failedJob.group.machines[0].units
                                              ?.left_edge_trim
                                          ]?.displayName.toUpperCase()} / ${
                                            failedJob.group.machines[0]
                                              .right_edge_trim
                                          } ${lengthUnit[
                                            failedJob.group.machines[0].units
                                              ?.right_edge_trim
                                          ]?.displayName.toUpperCase()}`}</p>
                                        </li>
                                        <li>
                                          <span>Product Specifications</span>
                                          <p style={{ wordWrap: "break-word" }}>
                                            {
                                              failedJob.group.product
                                                .product_spec
                                            }
                                          </p>
                                        </li>
                                        <li>
                                          <span>Number of Fulfilled Reels</span>
                                          <p>0</p>
                                        </li>
                                      </ul>
                                    </Col>
                                    <Col span={12}>
                                      <ul>
                                        <li>
                                          <span>Deckle Width</span>
                                          <p>
                                            {`${(
                                              failedJob?.group.machines[0]
                                                .deckle_size_ub +
                                              (failedJob?.group.machines[0]
                                                .left_edge_trim +
                                                failedJob?.group.machines[0]
                                                  .right_edge_trim) *
                                                CoversionFactorUnitsToCM[
                                                  failedJob?.group.machines[0]
                                                    .units?.right_edge_trim
                                                ] *
                                                CoversionFactorCMToUnits[
                                                  failedJob?.group.machines[0]
                                                    .units?.deckle_size_ub
                                                ]
                                            )?.toFixed(
                                              3,
                                            )} - ${failedJob.group.machines[0].deckle_size_lb?.toFixed(
                                              3,
                                            )} ${lengthUnit[
                                              failedJob.group.machines[0].units
                                                ?.deckle_size_ub
                                            ]?.displayName.toUpperCase()}`}
                                          </p>
                                        </li>
                                        {/* <li>
                                        <span>Core ID / Reel OD</span>
                                        <p>{`${
                                          failedJob.group.grouping_params
                                            .core_id
                                        }  ${lengthUnit[
                                          failedJob.group.grouping_params.units
                                            ?.core_id
                                        ]?.displayName.toUpperCase()}/ ${
                                          failedJob.group.grouping_params
                                            .reel_od
                                        } ${lengthUnit[
                                          failedJob.group.grouping_params.units
                                            ?.reel_od
                                        ]?.displayName.toUpperCase()}`}</p>
                                      </li> */}
                                        <li>
                                          <span>Total Number of Sets</span>
                                          <p>0</p>
                                        </li>
                                        <li>
                                          <span>Priority Quantity</span>
                                          <p>0 T</p>
                                        </li>
                                      </ul>
                                    </Col>
                                  </Row>
                                </div>
                              </Panes>
                              {/* <Panes
                                tab={
                                  <span>
                                    Unfulfilled Orders
                                    {activeTab == "4" && (
                                      <Button
                                        key="1"
                                        style={{ border: "none" }}
                                        onClick={(e) =>
                                          setSizeExpanded(!sizeExpanded)
                                        }
                                      >
                                        <Iconmoon
                                          icon={
                                            sizeExpanded
                                              ? "contract_arrow"
                                              : "expand_arrow"
                                          }
                                          size={14}
                                          color="#EA4E2C"
                                        />
                                      </Button>
                                    )}
                                  </span>
                                }
                                key="4"
                                // disabled={jobCardDetailsList[jobIndex]?.solution2.exception}
                              >
                                <TableLayoutData>
                                  <div
                                    className="tableDataFormat"
                                    style={{ marginTop: "25px" }}
                                  >
                                    {isFetchingData ? (
                                      <TableShimmer
                                        header={unfulfilledColumnsHead}
                                        scroll={1300}
                                      />
                                    ) : (
                                      <Table
                                        columns={unfulfilledColumnsHead}
                                        dataSource={failedJobOrders}
                                        onChange={(pagination) =>
                                          onChange(pagination, true)
                                        }
                                        scroll={{ x: 1800 }}
                                        rowClassName={(record) =>
                                          record.priority && "true"
                                        }
                                        pagination={{
                                          current: currentPage,
                                          pageSize: pageSize,
                                          total: totalUnfulfilledOrders,
                                          onChange: onPaginationChange,
                                          showSizeChanger: true,
                                          showQuickJumper: true,
                                          // showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                                        }}
                                      />
                                    )}
                                  </div>
                                </TableLayoutData>
                              </Panes> */}
                            </Tabs>
                          </Col>
                        </Row>
                      </div>
                      {/* </Panes> */}
                    </TabPane>
                  ))}
              </Tabs>
            )}
          </DetailFields>
        </ResultWrap1>

        {/* Accept Modal */}
        <ModalPopup visible={isAcceptModal}>
          <div className="Popup-img">
            <img src={warning} alt="Warning" />
          </div>
          <div className="Popup-content">
            <span>Send for approval?</span>
            <p>
              You are about to remove this order group, are you sure you want to
              continue?
            </p>
          </div>
          <div className="ant-modal-footer-section">
            <Button
              key="back"
              className="themeBtn-plane"
              onClick={() => acceptModalClose()}
              // disabled={solutionSummary?.solution2.exception}
            >
              <div className="plusPopUpBorder">
                <Iconmoon
                  icon="plus-sign"
                  size={9}
                  color="#EA655B"
                  className="ant-ico-sec"
                />
              </div>
              Cancel
            </Button>

            <Button
              key="submit"
              className="themeBtn"
              onClick={() => acceptModalConfirm()}
              // disabled={solutionSummary?.solution2.exception}
            >
              <Iconmoon icon="tick-mark" size={14} color="#ffff" />
              Confirm
            </Button>
          </div>
        </ModalPopup>

        {/* Discard Modal */}
        <ModalPopup visible={isDiscardModal}>
          <div className="Popup-img">
            <img src={warning} alt="Warning" />
          </div>
          <div className="Popup-content">
            <span>Discard the solution?</span>
            <p>
              You are about to discard this order group, are you sure you want
              to continue?
            </p>
          </div>
          <div className="ant-modal-footer-section">
            <Button
              key="back"
              className="themeBtn-plane"
              onClick={() => discardModalClose()}
            >
              <div className="plusPopUpBorder">
                <Iconmoon
                  icon="plus-sign"
                  size={9}
                  color="#EA655B"
                  className="ant-ico-sec"
                />
              </div>
              Cancel
            </Button>

            <Button
              key="submit"
              className="themeBtn"
              onClick={() => discardModalConfirm()}
            >
              <Iconmoon icon="tick-mark" size={14} color="#ffff" />
              Confirm
            </Button>
          </div>
        </ModalPopup>

        <ViewDeckleOrder
          selectedOrderNo={selectedOrderNo}
          // showButton={true}
          visible={viewOrder}
          onClose={closeViewDrawer}
          onCloseGrade={closeViewDrawer}
          category={selectedOrder?.category}
        />
        {visibleToaster && actionToaster.error && (
          <AlertContainer
            color="red toaster"
            icon={alertRed}
            msg={actionToaster.msg}
          />
        )}
        {visibleToaster && !actionToaster.error && (
          <AlertContainer
            color="green toaster"
            icon={alertGreen}
            msg={actionToaster.msg}
          />
        )}
      </RightLayoutContainer>
    )
  ) : (
    <RightLayoutContainer>
      <PageTitleComp style={{ borderBottom: "0" }}>
        <PageHeader
          ghost={false}
          title="Preparing Job Card"
          extra={[
            <Button
              key="1"
              className="textTypeBtn textBtnIcon"
              onClick={() => {
                history("../job-cards");
              }}
            >
              {" "}
              <Iconmoon
                icon="wrong"
                size={14}
                color="#EA4E2C"
                style={{ marginRight: "8px", top: "1px", position: "relative" }}
              />{" "}
              Cancel Job Card
            </Button>,
            <Button
              key="1"
              className="themeBtn noBg noMargin"
              onClick={routeChange}
            >
              Go Back
            </Button>,
          ]}
        ></PageHeader>
      </PageTitleComp>
      <ContentMiddle>
        <div className="imageAnimate">
          <div className="imageCover">
            <LottieAnimation lotti={JobcardPrepare} />
            <p>
              Our algorithms are cooking a job card for you <br />
              please wait, it will take less than a minute
            </p>
          </div>
        </div>
      </ContentMiddle>
    </RightLayoutContainer>
  );
};
export default DeckleResultsData;
